var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var DocumentEditorPreviewUi = (function () {
                        function DocumentEditorPreviewUi($container) {
                            var _this = this;
                            this.startSpinner = function () { return undefined; };
                            this.stopSpinner = function () {
                                if (_this.onLoadCallback) {
                                    _this.onLoadCallback();
                                }
                            };
                            this.appendFrame = function (viewUrl, onFrameLoaded) {
                                var $iframe = $("<iframe id=\"view-document\" src=\"" + viewUrl + "\"></iframe>").on('load', onFrameLoaded);
                                _this.$container.append($iframe);
                            };
                            this.$container = $container;
                        }
                        DocumentEditorPreviewUi.prototype.onLoad = function (onLoadCallback) {
                            this.onLoadCallback = onLoadCallback;
                        };
                        return DocumentEditorPreviewUi;
                    }());
                    var DefaultDocumentEditorPlugin = (function () {
                        function DefaultDocumentEditorPlugin(documentEditorSelector, options) {
                            var _this = this;
                            this.setStatus = function (status) { return undefined; };
                            this.viewFile = function () {
                                var ui = new DocumentEditorPreviewUi($(_this.documentEditorSelector + ' .view-document-content'));
                                ui.onLoad(function () {
                                    if (_this.onReadyCallback) {
                                        _this.onReadyCallback(_this.viewModel);
                                    }
                                });
                                MatrixDocs.loadPreview(new MatrixDocs.PreviewApi(), ui, _this.viewModel.pdfUrl(), _this.viewModel.isPdfAvailableUrl(), _this.viewModel.requestPdfConversionUrl());
                            };
                            this.documentEditorSelector = documentEditorSelector;
                        }
                        DefaultDocumentEditorPlugin.prototype.open = function (viewModel) {
                            this.viewModel = viewModel;
                            this.setContent();
                            this.viewFile();
                        };
                        DefaultDocumentEditorPlugin.prototype.update = function (viewModel) {
                            this.viewModel.isEditable(viewModel.isEditable());
                            this.viewModel.canOpenInEditor(viewModel.canOpenInEditor());
                        };
                        DefaultDocumentEditorPlugin.prototype.onReady = function (callback) {
                            this.onReadyCallback = callback;
                        };
                        DefaultDocumentEditorPlugin.prototype.setContent = function () {
                            $(this.documentEditorSelector)
                                .html($("#default-plugin-content").html())
                                .removeClass();
                            ko.applyBindings(this.viewModel, $(this.documentEditorSelector + ' .view-document-toolbar')[0]);
                        };
                        return DefaultDocumentEditorPlugin;
                    }());
                    DocumentEditor.DefaultDocumentEditorPlugin = DefaultDocumentEditorPlugin;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor_1) {
                    var DocumentEditorPluginStatusType;
                    (function (DocumentEditorPluginStatusType) {
                        DocumentEditorPluginStatusType[DocumentEditorPluginStatusType["Normal"] = 0] = "Normal";
                        DocumentEditorPluginStatusType[DocumentEditorPluginStatusType["Success"] = 1] = "Success";
                        DocumentEditorPluginStatusType[DocumentEditorPluginStatusType["Error"] = 2] = "Error";
                    })(DocumentEditorPluginStatusType = DocumentEditor_1.DocumentEditorPluginStatusType || (DocumentEditor_1.DocumentEditorPluginStatusType = {}));
                    function isRedactionPlugin(plugin) {
                        return plugin.supportsRedactions === true;
                    }
                    var DocumentEditor = (function () {
                        function DocumentEditor(idSelector, viewModel) {
                            this.idSelector = idSelector;
                            this.viewModel = viewModel;
                        }
                        DocumentEditor.prototype.viewVersion = function (documentVersionVm, options) {
                            var newPlugin = documentVersionVm.isFileMissing()
                                ? new DocumentEditor_1.MissingFileDocumentEditorPlugin(this.idSelector, options)
                                : documentVersionVm.isPdfConvertable()
                                    ? new DocumentEditor_1.DefaultDocumentEditorPlugin(this.idSelector, options)
                                    : new DocumentEditor_1.MediaDocumentEditorPlugin(this.idSelector, options);
                            return this.view(documentVersionVm, newPlugin);
                        };
                        DocumentEditor.prototype.viewOcrVersion = function (documentOcrVersionVm, options) {
                            var newPlugin = new DocumentEditor_1.DefaultDocumentEditorPlugin(this.idSelector, options);
                            return this.view(documentOcrVersionVm, newPlugin);
                        };
                        DocumentEditor.prototype.viewRedaction = function (redactionVm, options) {
                            var newPlugin = redactionVm.status() === Pbs.Documents.SpryUI.ViewModels.DocumentEditor.Redactions.RedactionStatus.Final
                                ? new DocumentEditor_1.DefaultDocumentEditorPlugin(this.idSelector, options)
                                : new DocumentEditor_1.PrizmDocDocumentEditorPlugin(this.idSelector, options);
                            return this.view(redactionVm, newPlugin);
                        };
                        DocumentEditor.prototype.view = function (viewModel, newPlugin) {
                            if (this.plugin) {
                                delete this.plugin;
                            }
                            this.plugin = newPlugin;
                            this.plugin.onReady(this.onPluginReady);
                            if (isRedactionPlugin(this.plugin)) {
                                this.plugin.onRedactionMarkCreated(this.onPluginRedactionMarkCreated);
                                this.plugin.onRedactionMarkEdited(this.onPluginRedactionMarkEdited);
                                this.plugin.onRedactionMarkDeleted(this.onPluginRedactionMarkDeleted);
                                this.plugin.onRedactionClosed(this.onPluginRedactionClosed);
                                this.plugin.onRedactionSaved(this.onPluginRedactionSaved);
                                this.plugin.onRedactionCopied(this.onPluginRedactionCopied);
                            }
                            this.plugin.open(viewModel);
                        };
                        return DocumentEditor;
                    }());
                    DocumentEditor_1.DocumentEditor = DocumentEditor;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var DocumentSourceVm = (function () {
                        function DocumentSourceVm(data) {
                            this.displayName = ko.observable(data.displayName);
                            this.url = ko.observable(data.url);
                        }
                        DocumentSourceVm.prototype.update = function (data) {
                            this.displayName(data.displayName);
                            this.url(data.url);
                        };
                        return DocumentSourceVm;
                    }());
                    DocumentEditor.DocumentSourceVm = DocumentSourceVm;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentPermissionLinkVm = (function () {
                    function DocumentPermissionLinkVm(data) {
                        this.url = ko.observable(data.url);
                        this.canPerformAction = ko.observable(data.canPerformAction);
                        this.cannotPerformMessage = ko.observable(data.cannotPerformMessage);
                    }
                    DocumentPermissionLinkVm.prototype.update = function (data) {
                        this.url(data.url);
                        this.canPerformAction(data.canPerformAction);
                        this.cannotPerformMessage(data.cannotPerformMessage);
                    };
                    return DocumentPermissionLinkVm;
                }());
                ViewModels.DocumentPermissionLinkVm = DocumentPermissionLinkVm;
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var DocumentReferenceVm = (function () {
                        function DocumentReferenceVm(data) {
                            this.displayName = ko.observable(data.displayName);
                            this.url = ko.observable(data.url);
                        }
                        DocumentReferenceVm.prototype.update = function (data) {
                            this.displayName(data.displayName);
                            this.url(data.url);
                        };
                        return DocumentReferenceVm;
                    }());
                    DocumentEditor.DocumentReferenceVm = DocumentReferenceVm;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var FileInfo;
                    (function (FileInfo) {
                        var FileInfoImportedPropertiesVm = (function () {
                            function FileInfoImportedPropertiesVm(data) {
                                this.filename = ko.observable(data.filename);
                                this.folderPath = ko.observable(data.folderPath);
                                this.createdOn = ko.observable(data.createdOn);
                                this.modifiedOn = ko.observable(data.modifiedOn);
                            }
                            FileInfoImportedPropertiesVm.prototype.update = function (data) {
                                this.filename(data.filename);
                                this.folderPath(data.folderPath);
                                this.createdOn(data.createdOn);
                                this.modifiedOn(data.modifiedOn);
                            };
                            return FileInfoImportedPropertiesVm;
                        }());
                        FileInfo.FileInfoImportedPropertiesVm = FileInfoImportedPropertiesVm;
                    })(FileInfo = DocumentEditor.FileInfo || (DocumentEditor.FileInfo = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var FileInfo;
                    (function (FileInfo) {
                        var FileInfoVm = (function () {
                            function FileInfoVm(data) {
                                var _this = this;
                                this.onToggleMatrixProperties = function () {
                                    _this.isMatrixPropertiesExpanded(!_this.isMatrixPropertiesExpanded());
                                };
                                this.onToggleImportedProperties = function () {
                                    _this.isImportedPropertiesExpanded(!_this.isImportedPropertiesExpanded());
                                };
                                this.name = ko.observable(data.name);
                                this.formattedType = ko.observable(data.formattedType);
                                this.description = ko.observable(data.description);
                                this.index = ko.observable(data.index);
                                this.formattedModification = ko.observable(data.formattedModification);
                                this.formattedCreation = ko.observable(data.formattedCreation);
                                this.formattedSize = ko.observable(data.formattedSize);
                                this.activityFrom = ko.observable(data.activityFrom);
                                this.activityThru = ko.observable(data.activityThru);
                                this.sources = ko.observableArray(data.sources
                                    ? data.sources.map(function (i) { return i ? new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.DocumentSourceVm(i) : null; })
                                    : []);
                                this.editPermissionLink = data.editPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.editPermissionLink) : null;
                                this.refreshUrl = ko.observable(data.refreshUrl);
                                this.references = ko.observableArray(data.references
                                    ? data.references.map(function (d) { return d ? new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.DocumentReferenceVm(d) : null; })
                                    : []);
                                this.hasImportedProperties = ko.observable(data.hasImportedProperties);
                                this.importedProperties = data.importedProperties ? new FileInfo.FileInfoImportedPropertiesVm(data.importedProperties) : null;
                                this.isMatrixPropertiesExpanded = ko.observable(true);
                                this.isImportedPropertiesExpanded = ko.observable(true);
                                this.hasReferences = ko.pureComputed(function () { return _this.references().length > 0; });
                                this.hasSources = ko.pureComputed(function () { return _this.sources().length > 0; });
                            }
                            FileInfoVm.prototype.update = function (data) {
                                this.name(data.name);
                                this.formattedType(data.formattedType);
                                this.description(data.description);
                                this.index(data.index);
                                this.formattedModification(data.formattedModification);
                                this.formattedCreation(data.formattedCreation);
                                this.formattedSize(data.formattedSize);
                                this.activityFrom(data.activityFrom);
                                this.activityThru(data.activityThru);
                                this.sources(data.sources
                                    ? data.sources.map(function (i) { return i ? new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.DocumentSourceVm(i) : null; })
                                    : []);
                                if (this.editPermissionLink && data.editPermissionLink) {
                                    this.editPermissionLink.update(data.editPermissionLink);
                                }
                                else {
                                    this.editPermissionLink = data.editPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.editPermissionLink) : null;
                                }
                                ;
                                this.refreshUrl(data.refreshUrl);
                                this.references(data.references
                                    ? data.references.map(function (d) { return d ? new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.DocumentReferenceVm(d) : null; })
                                    : []);
                                this.hasImportedProperties(data.hasImportedProperties);
                                if (this.importedProperties && data.importedProperties) {
                                    this.importedProperties.update(data.importedProperties);
                                }
                                else {
                                    this.importedProperties = data.importedProperties ? new FileInfo.FileInfoImportedPropertiesVm(data.importedProperties) : null;
                                }
                                ;
                            };
                            return FileInfoVm;
                        }());
                        FileInfo.FileInfoVm = FileInfoVm;
                    })(FileInfo = DocumentEditor.FileInfo || (DocumentEditor.FileInfo = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Versions;
                    (function (Versions) {
                        var DocumentOcrVersionVm = (function () {
                            function DocumentOcrVersionVm(data, documentVersion) {
                                var _this = this;
                                this.onView = function (e) {
                                };
                                this.onDownload = function (e) {
                                };
                                this.onOpenInEditor = function () {
                                };
                                this.documentVersionId = ko.observable(data.documentVersionId);
                                this.isPdfConvertable = ko.observable(data.isPdfConvertable);
                                this.pdfUrl = ko.observable(data.pdfUrl);
                                this.isPdfAvailableUrl = ko.observable(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl = ko.observable(data.requestPdfConversionUrl);
                                this.isEditable = ko.observable(data.isEditable);
                                this.canOpenInEditor = ko.observable(data.canOpenInEditor);
                                this.openInEditorTooltip = ko.observable(data.openInEditorTooltip);
                                this.viewingState = ko.observable(data.viewingState);
                                this.viewPermissionLink = data.viewPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink) : null;
                                this.downloadPermissionLink = data.downloadPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink) : null;
                                this.viewingAlert = ko.pureComputed(function () { return true; });
                                this.viewingSummary = ko.pureComputed(function () {
                                    return "Viewing searchable version " + documentVersion.formattedTimestamp();
                                });
                                this.isViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.Viewing; });
                                this.isNotViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.NotViewing; });
                                this.isRequestingView = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.RequestingView; });
                                this.isSuitableForRelease = ko.observable(false);
                                this.isFileMissing = ko.observable(data.isFileMissing);
                            }
                            DocumentOcrVersionVm.prototype.update = function (data) {
                                this.documentVersionId(data.documentVersionId);
                                this.isPdfConvertable(data.isPdfConvertable);
                                this.pdfUrl(data.pdfUrl);
                                this.isPdfAvailableUrl(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl(data.requestPdfConversionUrl);
                                this.isEditable(data.isEditable);
                                this.canOpenInEditor(data.canOpenInEditor);
                                this.openInEditorTooltip(data.openInEditorTooltip);
                                this.viewingState(data.viewingState);
                                if (this.viewPermissionLink && data.viewPermissionLink) {
                                    this.viewPermissionLink.update(data.viewPermissionLink);
                                }
                                else {
                                    this.viewPermissionLink = data.viewPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.downloadPermissionLink && data.downloadPermissionLink) {
                                    this.downloadPermissionLink.update(data.downloadPermissionLink);
                                }
                                else {
                                    this.downloadPermissionLink = data.downloadPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink)
                                        : null;
                                }
                                ;
                                this.isFileMissing(data.isFileMissing);
                            };
                            return DocumentOcrVersionVm;
                        }());
                        Versions.DocumentOcrVersionVm = DocumentOcrVersionVm;
                    })(Versions = DocumentEditor.Versions || (DocumentEditor.Versions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var ViewingState;
                    (function (ViewingState) {
                        ViewingState["NotViewing"] = "NotViewing";
                        ViewingState["RequestingView"] = "RequestingView";
                        ViewingState["Viewing"] = "Viewing";
                    })(ViewingState = DocumentEditor.ViewingState || (DocumentEditor.ViewingState = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Versions;
                    (function (Versions) {
                        var DocumentVersionVm = (function () {
                            function DocumentVersionVm(data) {
                                var _this = this;
                                this.onView = function (vm, e) {
                                };
                                this.onDownload = function (e) {
                                };
                                this.onOpenInEditor = function () {
                                };
                                this.onEdit = function (contextMenuItem, e) {
                                };
                                this.onRestore = function (e) {
                                };
                                this.onContextMenu = function (vm, e) {
                                    Pb.Grid.toggleDropMenuFromIndicator.call($(e.target));
                                };
                                this.documentId = ko.observable(data.documentId);
                                this.documentVersionId = ko.observable(data.documentVersionId);
                                this.isCurrentVersion = ko.observable(data.isCurrentVersion);
                                this.addedBy = ko.observable(data.addedBy);
                                this.extension = ko.observable(data.extension);
                                this.size = ko.observable(data.size);
                                this.comments = ko.observable(data.comments);
                                this.fileExtensionClassName = ko.observable(data.fileExtensionClassName);
                                this.isPdfConvertable = ko.observable(data.isPdfConvertable);
                                this.formattedTimestamp = ko.observable(data.formattedTimestamp);
                                this.isSearchable = ko.observable(data.isSearchable);
                                this.ocrVersion = data.ocrVersion ? new Versions.DocumentOcrVersionVm(data.ocrVersion, this) : null;
                                this.mimeType = ko.observable(data.mimeType);
                                this.isAudio = ko.observable(data.isAudio);
                                this.isVideo = ko.observable(data.isVideo);
                                this.isStreamingMedia = ko.observable(data.isStreamingMedia);
                                this.isEmail = ko.observable(data.isEmail);
                                this.supportedAudioStreamingFormats = ko.observable(data.supportedAudioStreamingFormats);
                                this.supportedVideoStreamingFormats = ko.observable(data.supportedVideoStreamingFormats);
                                this.downloadPermissionLink = data.downloadPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink) : null;
                                this.restorePermissionLink = data.restorePermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.restorePermissionLink) : null;
                                this.viewPermissionLink = data.viewPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink) : null;
                                this.editUrl = ko.observable(data.editUrl);
                                this.pdfUrl = ko.observable(data.pdfUrl);
                                this.isPdfAvailableUrl = ko.observable(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl = ko.observable(data.requestPdfConversionUrl);
                                this.isEditable = ko.observable(data.isEditable);
                                this.canOpenInEditor = ko.observable(data.canOpenInEditor);
                                this.openInEditorTooltip = ko.observable(data.openInEditorTooltip);
                                this.viewingState = ko.observable(data.viewingState);
                                this.contextMenuItems = ko.observableArray(data.contextMenuItems
                                    ? data.contextMenuItems.map(function (k) { return k ? new Pbs.Spry.ViewModels.KoContextMenuLinkItem(k) : null; })
                                    : []);
                                this.contextMenu = new Pb.ContextMenuVm({
                                    items: this.contextMenuItems(),
                                    context: this
                                });
                                this.canRestore = ko.computed(function () {
                                    return !_this.isCurrentVersion() && _this.restorePermissionLink.canPerformAction();
                                });
                                this.viewingSummary = ko.pureComputed(function () {
                                    return _this.isCurrentVersion()
                                        ? "Viewing latest version " + _this.formattedTimestamp()
                                        : "Viewing prior version " + _this.formattedTimestamp();
                                });
                                this.viewingAlert = ko.pureComputed(function () { return !_this.isCurrentVersion(); });
                                this.isViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.Viewing; });
                                this.isNotViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.NotViewing; });
                                this.isRequestingView = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.RequestingView; });
                                this.isSuitableForRelease = ko.observable(data.isSuitableForRelease);
                                this.isFileMissing = ko.observable(data.isFileMissing);
                            }
                            DocumentVersionVm.prototype.update = function (data) {
                                this.documentId(data.documentId);
                                this.documentVersionId(data.documentVersionId);
                                this.isCurrentVersion(data.isCurrentVersion);
                                this.addedBy(data.addedBy);
                                this.extension(data.extension);
                                this.size(data.size);
                                this.comments(data.comments);
                                this.fileExtensionClassName(data.fileExtensionClassName);
                                this.isPdfConvertable(data.isPdfConvertable);
                                this.formattedTimestamp(data.formattedTimestamp);
                                this.isSearchable(data.isSearchable);
                                if (this.ocrVersion && data.ocrVersion) {
                                    this.ocrVersion.update(data.ocrVersion);
                                }
                                else {
                                    this.ocrVersion = data.ocrVersion ? new Versions.DocumentOcrVersionVm(data.ocrVersion, this) : null;
                                }
                                ;
                                this.mimeType(data.mimeType);
                                this.isAudio(data.isAudio);
                                this.isVideo(data.isVideo);
                                this.isStreamingMedia(data.isStreamingMedia);
                                this.isEmail(data.isEmail);
                                this.supportedAudioStreamingFormats(data.supportedAudioStreamingFormats);
                                this.supportedVideoStreamingFormats(data.supportedVideoStreamingFormats);
                                if (this.downloadPermissionLink && data.downloadPermissionLink) {
                                    this.downloadPermissionLink.update(data.downloadPermissionLink);
                                }
                                else {
                                    this.downloadPermissionLink = data.downloadPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.restorePermissionLink && data.restorePermissionLink) {
                                    this.restorePermissionLink.update(data.restorePermissionLink);
                                }
                                else {
                                    this.restorePermissionLink = data.restorePermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.restorePermissionLink)
                                        : null;
                                }
                                ;
                                if (this.viewPermissionLink && data.viewPermissionLink) {
                                    this.viewPermissionLink.update(data.viewPermissionLink);
                                }
                                else {
                                    this.viewPermissionLink = data.viewPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink)
                                        : null;
                                }
                                ;
                                this.editUrl(data.editUrl);
                                this.pdfUrl(data.pdfUrl);
                                this.isPdfAvailableUrl(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl(data.requestPdfConversionUrl);
                                this.isEditable(data.isEditable);
                                this.canOpenInEditor(data.canOpenInEditor);
                                this.openInEditorTooltip(data.openInEditorTooltip);
                                this.viewingState(data.viewingState);
                                this.contextMenuItems(data.contextMenuItems
                                    ? data.contextMenuItems.map(function (k) { return k ? new Pbs.Spry.ViewModels.KoContextMenuLinkItem(k) : null; })
                                    : []);
                                this.isSuitableForRelease(data.isSuitableForRelease);
                                this.isFileMissing(data.isFileMissing);
                            };
                            return DocumentVersionVm;
                        }());
                        Versions.DocumentVersionVm = DocumentVersionVm;
                    })(Versions = DocumentEditor.Versions || (DocumentEditor.Versions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Versions;
                    (function (Versions) {
                        var VersionsVm = (function () {
                            function VersionsVm(data, options) {
                                var _this = this;
                                this.update = function (data) {
                                    _this.versions(data.versions
                                        ? data.versions.map(function (i) { return i ? _this.versionVmFactory(i) : null; })
                                        : []);
                                    if (_this.newPermissionLink && data.newPermissionLink) {
                                        _this.newPermissionLink.update(data.newPermissionLink);
                                    }
                                    else {
                                        _this.newPermissionLink = data.newPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink) : null;
                                    }
                                    ;
                                    _this.refreshUrl(data.refreshUrl);
                                };
                                var actual = Object.assign({}, {
                                    versionVmFactory: function (dto) { return new Versions.DocumentVersionVm(dto); }
                                }, options);
                                this.versionVmFactory = actual.versionVmFactory;
                                this.versions = ko.observableArray(data.versions
                                    ? data.versions.map(function (i) { return i ? _this.versionVmFactory(i) : null; })
                                    : []);
                                this.newPermissionLink = data.newPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink) : null;
                                this.refreshUrl = ko.observable(data.refreshUrl);
                                this.numVersions = ko.computed(function () { return _this.versions().length; });
                            }
                            Object.defineProperty(VersionsVm.prototype, "currentVersion", {
                                get: function () {
                                    return this.versions().find(function (v) { return v.isCurrentVersion(); });
                                },
                                enumerable: true,
                                configurable: true
                            });
                            return VersionsVm;
                        }());
                        Versions.VersionsVm = VersionsVm;
                    })(Versions = DocumentEditor.Versions || (DocumentEditor.Versions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Redactions;
                    (function (Redactions) {
                        var RedactionMarkVm = (function () {
                            function RedactionMarkVm(data) {
                                this.redactionMarkId = ko.observable(data.redactionMarkId);
                                this.uniqueIdentifier = ko.observable(data.uniqueIdentifier);
                                this.data = ko.observable(data.data);
                            }
                            RedactionMarkVm.prototype.update = function (data) {
                                this.redactionMarkId(data.redactionMarkId);
                                this.uniqueIdentifier(data.uniqueIdentifier);
                                this.data(data.data);
                            };
                            return RedactionMarkVm;
                        }());
                        Redactions.RedactionMarkVm = RedactionMarkVm;
                    })(Redactions = DocumentEditor.Redactions || (DocumentEditor.Redactions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Redactions;
                    (function (Redactions) {
                        var RedactionVm = (function () {
                            function RedactionVm(data) {
                                var _this = this;
                                this.documentVersionId = ko.observable(data.documentVersionId);
                                this.redactionId = ko.observable(data.redactionId);
                                this.status = ko.observable(data.status);
                                this.comments = ko.observable(data.comments);
                                this.reviewState = ko.observable(data.reviewState);
                                this.addedBy = ko.observable(data.addedBy);
                                this.formattedTimestamp = ko.observable(data.formattedTimestamp);
                                this.viewPermissionLink = data.viewPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink) : null;
                                this.downloadPermissionLink = data.downloadPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink) : null;
                                this.deletePermissionLink = data.deletePermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.deletePermissionLink) : null;
                                this.editUrl = ko.observable(data.editUrl);
                                this.updateUrl = ko.observable(data.updateUrl);
                                this.finalizeUrl = ko.observable(data.finalizeUrl);
                                this.finalizeStatusUrl = ko.observable(data.finalizeStatusUrl);
                                this.updateMarksUrl = ko.observable(data.updateMarksUrl);
                                this.createMarkUrl = ko.observable(data.createMarkUrl);
                                this.editMarkUrl = ko.observable(data.editMarkUrl);
                                this.deleteMarkUrl = ko.observable(data.deleteMarkUrl);
                                this.isPdfConvertable = ko.observable(data.isPdfConvertable);
                                this.pdfUrl = ko.observable(data.pdfUrl);
                                this.isPdfAvailableUrl = ko.observable(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl = ko.observable(data.requestPdfConversionUrl);
                                this.isEditable = ko.observable(data.isEditable);
                                this.canOpenInEditor = ko.observable(data.canOpenInEditor);
                                this.openInEditorTooltip = ko.observable(data.openInEditorTooltip);
                                this.viewingState = ko.observable(data.viewingState);
                                this.contextMenuItems = ko.observableArray(data.contextMenuItems
                                    ? data.contextMenuItems.map(function (k) { return k ? new Pbs.Spry.ViewModels.KoContextMenuLinkItem(k) : null; })
                                    : []);
                                this.marks = ko.observableArray(data.marks ? data.marks.map(function (r) { return r ? new Redactions.RedactionMarkVm(r) : null; }) : []);
                                this.contextMenu = new Pb.ContextMenuVm({
                                    items: this.contextMenuItems(),
                                    context: this
                                });
                                this.contextMenuItems()
                                    .filter(function (m) { return m.text() === 'Finalize' || m.text() === 'Copy and Open Redaction'; })
                                    .forEach(function (m) { return m.disabledTooltip = ko.computed(function () {
                                    if (_this.status() === Redactions.RedactionStatus.Final)
                                        return "This redaction is already finalized.";
                                    else if (_this.status() === Redactions.RedactionStatus.Finalizing)
                                        return "This redaction is finalizing.";
                                    else
                                        return null;
                                }); });
                                this.canFinalize = ko.pureComputed(function () { return _this.status() === Redactions.RedactionStatus.Draft; });
                                this.canOpen = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.NotViewing; });
                                this.canCopy = ko.pureComputed(function () { return _this.status() === Redactions.RedactionStatus.Draft; });
                                this.viewingSummary = ko.pureComputed(function () {
                                    return _this.status() === Redactions.RedactionStatus.Final
                                        ? "Viewing final redaction " + _this.formattedTimestamp()
                                        : "Viewing draft redaction " + _this.formattedTimestamp();
                                });
                                this.viewingAlert = ko.pureComputed(function () { return _this.status() !== Redactions.RedactionStatus.Final; });
                                this.isViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.Viewing; });
                                this.isNotViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.NotViewing; });
                                this.isRequestingView = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.RequestingView; });
                                this.iconClass = ko.computed(function () {
                                    return _this.status() === Redactions.RedactionStatus.Draft ? "draft-redaction-icon" : "final-redaction-icon";
                                });
                                this.iconTitle = ko.computed(function () {
                                    return Redactions.RedactionStatus[_this.status()];
                                });
                                this.isSuitableForRelease = ko.observable(data.isSuitableForRelease);
                                this.isNotSuitableForRelease = ko.pureComputed(function () {
                                    return !_this.isSuitableForRelease();
                                });
                                this.isFileMissing = ko.observable(data.isFileMissing);
                            }
                            RedactionVm.prototype.update = function (data) {
                                this.documentVersionId(data.documentVersionId);
                                this.redactionId(data.redactionId);
                                this.status(data.status);
                                this.comments(data.comments);
                                this.reviewState(data.reviewState);
                                this.addedBy(data.addedBy);
                                this.formattedTimestamp(data.formattedTimestamp);
                                if (this.viewPermissionLink && data.viewPermissionLink) {
                                    this.viewPermissionLink.update(data.viewPermissionLink);
                                }
                                else {
                                    this.viewPermissionLink = data.viewPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.downloadPermissionLink && data.downloadPermissionLink) {
                                    this.downloadPermissionLink.update(data.downloadPermissionLink);
                                }
                                else {
                                    this.downloadPermissionLink = data.downloadPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.deletePermissionLink && data.deletePermissionLink) {
                                    this.deletePermissionLink.update(data.deletePermissionLink);
                                }
                                else {
                                    this.deletePermissionLink = data.deletePermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.deletePermissionLink)
                                        : null;
                                }
                                ;
                                this.editUrl(data.editUrl);
                                this.updateUrl(data.updateUrl);
                                this.finalizeUrl(data.finalizeUrl);
                                this.finalizeStatusUrl(data.finalizeStatusUrl);
                                this.updateMarksUrl(data.updateMarksUrl);
                                this.createMarkUrl(data.createMarkUrl);
                                this.editMarkUrl(data.editMarkUrl);
                                this.deleteMarkUrl(data.deleteMarkUrl);
                                this.isPdfConvertable(data.isPdfConvertable);
                                this.pdfUrl(data.pdfUrl);
                                this.isPdfAvailableUrl(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl(data.requestPdfConversionUrl);
                                this.isEditable(data.isEditable);
                                this.canOpenInEditor(data.canOpenInEditor);
                                this.openInEditorTooltip(data.openInEditorTooltip);
                                this.viewingState(data.viewingState);
                                this.contextMenuItems(data.contextMenuItems
                                    ? data.contextMenuItems.map(function (k) { return k ? new Pbs.Spry.ViewModels.KoContextMenuLinkItem(k) : null; })
                                    : []);
                                this.marks(data.marks
                                    ? data.marks.map(function (r) { return r ? new Redactions.RedactionMarkVm(r) : null; })
                                    : []);
                                this.isFileMissing(data.isFileMissing);
                            };
                            return RedactionVm;
                        }());
                        Redactions.RedactionVm = RedactionVm;
                    })(Redactions = DocumentEditor.Redactions || (DocumentEditor.Redactions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Redactions;
                    (function (Redactions) {
                        var RedactionsVm = (function () {
                            function RedactionsVm(data, options) {
                                var _this = this;
                                var actual = Object.assign({}, {
                                    redactionVmFactory: function (dto) { return new Redactions.RedactionVm(dto); }
                                }, options);
                                this.redactionVmFactory = actual.redactionVmFactory;
                                this.redactions = ko.observableArray(data.redactions
                                    ? data.redactions.map(function (i) { return i ? _this.redactionVmFactory(i) : null; })
                                    : []);
                                this.newPermissionLink = data.newPermissionLink
                                    ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink)
                                    : null;
                                this.createUrl = ko.observable(data.createUrl);
                                this.refreshUrl = ko.observable(data.refreshUrl);
                                this.numRedactions = ko.computed(function () { return _this.redactions().length; });
                                this.empty = ko.computed(function () { return _this.redactions().length === 0; });
                            }
                            RedactionsVm.prototype.update = function (data) {
                                var _this = this;
                                this.redactions(data.redactions
                                    ? data.redactions.map(function (i) { return i ? _this.redactionVmFactory(i) : null; })
                                    : []);
                                if (this.newPermissionLink && data.newPermissionLink) {
                                    this.newPermissionLink.update(data.newPermissionLink);
                                }
                                else {
                                    this.newPermissionLink = data.newPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink)
                                        : null;
                                }
                                ;
                                this.createUrl(data.createUrl);
                                this.refreshUrl(data.refreshUrl);
                            };
                            Object.defineProperty(RedactionsVm.prototype, "lastRedaction", {
                                get: function () {
                                    return this.redactions()[0];
                                },
                                enumerable: true,
                                configurable: true
                            });
                            return RedactionsVm;
                        }());
                        Redactions.RedactionsVm = RedactionsVm;
                    })(Redactions = DocumentEditor.Redactions || (DocumentEditor.Redactions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var SignedDocuments;
                    (function (SignedDocuments) {
                        var SignedDocumentVm = (function () {
                            function SignedDocumentVm(data) {
                                var _this = this;
                                this.isNew = ko.observable(data.isNew);
                                this.status = ko.observable(data.status);
                                this.signedDocumentId = ko.observable(data.signedDocumentId);
                                this.comments = ko.observable(data.comments);
                                this.addedBy = ko.observable(data.addedBy);
                                this.formattedTimestamp = ko.observable(data.formattedTimestamp);
                                this.viewPermissionLink = data.viewPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink) : null;
                                this.downloadPermissionLink = data.downloadPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink) : null;
                                this.deletePermissionLink = data.deletePermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.deletePermissionLink) : null;
                                this.finalizePermissionLink = data.finalizePermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.finalizePermissionLink) : null;
                                this.updatePermissionLink = data.updatePermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.updatePermissionLink) : null;
                                this.finalizeStatusUrl = ko.observable(data.finalizeStatusUrl);
                                this.isPdfConvertable = ko.observable(data.isPdfConvertable);
                                this.pdfUrl = ko.observable(data.pdfUrl);
                                this.isPdfAvailableUrl = ko.observable(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl = ko.observable(data.requestPdfConversionUrl);
                                this.isEditable = ko.observable(data.isEditable);
                                this.canOpenInEditor = ko.observable(data.canOpenInEditor);
                                this.viewingState = ko.observable(data.viewingState);
                                this.viewingSummary = ko.pureComputed(function () {
                                    return _this.status() === SignedDocuments.SignedDocumentStatus.Final
                                        ? "Viewing final signed document " + _this.formattedTimestamp()
                                        : "Viewing new signed document " + _this.formattedTimestamp();
                                });
                                this.viewingAlert = ko.pureComputed(function () { return _this.status() !== SignedDocuments.SignedDocumentStatus.Final; });
                                this.isViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.Viewing; });
                                this.isNotViewing = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.NotViewing; });
                                this.isRequestingView = ko.pureComputed(function () { return _this.viewingState() === DocumentEditor.ViewingState.RequestingView; });
                                this.isSuitableForRelease = ko.observable(false);
                                this.isFileMissing = ko.observable(data.isFileMissing);
                            }
                            SignedDocumentVm.prototype.update = function (data) {
                                this.isNew(data.isNew);
                                this.status(data.status);
                                this.signedDocumentId(data.signedDocumentId);
                                this.comments(data.comments);
                                this.addedBy(data.addedBy);
                                this.formattedTimestamp(data.formattedTimestamp);
                                if (this.viewPermissionLink && data.viewPermissionLink) {
                                    this.viewPermissionLink.update(data.viewPermissionLink);
                                }
                                else {
                                    this.viewPermissionLink = data.viewPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.viewPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.downloadPermissionLink && data.downloadPermissionLink) {
                                    this.downloadPermissionLink.update(data.downloadPermissionLink);
                                }
                                else {
                                    this.downloadPermissionLink = data.downloadPermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.downloadPermissionLink)
                                        : null;
                                }
                                ;
                                if (this.deletePermissionLink && data.deletePermissionLink) {
                                    this.deletePermissionLink.update(data.deletePermissionLink);
                                }
                                else {
                                    this.deletePermissionLink = data.deletePermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.deletePermissionLink)
                                        : null;
                                }
                                ;
                                if (this.finalizePermissionLink && data.finalizePermissionLink) {
                                    this.finalizePermissionLink.update(data.finalizePermissionLink);
                                }
                                else {
                                    this.finalizePermissionLink = data.finalizePermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.finalizePermissionLink)
                                        : null;
                                }
                                ;
                                if (this.updatePermissionLink && data.updatePermissionLink) {
                                    this.updatePermissionLink.update(data.updatePermissionLink);
                                }
                                else {
                                    this.updatePermissionLink = data.updatePermissionLink
                                        ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.updatePermissionLink)
                                        : null;
                                }
                                ;
                                this.finalizeStatusUrl(data.finalizeStatusUrl);
                                this.isPdfConvertable(data.isPdfConvertable);
                                this.pdfUrl(data.pdfUrl);
                                this.isPdfAvailableUrl(data.isPdfAvailableUrl);
                                this.requestPdfConversionUrl(data.requestPdfConversionUrl);
                                this.isEditable(data.isEditable);
                                this.canOpenInEditor(data.canOpenInEditor);
                                this.viewingState(data.viewingState);
                                this.isFileMissing(data.isFileMissing);
                            };
                            return SignedDocumentVm;
                        }());
                        SignedDocuments.SignedDocumentVm = SignedDocumentVm;
                    })(SignedDocuments = DocumentEditor.SignedDocuments || (DocumentEditor.SignedDocuments = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var SignedDocuments;
                    (function (SignedDocuments) {
                        var SignedDocumentsVm = (function () {
                            function SignedDocumentsVm(data) {
                                this.signedDocuments = ko.observableArray(data.signedDocuments ? data.signedDocuments.map(function (i) { return i ? new SignedDocuments.SignedDocumentVm(i) : null; }) : []);
                                this.newPermissionLink = data.newPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink) : null;
                                this.refreshUrl = ko.observable(data.refreshUrl);
                                this.getUserSignatureUrl = ko.observable(data.getUserSignatureUrl);
                                this.doesUserHaveSignature = ko.observable(data.doesUserHaveSignature);
                                this.userId = ko.observable(data.userId);
                                this.userName = ko.observable(data.userName);
                            }
                            SignedDocumentsVm.prototype.update = function (data) {
                                this.signedDocuments(data.signedDocuments ? data.signedDocuments.map(function (i) { return i ? new SignedDocuments.SignedDocumentVm(i) : null; }) : []);
                                if (this.newPermissionLink && data.newPermissionLink) {
                                    this.newPermissionLink.update(data.newPermissionLink);
                                }
                                else {
                                    this.newPermissionLink = data.newPermissionLink ? new Pbs.Documents.SpryUI.ViewModels.DocumentPermissionLinkVm(data.newPermissionLink) : null;
                                }
                                ;
                                this.refreshUrl(data.refreshUrl);
                                this.getUserSignatureUrl(data.getUserSignatureUrl);
                                this.doesUserHaveSignature(data.doesUserHaveSignature);
                                this.userId(data.userId);
                                this.userName(data.userName);
                            };
                            return SignedDocumentsVm;
                        }());
                        SignedDocuments.SignedDocumentsVm = SignedDocumentsVm;
                    })(SignedDocuments = DocumentEditor.SignedDocuments || (DocumentEditor.SignedDocuments = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var DocumentEditorVm = (function () {
                        function DocumentEditorVm(data, options) {
                            var _this = this;
                            this.findCurrentlyViewing = function () {
                                if (_this.canViewVersions()) {
                                    var currentVersion = _this.versions.versions().find(function (v) { return v.isViewing() || v.isRequestingView(); });
                                    if (currentVersion) {
                                        return currentVersion;
                                    }
                                    var ocrVersions = _this.versions.versions()
                                        .filter(function (v) { return v.isSearchable(); })
                                        .map(function (v) { return v.ocrVersion; });
                                    var currentOcrVersion = ocrVersions.find(function (o) { return o.isViewing() || o.isRequestingView(); });
                                    if (currentOcrVersion) {
                                        return currentOcrVersion;
                                    }
                                }
                                if (_this.canViewRedactions()) {
                                    var currentRedaction = _this.redactions.redactions().find(function (r) { return r.isViewing() || r.isRequestingView(); });
                                    if (currentRedaction) {
                                        return currentRedaction;
                                    }
                                }
                                if (_this.canViewSignedDocuments()) {
                                    var currentSignedDocument = _this.signedDocuments.signedDocuments().find(function (s) { return s.isViewing() || s.isRequestingView(); });
                                    if (currentSignedDocument) {
                                        return currentSignedDocument;
                                    }
                                }
                                return null;
                            };
                            var defaults = {
                                sidebarVmFactory: function () { return new DocumentEditor.SidebarVm(_this.buildDefaultSidebar(data)); },
                                fileInfoVmFactory: function (fileInfoVmDto) { return new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.FileInfo.FileInfoVm(fileInfoVmDto); },
                                versionsVmFactory: function (versionsVmDto) { return new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.Versions.VersionsVm(versionsVmDto); },
                                redactionsVmFactory: function (redactionsVmDto, documentEditorVm) { return new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.Redactions.RedactionsVm(redactionsVmDto); },
                                signedDocumentsVmFactory: function (signedDocumentsVmDto) { return new Pbs.Documents.SpryUI.ViewModels.DocumentEditor.SignedDocuments.SignedDocumentsVm(signedDocumentsVmDto); }
                            };
                            var actual = Object.assign({}, defaults, options);
                            this.fileInfoVmFactory = actual.fileInfoVmFactory;
                            this.versionsVmFactory = actual.versionsVmFactory;
                            this.redactionsVmFactory = actual.redactionsVmFactory;
                            this.signedDocumentsVmFactory = actual.signedDocumentsVmFactory;
                            this.fileInfo = data.fileInfo ? this.fileInfoVmFactory(data.fileInfo) : null;
                            this.versions = data.canViewVersions && data.versions ? this.versionsVmFactory(data.versions) : null;
                            this.redactions = data.canViewRedactions && data.redactions ? this.redactionsVmFactory(data.redactions, this) : null;
                            this.signedDocuments = data.canViewSignedDocuments && data.signedDocuments ? this.signedDocumentsVmFactory(data.signedDocuments) : null;
                            this.initialDocumentVersionId = ko.observable(data.initialDocumentVersionId);
                            this.initialRedactionId = ko.observable(data.initialRedactionId);
                            this.initialSignedDocumentId = ko.observable(data.initialSignedDocumentId);
                            this.showFileInfo = ko.observable(data.showFileInfo);
                            this.showVersions = ko.observable(data.showVersions);
                            this.showRedactions = ko.observable(data.showRedactions);
                            this.showSignedDocuments = ko.observable(data.showSignedDocuments);
                            this.canViewVersions = ko.observable(data.canViewVersions);
                            this.canViewRedactions = ko.observable(data.canViewRedactions);
                            this.canViewSignedDocuments = ko.observable(data.canViewSignedDocuments);
                            this.currentlyViewing = ko.pureComputed(function () { return _this.findCurrentlyViewing(); });
                            this.title = ko.pureComputed(function () { return _this.fileInfo.name() + " - " + _this.fileInfo.formattedType(); });
                            this.subtitle = ko.pureComputed(function () { return _this.fileInfo.description(); });
                            this.fileExtensionClassName = ko.pureComputed(function () {
                                return _this.versions
                                    ? _this.versions.currentVersion.fileExtensionClassName()
                                    : null;
                            });
                            this.viewingSummary = ko.pureComputed(function () {
                                var document = _this.currentlyViewing();
                                return document != null ? document.viewingSummary() : null;
                            });
                            this.viewingAlert = ko.pureComputed(function () {
                                var document = _this.currentlyViewing();
                                return document != null ? document.viewingAlert() : false;
                            });
                            this.isSuitableForRelease = ko.pureComputed(function () {
                                var document = _this.currentlyViewing();
                                return document != null ? document.isSuitableForRelease() : false;
                            });
                            this.sidebar = actual.sidebarVmFactory();
                            this.isLoading = ko.observable(data.versions.versions.length > 0);
                        }
                        DocumentEditorVm.prototype.update = function (data) {
                            if (this.fileInfo && data.fileInfo) {
                                this.fileInfo.update(data.fileInfo);
                            }
                            else {
                                this.fileInfo = data.fileInfo ? this.fileInfoVmFactory(data.fileInfo) : null;
                            }
                            if (this.versions && data.versions) {
                                this.versions.update(data.versions);
                            }
                            else {
                                this.versions = data.versions ? this.versionsVmFactory(data.versions) : null;
                            }
                            ;
                            if (this.redactions && data.redactions) {
                                this.redactions.update(data.redactions);
                            }
                            else {
                                this.redactions = data.redactions ? this.redactionsVmFactory(data.redactions, this) : null;
                            }
                            ;
                            if (this.signedDocuments && data.signedDocuments) {
                                this.signedDocuments.update(data.signedDocuments);
                            }
                            else {
                                this.signedDocuments = data.signedDocuments ? this.signedDocumentsVmFactory(data.signedDocuments) : null;
                            }
                            ;
                            this.initialDocumentVersionId(data.initialDocumentVersionId);
                            this.initialRedactionId(data.initialRedactionId);
                            this.initialSignedDocumentId(data.initialSignedDocumentId);
                            this.showFileInfo(data.showFileInfo);
                            this.showVersions(data.showVersions);
                            this.showRedactions(data.showRedactions);
                            this.showSignedDocuments(data.showSignedDocuments);
                            this.canViewVersions(data.canViewVersions);
                            this.canViewRedactions(data.canViewRedactions);
                            this.canViewSignedDocuments(data.canViewSignedDocuments);
                        };
                        DocumentEditorVm.prototype.buildDefaultSidebar = function (data) {
                            return {
                                isSidebarOpen: data.showFileInfo || data.showVersions || data.showRedactions || data.showSignedDocuments,
                                panels: {
                                    "FILE INFO": {
                                        title: "FILE INFO",
                                        tooltipText: "File info",
                                        iconClassName: "info-circle-icon",
                                        isPanelVisible: true,
                                        isPanelExpanded: data.showFileInfo,
                                        isPanelOpen: data.showFileInfo
                                    },
                                    "VERSIONS": {
                                        title: "VERSIONS",
                                        tooltipText: "Versions",
                                        iconClassName: "file-explorer-icon",
                                        isPanelVisible: data.canViewVersions,
                                        isPanelExpanded: data.showVersions,
                                        isPanelOpen: data.showVersions
                                    },
                                    "REDACTIONS": {
                                        title: "REDACTIONS",
                                        tooltipText: "Redactions",
                                        iconClassName: "redacted-icon",
                                        isPanelVisible: data.canViewRedactions,
                                        isPanelExpanded: data.showRedactions,
                                        isPanelOpen: data.showRedactions
                                    },
                                    "SIGNED DOCUMENTS": {
                                        title: "SIGNED DOCUMENTS",
                                        tooltipText: "Signed Documents",
                                        iconClassName: "record-decision-icon",
                                        isPanelVisible: data.canViewSignedDocuments,
                                        isPanelExpanded: data.showSignedDocuments,
                                        isPanelOpen: data.showSignedDocuments
                                    }
                                }
                            };
                        };
                        return DocumentEditorVm;
                    }());
                    DocumentEditor.DocumentEditorVm = DocumentEditorVm;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var DocumentFilterVm = (function () {
                        function DocumentFilterVm(data) {
                            this.groupId = ko.observable(data.groupId);
                            this.typeId = ko.observable(data.typeId);
                            this.binderId = ko.observable(data.binderId);
                            this.folderId = ko.observable(data.folderId);
                            this.page = ko.observable(data.page);
                            this.resultsPerPage = ko.observable(data.resultsPerPage);
                            this.isUnattached = ko.observable(data.isUnattached);
                            this.documentsToExclude = ko.observableArray(data.documentsToExclude ? data.documentsToExclude.map(function (i) { return i; }) : []);
                            this.sortByField = ko.observable(data.sortByField);
                            this.sortDesc = ko.observable(data.sortDesc);
                            this.sortBy = ko.observable(data.sortBy);
                            this.searchText = ko.observable(data.searchText);
                            this.isRecycled = ko.observable(data.isRecycled);
                            this.isNotInBinder = ko.observable(data.isNotInBinder);
                            this.hasFilter = ko.observable(data.hasFilter);
                        }
                        DocumentFilterVm.prototype.update = function (data) {
                            this.groupId(data.groupId);
                            this.typeId(data.typeId);
                            this.binderId(data.binderId);
                            this.folderId(data.folderId);
                            this.page(data.page);
                            this.resultsPerPage(data.resultsPerPage);
                            this.isUnattached(data.isUnattached);
                            this.documentsToExclude(data.documentsToExclude ? data.documentsToExclude.map(function (i) { return i; }) : []);
                            this.sortByField(data.sortByField);
                            this.sortDesc(data.sortDesc);
                            this.sortBy(data.sortBy);
                            this.searchText(data.searchText);
                            this.isRecycled(data.isRecycled);
                            this.isNotInBinder(data.isNotInBinder);
                            this.hasFilter(data.hasFilter);
                        };
                        return DocumentFilterVm;
                    }());
                    SelectDocuments.DocumentFilterVm = DocumentFilterVm;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
ko.components.register('document-icon', {
    viewModel: function (params) {
        var _this = this;
        this.fileExtensionClass = params.fileExtensionClass;
        this.fileExtensionTitle = params.fileExtensionTitle;
        this.isConfidential = params.isConfidential;
        this.isFileValid = params.isFileValid;
        this.isFileInvalid = ko.pureComputed(function () {
            return ko.unwrap(_this.isFileValid) === false;
        });
        this.fileValidationError = params.fileValidationError;
        this.isIncluded = params.isIncluded;
        this.visible = !!params.visible ? params.visible : true;
        this.className = params.className;
        this.css = ko.pureComputed(function () {
            return ko.unwrap(params.fileExtensionClass) + ' ' + ko.unwrap(params.className);
        });
    },
    template: "\n  <div class='document-icon-element'>\n    <span class='filetype-icon no-padding-psuedo-elements' data-bind=\"css: css, attr: { title: fileExtensionTitle }, visible: visible\">\n      <span class='lock-icon' data-bind='visible: isConfidential'></span>\n      <span class='warning-icon' data-bind='visible: isFileInvalid, attr: { title: fileValidationError }'></span>\n      <span class='included-icon' data-bind='visible: isIncluded'></span>\n    </span>\n  </div>\n  "
});
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var MediaDocumentEditorPlugin = (function () {
                        function MediaDocumentEditorPlugin(documentEditorSelector, options) {
                            this.setStatus = function (status) { return undefined; };
                            this.documentEditorSelector = documentEditorSelector;
                        }
                        MediaDocumentEditorPlugin.prototype.open = function (viewModel) {
                            this.viewModel = viewModel;
                            this.setContent();
                            if (this.onReadyCallback) {
                                this.onReadyCallback(this.viewModel);
                            }
                        };
                        MediaDocumentEditorPlugin.prototype.update = function (viewModel) {
                            this.viewModel = viewModel;
                        };
                        MediaDocumentEditorPlugin.prototype.onReady = function (callback) {
                            this.onReadyCallback = callback;
                        };
                        MediaDocumentEditorPlugin.prototype.setContent = function () {
                            $(this.documentEditorSelector)
                                .html($("#media-plugin-content").html())
                                .removeClass();
                            ko.applyBindings(this.viewModel, $(this.documentEditorSelector + ' .view-document-container')[0]);
                        };
                        return MediaDocumentEditorPlugin;
                    }());
                    DocumentEditor.MediaDocumentEditorPlugin = MediaDocumentEditorPlugin;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var MissingFileDocumentEditorPlugin = (function () {
                        function MissingFileDocumentEditorPlugin(documentEditorSelector, options) {
                            this.setStatus = function (status) { return undefined; };
                            this.documentEditorSelector = documentEditorSelector;
                        }
                        MissingFileDocumentEditorPlugin.prototype.open = function (viewModel) {
                            this.viewModel = viewModel;
                            this.setContent();
                            this.onReadyCallback(viewModel);
                        };
                        MissingFileDocumentEditorPlugin.prototype.update = function (viewModel) {
                        };
                        MissingFileDocumentEditorPlugin.prototype.onReady = function (callback) {
                            this.onReadyCallback = callback;
                        };
                        MissingFileDocumentEditorPlugin.prototype.setContent = function () {
                            $(this.documentEditorSelector)
                                .html($("#missing-file-plugin-content").html())
                                .removeClass();
                        };
                        return MissingFileDocumentEditorPlugin;
                    }());
                    DocumentEditor.MissingFileDocumentEditorPlugin = MissingFileDocumentEditorPlugin;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var PrizmDocDocumentEditorPlugin = (function () {
                        function PrizmDocDocumentEditorPlugin(documentEditorSelector, options) {
                            var _this = this;
                            this.setStatus = function (status) {
                                clearTimeout(_this.statusTimeout);
                                var typeClass = status.type === DocumentEditor.DocumentEditorPluginStatusType.Success ? 'status-success'
                                    : status.type === DocumentEditor.DocumentEditorPluginStatusType.Error ? 'status-error'
                                        : 'status-normal';
                                $(_this.documentEditorSelector + ' .matrix-save-status-text')
                                    .text(status.text)
                                    .removeClass('status-normal status-success status-error')
                                    .addClass(typeClass);
                                _this.statusTimeout = window.setTimeout(function () {
                                    $(_this.documentEditorSelector + ' .matrix-save-status-text')
                                        .removeClass('status-normal status-success status-error');
                                }, 3000);
                            };
                            this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
                                var documentEditor, numTries, _loop_1, this_1, state_1;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            documentEditor = $(this.documentEditorSelector);
                                            numTries = 0;
                                            _loop_1 = function () {
                                                var response, isPdfAvailable, timeout;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4, fetch(this_1.viewModel.isPdfAvailableUrl())];
                                                        case 1:
                                                            response = _a.sent();
                                                            if (!response.ok) {
                                                                throw "Failed to get PDF status";
                                                            }
                                                            return [4, response.json()];
                                                        case 2:
                                                            isPdfAvailable = _a.sent();
                                                            if (isPdfAvailable) {
                                                                return [2, "break"];
                                                            }
                                                            timeout = Math.min(Math.pow(2, numTries) * 1000, 10000);
                                                            return [4, new Promise(function (resolve) { return setTimeout(resolve, timeout); })];
                                                        case 3:
                                                            _a.sent();
                                                            numTries++;
                                                            return [2];
                                                    }
                                                });
                                            };
                                            this_1 = this;
                                            _a.label = 1;
                                        case 1:
                                            if (!true) return [3, 3];
                                            return [5, _loop_1()];
                                        case 2:
                                            state_1 = _a.sent();
                                            if (state_1 === "break")
                                                return [3, 3];
                                            return [3, 1];
                                        case 3:
                                            this.viewer = documentEditor.pccViewer(this.options).viewerControl;
                                            this.viewer.on(PCCViewer.EventType.ViewerReady, function () {
                                                _this.bind(_this.viewModel);
                                                _this.openThumbnails();
                                                _this.openRedactionTools();
                                                _this.initRedactionViewMode();
                                            });
                                            this.viewer.on(PCCViewer.EventType.PageCountReady, function () {
                                                _this.isRedactionsLoaded = false;
                                                _this.loadRedactions();
                                                _this.enableTextSelectionRedaction();
                                                if (_this.onReadyCallback) {
                                                    _this.onReadyCallback(_this.viewModel);
                                                }
                                            });
                                            this.viewer.on(PCCViewer.EventType.MarkCreated, this.onMarkCreated);
                                            this.viewer.on(PCCViewer.EventType.MarkChanged, _.debounce(this.onMarkChanged, 500));
                                            this.viewer.on(PCCViewer.EventType.MarkRemoved, this.onMarkRemoved);
                                            this.viewer.on(PCCViewer.EventType.MarkSelectionChanged, this.onMarkSelectionChanged);
                                            this.viewer.on(PCCViewer.EventType.Click, this.onMarkClicked);
                                            return [2];
                                    }
                                });
                            }); };
                            this.wireUpDownloadButton = function () {
                                var downloadButton = $(_this.documentEditorSelector + ' [data-pcc-toggle=dialog-download]');
                                downloadButton.off('click');
                                downloadButton.on('click', function (e) { return _this.viewModel.onDownload(e); });
                            };
                            this.wireUpOpenInEditorButton = function () {
                                var openInEditorButton = $(_this.documentEditorSelector + ' .matrix-open-in-editor-icon');
                                openInEditorButton.on('click', function () { return _this.viewModel.onOpenInEditor(); });
                            };
                            this.wireUpRedactionTools = function () {
                                var redactionVm = _this.viewModel;
                                $(_this.documentEditorSelector + ' .matrix-delete-redactions-button')
                                    .on('click', _this.deleteSelectedMarks);
                                $(_this.documentEditorSelector + ' .matrix-save-redaction-button')
                                    .on('click', _this.saveRedaction)
                                    .prop('disabled', !redactionVm.canFinalize());
                                $(_this.documentEditorSelector + ' .matrix-save-a-copy-redaction-button')
                                    .on('click', _this.saveACopy)
                                    .prop('disabled', !redactionVm.canCopy());
                                $(_this.documentEditorSelector + ' .matrix-close-redaction-button')
                                    .on('click', _this.closeRedaction)
                                    .prop('disabled', !redactionVm.canFinalize());
                                $(_this.documentEditorSelector + ' .matrix-finalize-redaction-button')
                                    .on('click', function (e) { return redactionVm.onFinalize(null, e); })
                                    .prop('disabled', !redactionVm.canFinalize())
                                    .toggle(redactionVm.canFinalize());
                                $(_this.documentEditorSelector + ' .matrix-finalizing-progress-text')
                                    .toggle(!redactionVm.canFinalize()).loading();
                                var redactionToolbarButtons = $(_this.documentEditorSelector + " .pcc-tab[data-pcc-nav-tab='redact'] > .pcc-tab-pane > .pcc-left > .pcc-icon");
                                redactionToolbarButtons.prop('disabled', !redactionVm.canFinalize());
                                $(_this.documentEditorSelector + " .pcc-tab[data-pcc-nav-tab='redact'] > .pcc-tab-pane > .pcc-left > .pcc-icon-redact-textselection")
                                    .prop('disabled', true);
                                _this.viewer.getActiveMarkupLayer()
                                    .setInteractionMode(redactionVm.canFinalize() ? PCCViewer.Mark.InteractionMode.Full : PCCViewer.Mark.InteractionMode.SelectionDisabled);
                            };
                            this.openThumbnails = function () {
                                $(_this.documentEditorSelector + ' button[data-pcc-toggle="dialog-thumbnails"]').click();
                            };
                            this.openRedactionTools = function () {
                                if (_this.options.uiElements.redactTab) {
                                    $(_this.documentEditorSelector + " .pcc-tab[data-pcc-nav-tab='redact'] > .pcc-tab-item").click();
                                }
                            };
                            this.initRedactionViewMode = function () {
                                _this.viewer.setRedactionViewMode(PCCViewer.RedactionViewMode.Draft);
                                $(_this.documentEditorSelector + ' button[data-pcc-redactionviewmode]').addClass('pcc-active');
                            };
                            this.onMarkCreated = function (evt) {
                                if (_this.onRedactionMarkCreatedCallback) {
                                    if (!_this.isLoadedRedaction(evt.mark)) {
                                        if (evt.mark.interactionMode === PCCViewer.Mark.InteractionMode.SelectionDisabled) {
                                            evt.mark.setInteractionMode(PCCViewer.Mark.InteractionMode.Full);
                                        }
                                        _this.updateMark(evt.mark, _this.onRedactionMarkCreatedCallback);
                                    }
                                }
                            };
                            this.onMarkChanged = function (evt) {
                                if (_this.onRedactionMarkEditedCallback && _this.isRedactionsLoaded) {
                                    _this.updateMark(evt.mark, _this.onRedactionMarkEditedCallback);
                                }
                            };
                            this.onMarkRemoved = function (evt) {
                                if (_this.onRedactionMarkDeletedCallback) {
                                    _this.onRedactionMarkDeletedCallback(_this.viewModel, evt.mark);
                                }
                            };
                            this.onMarkSelectionChanged = function (evt) {
                                if (!_this.isRedactionsLoaded) {
                                    _this.isRedactionsLoaded = true;
                                }
                                var selectedMarks = _this.viewer.getSelectedMarks();
                                var hasSelectedMarks = selectedMarks && selectedMarks.length > 0;
                                $(_this.documentEditorSelector + ' .matrix-delete-redactions-button')
                                    .toggleClass('pcc-disabled', !hasSelectedMarks);
                            };
                            this.onMarkClicked = function (e) {
                                if (e.mark) {
                                    var currentMouseTool = _this.viewer.getCurrentMouseTool();
                                    if (currentMouseTool.endsWith('Redaction')) {
                                        _this.deselectCurrentMouseToolButton(currentMouseTool);
                                        _this.viewer.setCurrentMouseTool('AccusoftPanAndEdit');
                                        _this.viewer.selectMarks([e.mark]);
                                    }
                                }
                            };
                            this.deselectCurrentMouseToolButton = function (currentMouseTool) {
                                var mouseToolButtonClass = currentMouseTool === 'AccusoftRectangleRedaction' ? 'pcc-icon-redact-rectangle'
                                    : currentMouseTool === 'AccusoftTextSelectionRedaction' ? 'pcc-icon-redact-textselection'
                                        : null;
                                $(_this.documentEditorSelector)
                                    .find(".pcc-tabset > .pcc-tab[data-pcc-nav-tab='redact'] button." + mouseToolButtonClass)
                                    .removeClass("pcc-active pcc-locked");
                            };
                            this.loadRedactions = function () {
                                var redaction = _this.viewModel;
                                var marks = redaction.marks()
                                    .map(function (m) { return m.data(); })
                                    .map(function (d) { return JSON.parse(d); });
                                _this.viewer.deserializeMarks(marks);
                            };
                            this.isLoadedRedaction = function (mark) {
                                return !!_this.findLoadedRedaction(mark);
                            };
                            this.findLoadedRedaction = function (mark) {
                                var redaction = _this.viewModel;
                                return _.find(redaction.marks(), function (m) { return m.uniqueIdentifier() === mark.uid; });
                            };
                            this.enableTextSelectionRedaction = function () {
                                _this.viewer.documentHasText().then(function (hasText) {
                                    $(_this.documentEditorSelector + " .pcc-tab[data-pcc-nav-tab='redact'] > .pcc-tab-pane > .pcc-left > .pcc-icon-redact-textselection")
                                        .prop('disabled', !hasText);
                                }, function (error) {
                                    console.error("Failed to detect text in document: " + error + ".");
                                });
                            };
                            this.updateMark = function (mark, callback) {
                                _this.viewer.serializeMarks([mark]).then(function (marks) {
                                    callback(_this.viewModel, marks[0]);
                                }, function (error) {
                                    console.log("Failed to serialize mark - " + error + ".");
                                });
                            };
                            this.updateAllMarks = function (callback) {
                                var allMarks = _this.viewer.getAllMarks();
                                if (allMarks.length == 0) {
                                    callback(_this.viewModel, []);
                                }
                                else {
                                    _this.viewer.serializeMarks(allMarks).then(function (marks) {
                                        callback(_this.viewModel, marks);
                                    }, function (error) {
                                        console.log("Failed to serialize marks - " + error + ".");
                                    });
                                }
                            };
                            this.saveRedaction = function (e) {
                                if (_this.onRedactionSavedCallback) {
                                    _this.updateAllMarks(_this.onRedactionSavedCallback);
                                }
                            };
                            this.saveACopy = function (e) {
                                _this.saveRedaction(e);
                                if (_this.onRedactionCopiedCallback) {
                                    _this.onRedactionCopiedCallback(_this.viewModel, e);
                                }
                            };
                            this.deleteSelectedMarks = function (e) {
                                var selectedMarks = _this.viewer.getSelectedMarks();
                                if (selectedMarks && selectedMarks.length > 0) {
                                    _this.viewer.deleteMarks(selectedMarks);
                                }
                            };
                            this.closeRedaction = function (e) {
                                _this.saveRedaction(e);
                                if (_this.onRedactionClosedCallback) {
                                    _this.onRedactionClosedCallback(_this, e);
                                }
                            };
                            this.documentEditorSelector = documentEditorSelector;
                            this.options = {
                                documentID: options.viewingSessionId,
                                language: JSON.parse(options.languageConfigurationJson),
                                annotationsMode: 'LayeredAnnotations',
                                imageHandlerUrl: options.routeName,
                                immediateActionMenuMode: 'off',
                                predefinedSearch: JSON.parse(options.searchConfigurationJson),
                                template: JSON.parse(options.templateJson),
                                redactionReasons: JSON.parse(options.redactionConfigurationJson),
                                signatureCategories: 'Signature,Initials,Title',
                                resourcePath: options.resourceDirectory,
                                encryption: true,
                                uiElements: {
                                    advancedSearch: true,
                                    attachments: true,
                                    download: true,
                                    fullScreenOnInit: false,
                                    annotateTab: false,
                                    redactTab: options.enableRedactTab,
                                    searchTab: options.enableSearchTab,
                                    esignTab: false,
                                    printing: false
                                }
                            };
                            this.supportsRedactions = true;
                        }
                        PrizmDocDocumentEditorPlugin.prototype.open = function (viewModel) {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.viewModel = viewModel;
                                            this.remove();
                                            return [4, this.refresh()];
                                        case 1:
                                            _a.sent();
                                            return [2];
                                    }
                                });
                            });
                        };
                        PrizmDocDocumentEditorPlugin.prototype.update = function (viewModel) {
                            this.viewModel = viewModel;
                            this.bind(this.viewModel);
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onReady = function (callback) {
                            this.onReadyCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionMarkCreated = function (callback) {
                            this.onRedactionMarkCreatedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionMarkEdited = function (callback) {
                            this.onRedactionMarkEditedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionMarkDeleted = function (callback) {
                            this.onRedactionMarkDeletedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionClosed = function (callback) {
                            this.onRedactionClosedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionSaved = function (callback) {
                            this.onRedactionSavedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.onRedactionCopied = function (callback) {
                            this.onRedactionCopiedCallback = callback;
                        };
                        PrizmDocDocumentEditorPlugin.prototype.remove = function () {
                            var $documentEditor = $(this.documentEditorSelector);
                            var $container = $documentEditor.parent();
                            $documentEditor.remove();
                            var id = this.documentEditorSelector.replace(/^#/, '');
                            $documentEditor = $("<div id='" + id + "'></div>");
                            $container.append($documentEditor);
                        };
                        PrizmDocDocumentEditorPlugin.prototype.bind = function (viewModel) {
                            $(this.documentEditorSelector + ' .matrix-open-in-editor-icon').toggle(viewModel.isEditable());
                            this.wireUpDownloadButton();
                            this.wireUpOpenInEditorButton();
                            this.wireUpRedactionTools();
                        };
                        return PrizmDocDocumentEditorPlugin;
                    }());
                    DocumentEditor.PrizmDocDocumentEditorPlugin = PrizmDocDocumentEditorPlugin;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Redactions;
                    (function (Redactions) {
                        var RedactionBurnStatus;
                        (function (RedactionBurnStatus) {
                            RedactionBurnStatus["Requested"] = "Requested";
                            RedactionBurnStatus["Processing"] = "Processing";
                            RedactionBurnStatus["Succeeded"] = "Succeeded";
                            RedactionBurnStatus["Failed"] = "Failed";
                        })(RedactionBurnStatus = Redactions.RedactionBurnStatus || (Redactions.RedactionBurnStatus = {}));
                    })(Redactions = DocumentEditor.Redactions || (DocumentEditor.Redactions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var Redactions;
                    (function (Redactions) {
                        var RedactionStatus;
                        (function (RedactionStatus) {
                            RedactionStatus["Draft"] = "Draft";
                            RedactionStatus["Finalizing"] = "Finalizing";
                            RedactionStatus["Final"] = "Final";
                        })(RedactionStatus = Redactions.RedactionStatus || (Redactions.RedactionStatus = {}));
                    })(Redactions = DocumentEditor.Redactions || (DocumentEditor.Redactions = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var SelectDocumentViewModel = (function () {
                        function SelectDocumentViewModel(data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) {
                            var _this = this;
                            this.supportsAttachments = true;
                            this.hasAttachments = ko.pureComputed(function () { return _this.attachments && _this.attachments().length > 0; });
                            this.includedAsAttachment = ko.pureComputed(function () { return _this.someVersionIncludedAsAttachmentTo().length > 0; });
                            this.references = ko.pureComputed(function () {
                                if (!_this.selected())
                                    return '';
                                if (!_this.includedAsAttachment())
                                    return _this.attachmentReference();
                                var references = _this.includedAsAttachmentTo();
                                if (_this.attachmentReference())
                                    references = [_this.attachmentReference()].concat(references);
                                return references.sort(function (a, b) { return Pb.compare(a, b); }).join(', ');
                            });
                            this.visible = ko.pureComputed(function () {
                                return !_this.isHidden() || _this.includedAsAttachment();
                            });
                            this.disabled = ko.pureComputed(function () {
                                return _this.serverDisabled() || _this.includedAsAttachment();
                            });
                            this.includedMessage = ko.observable(null);
                            this.filetypeTitle = ko.pureComputed(function () {
                                var title = _this.getFileTypeTitle();
                                if (!_this.includedMessage()) {
                                    return title;
                                }
                                else {
                                    return title + '\r\n' + _this.includedMessage();
                                }
                            });
                            this.checkboxTitle = ko.pureComputed(function () {
                                if (!_this.includedAsAttachment())
                                    return '';
                                return 'Included as attachment';
                            });
                            this.jsViewModelName = ko.observable(data.jsViewModelName);
                            this.__type = ko.observable(data.__type);
                            this.id = ko.observable(data.id);
                            this.fileId = ko.observable(data.fileId);
                            this.order = ko.observable(data.order);
                            this.documentVersionId = ko.observable(data.documentVersionId);
                            this.key = ko.observable(data.key);
                            this.fileType = ko.observable(data.fileType);
                            this.folder = ko.observable(data.folder);
                            this.typeDisplay = ko.observable(data.typeDisplay);
                            this.type = ko.observable(data.type);
                            this.name = ko.observable(data.name);
                            this.description = ko.observable(data.description);
                            this.index = ko.observable(data.index);
                            this.createdBy = ko.observable(data.createdBy);
                            this.createdOn = ko.observable(data.createdOn);
                            this.lastModified = ko.observable(data.lastModified);
                            this.lastModifiedBy = ko.observable(data.lastModifiedBy);
                            this.lastModifiedOn = ko.observable(data.lastModifiedOn);
                            this.lastModifiedOnString = ko.observable(data.lastModifiedOnString);
                            this.activityFrom = ko.observable(data.activityFrom);
                            this.activityThrough = ko.observable(data.activityThrough);
                            this.isMediaFile = ko.observable(data.isMediaFile);
                            this.isConfidential = ko.observable(data.isConfidential);
                            this.isPdfConvertable = ko.observable(data.isPdfConvertable);
                            this.isRestricted = ko.observable(data.isRestricted);
                            this.isUserAuthorized = ko.observable(data.isUserAuthorized);
                            this.isFileValid = ko.observable(data.isFileValid);
                            this.fileValidationError = ko.observable(data.fileValidationError);
                            this.downloadUrl = ko.observable(data.downloadUrl);
                            this.viewVersionUrl = ko.observable(data.viewVersionUrl);
                            this.fileExtension = ko.observable(data.fileExtension);
                            this.fileExtensionClass = ko.observable(data.fileExtensionClass);
                            this.fileExtensionTitle = ko.observable(data.fileExtensionTitle);
                            this.koTemplateName = ko.observable(data.koTemplateName);
                            this.isHidden = ko.observable(data.isHidden);
                            this.fileSize = ko.observable(data.fileSize);
                            this.attachmentReference = ko.observable(data.attachmentReference);
                            this.attachmentIdentifier = ko.observable(data.attachmentIdentifier);
                            this.attachments = ko.observableArray(data.attachments ? data.attachments.map(function (i) { return i; }) : []);
                            this.serverDisabled = ko.observable(data.disabled);
                            this.includeAttachments = ko.observable(false);
                            this.includedAsAttachmentTo = ko.computed(function () { return includedAsAttachmentTo(_this.key()); });
                            this.someVersionIncludedAsAttachmentTo = ko.computed(function () { return someVersionIncludedAsAttachmentTo(_this.key()); });
                            this.selected = ko.computed({
                                read: function () { return isSelected(_this.key()); },
                                write: function () { }
                            });
                            this.selectedDisplay = ko.computed({
                                read: function () { return _this.selected(); },
                                write: function () { }
                            });
                            this.reviewState = ko.observable(data.reviewState);
                        }
                        SelectDocumentViewModel.prototype.update = function (data) {
                            this.jsViewModelName(data.jsViewModelName);
                            this.id(data.id);
                            this.order(data.order);
                            this.documentVersionId(data.documentVersionId);
                            this.key(data.key);
                            this.fileType(data.fileType);
                            this.folder(data.folder);
                            this.typeDisplay(data.typeDisplay);
                            this.type(data.type);
                            this.name(data.name);
                            this.description(data.description);
                            this.index(data.index);
                            this.createdBy(data.createdBy);
                            this.createdOn(data.createdOn);
                            this.lastModified(data.lastModified);
                            this.lastModifiedBy(data.lastModifiedBy);
                            this.lastModifiedOn(data.lastModifiedOn);
                            this.activityFrom(data.activityFrom);
                            this.activityThrough(data.activityThrough);
                            this.lastModifiedOnString(data.lastModifiedOnString);
                            this.selected(data.selected);
                            this.isMediaFile(data.isMediaFile);
                            this.isConfidential(data.isConfidential);
                            this.isPdfConvertable(data.isPdfConvertable);
                            this.isRestricted(data.isRestricted);
                            this.isUserAuthorized(data.isUserAuthorized);
                            this.isFileValid(data.isFileValid);
                            this.fileValidationError(data.fileValidationError);
                            this.downloadUrl(data.downloadUrl);
                            this.fileExtension(data.fileExtension);
                            this.fileExtensionClass(data.fileExtensionClass);
                            this.fileExtensionTitle(data.fileExtensionTitle);
                            this.koTemplateName(data.koTemplateName);
                            this.isHidden(data.isHidden);
                            this.fileSize(data.fileSize);
                            this.attachmentReference(data.attachmentReference);
                            this.attachmentIdentifier(data.attachmentIdentifier);
                            this.attachments(data.attachments ? data.attachments.map(function (i) { return i; }) : []);
                            this.serverDisabled(data.disabled);
                            this.reviewState(data.reviewState);
                        };
                        return SelectDocumentViewModel;
                    }());
                    SelectDocuments.SelectDocumentViewModel = SelectDocumentViewModel;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var SelectDocumentVersionViewModel = (function (_super) {
                        __extends(SelectDocumentVersionViewModel, _super);
                        function SelectDocumentVersionViewModel(data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) {
                            return _super.call(this, data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) || this;
                        }
                        SelectDocumentVersionViewModel.prototype.update = function (data) {
                            _super.prototype.update.call(this, data);
                        };
                        SelectDocumentVersionViewModel.prototype.getFileTypeTitle = function () {
                            return this.fileExtensionTitle();
                        };
                        return SelectDocumentVersionViewModel;
                    }(SelectDocuments.SelectDocumentViewModel));
                    SelectDocuments.SelectDocumentVersionViewModel = SelectDocumentVersionViewModel;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var SelectDocumentsViewModel = (function () {
                        function SelectDocumentsViewModel(data) {
                            this.tabName = ko.observable(data.tabName);
                            this.title = ko.observable(data.title);
                            this.searchText = ko.observable(data.searchText);
                            this.documents = ko.observableArray(data.documents ? data.documents.map(function (d) {
                                var ctor = Pb.getObjectByName(d.jsViewModelName, window);
                                return new ctor(d);
                            }) : []);
                            this.documentTypeOptions = ko.observableArray(data.documentTypeOptions.map(function (t) { return new Pbs.Web.DropDowns.SelectTreeNode(t); }));
                            this.documentBinderOptions = ko.observableArray(data.documentBinderOptions.map(function (t) { return new Pbs.Web.DropDowns.SelectTreeNode(t); }));
                            this.documentReviewStateOptions = ko.observableArray(data.documentReviewStateOptions.map(function (t) { return new Pbs.Web.DropDowns.MultiSelectListItem(t); }));
                            this.documentTypeCount = ko.observable(data.documentTypeCount);
                            this.documentTypeLabel = ko.observable(data.documentTypeLabel);
                            this.documentReviewStateCount = ko.observable(data.documentReviewStateCount);
                            this.documentReviewStateLabel = ko.observable(data.documentReviewStateLabel);
                            this.filter = data.filter ? new SelectDocuments.DocumentFilterVm(data.filter) : null;
                            this.filteredTotal = ko.observable(data.filteredTotal);
                            this.unfilteredTotal = ko.observable(data.unfilteredTotal);
                            this.pager = data.pager ? new Pbs.Spry.ViewModels.PagerVm(data.pager) : null;
                            this.isSingleSelectionMode = ko.observable(data.isSingleSelectionMode);
                            this.filterResultsMessage = data.filterResultsMessage;
                            this.customFilterProviderFactoryFunctionName = ko.observable(data.customFilterProviderFactoryFunctionName);
                        }
                        SelectDocumentsViewModel.prototype.update = function (data) {
                            this.tabName(data.tabName);
                            this.title(data.title);
                            this.searchText(data.searchText);
                            this.documents(data.documents ? data.documents.map(function (d) {
                                var ctor = Pb.getObjectByName(d.jsViewModelName, window);
                                return new ctor(d);
                            }) : []);
                            if (this.filter && data.filter) {
                                this.filter.update(data.filter);
                            }
                            else {
                                this.filter = data.filter ? new SelectDocuments.DocumentFilterVm(data.filter) : null;
                            }
                            ;
                            if (this.pager && data.pager) {
                                this.pager.update(data.pager);
                            }
                            else {
                                this.pager = data.pager ? new Pbs.Spry.ViewModels.PagerVm(data.pager) : null;
                            }
                            ;
                            this.isSingleSelectionMode(data.isSingleSelectionMode);
                            this.filterResultsMessage = data.filterResultsMessage;
                            this.documentTypeOptions(data.documentTypeOptions.map(function (t) { return new Pbs.Web.DropDowns.SelectTreeNode(t); }));
                            this.documentBinderOptions(data.documentBinderOptions.map(function (t) { return new Pbs.Web.DropDowns.SelectTreeNode(t); }));
                            this.documentReviewStateOptions(data.documentReviewStateOptions.map(function (t) { return new Pbs.Web.DropDowns.MultiSelectListItem(t); }));
                            this.documentTypeCount(data.documentTypeCount);
                            this.documentTypeLabel(data.documentTypeLabel);
                            this.documentReviewStateCount(data.documentReviewStateCount);
                            this.documentReviewStateLabel(data.documentReviewStateLabel);
                            this.customFilterProviderFactoryFunctionName(data.customFilterProviderFactoryFunctionName);
                            this.filteredTotal(data.filteredTotal);
                            this.unfilteredTotal(data.unfilteredTotal);
                        };
                        return SelectDocumentsViewModel;
                    }());
                    SelectDocuments.SelectDocumentsViewModel = SelectDocumentsViewModel;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var SelectRedactionViewModel = (function (_super) {
                        __extends(SelectRedactionViewModel, _super);
                        function SelectRedactionViewModel(data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) {
                            var _this = _super.call(this, data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) || this;
                            _this.supportsAttachments = false;
                            _this.redactionId = ko.observable(data.redactionId);
                            _this.redactionComments = ko.observable(data.redactionComments);
                            _this.redactionStatus = ko.observable(data.redactionStatus);
                            _this.isDraft = ko.observable(data.isDraft);
                            return _this;
                        }
                        SelectRedactionViewModel.prototype.update = function (data) {
                            _super.prototype.update.call(this, data);
                            this.redactionId(data.redactionId);
                            this.redactionComments(data.redactionComments);
                            this.redactionStatus(data.redactionStatus);
                            this.isDraft(data.isDraft);
                        };
                        SelectRedactionViewModel.prototype.getFileTypeTitle = function () {
                            return "redaction" + (this.isConfidential ? " (Confidential)" : "");
                        };
                        return SelectRedactionViewModel;
                    }(SelectDocuments.SelectDocumentViewModel));
                    SelectDocuments.SelectRedactionViewModel = SelectRedactionViewModel;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var SelectDocuments;
                (function (SelectDocuments) {
                    var SelectSignedDocumentViewModel = (function (_super) {
                        __extends(SelectSignedDocumentViewModel, _super);
                        function SelectSignedDocumentViewModel(data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) {
                            var _this = _super.call(this, data, isSelected, includedAsAttachmentTo, someVersionIncludedAsAttachmentTo) || this;
                            _this.supportsAttachments = false;
                            _this.signedDocumentId = ko.observable(data.signedDocumentId);
                            _this.signedDocumentComments = ko.observable(data.signedDocumentComments);
                            _this.signedDocumentStatus = ko.observable(data.signedDocumentStatus);
                            _this.isDraft = ko.observable(data.isDraft);
                            return _this;
                        }
                        SelectSignedDocumentViewModel.prototype.update = function (data) {
                            _super.prototype.update.call(this, data);
                            this.signedDocumentId(data.signedDocumentId);
                            this.signedDocumentComments(data.signedDocumentComments);
                            this.signedDocumentStatus(data.signedDocumentStatus);
                            this.isDraft(data.isDraft);
                        };
                        SelectSignedDocumentViewModel.prototype.getFileTypeTitle = function () {
                            return "Signed Document" + (this.isConfidential() ? " (Confidential)" : "");
                        };
                        return SelectSignedDocumentViewModel;
                    }(SelectDocuments.SelectDocumentViewModel));
                    SelectDocuments.SelectSignedDocumentViewModel = SelectSignedDocumentViewModel;
                })(SelectDocuments = ViewModels.SelectDocuments || (ViewModels.SelectDocuments = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var SidebarPanelVm = (function () {
                        function SidebarPanelVm(data, sidebar) {
                            var _this = this;
                            this.title = ko.observable(data.title);
                            this.tooltipText = ko.observable(data.tooltipText);
                            this.iconClassName = ko.observable(data.iconClassName);
                            this.tooltip = ko.pureComputed(function () { return sidebar.isSidebarOpen() ? null : _this.tooltipText(); });
                            this.isPanelVisible = ko.observable(data.isPanelVisible);
                            this.isPanelExpanded = ko.observable(data.isPanelExpanded);
                            this.isPanelOpen = ko.observable(data.isPanelOpen);
                        }
                        SidebarPanelVm.prototype.update = function (data) {
                            this.title(data.title);
                            this.tooltipText(data.tooltipText);
                            this.iconClassName(data.iconClassName);
                            this.isPanelVisible(data.isPanelVisible);
                            this.isPanelExpanded(data.isPanelExpanded);
                            this.isPanelOpen(data.isPanelOpen);
                        };
                        return SidebarPanelVm;
                    }());
                    DocumentEditor.SidebarPanelVm = SidebarPanelVm;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var SidebarVm = (function () {
                        function SidebarVm(data, sidebarPanelFactory) {
                            this.isSidebarOpen = ko.observable(data.isSidebarOpen);
                            this.panels = {};
                            for (var key in data.panels) {
                                this.panels[key] = sidebarPanelFactory
                                    ? sidebarPanelFactory(data.panels[key], this)
                                    : new DocumentEditor.SidebarPanelVm(data.panels[key], this);
                            }
                        }
                        SidebarVm.prototype.update = function (data) {
                            this.isSidebarOpen(data.isSidebarOpen);
                            for (var key in data.panels) {
                                var panelData = data.panels[key];
                                var panel = this.panels[key];
                                if (panel) {
                                    panel.update(panelData);
                                }
                                else {
                                    this.panels[key] = this.sidebarPanelFactory
                                        ? this.sidebarPanelFactory(panelData, this)
                                        : new DocumentEditor.SidebarPanelVm(panelData, this);
                                }
                            }
                        };
                        return SidebarVm;
                    }());
                    DocumentEditor.SidebarVm = SidebarVm;
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pbs;
(function (Pbs) {
    var Documents;
    (function (Documents) {
        var SpryUI;
        (function (SpryUI) {
            var ViewModels;
            (function (ViewModels) {
                var DocumentEditor;
                (function (DocumentEditor) {
                    var SignedDocuments;
                    (function (SignedDocuments) {
                        var SignedDocumentStatus;
                        (function (SignedDocumentStatus) {
                            SignedDocumentStatus["Draft"] = "Draft";
                            SignedDocumentStatus["Finalizing"] = "Finalizing";
                            SignedDocumentStatus["Final"] = "Final";
                        })(SignedDocumentStatus = SignedDocuments.SignedDocumentStatus || (SignedDocuments.SignedDocumentStatus = {}));
                    })(SignedDocuments = DocumentEditor.SignedDocuments || (DocumentEditor.SignedDocuments = {}));
                })(DocumentEditor = ViewModels.DocumentEditor || (ViewModels.DocumentEditor = {}));
            })(ViewModels = SpryUI.ViewModels || (SpryUI.ViewModels = {}));
        })(SpryUI = Documents.SpryUI || (Documents.SpryUI = {}));
    })(Documents = Pbs.Documents || (Pbs.Documents = {}));
})(Pbs || (Pbs = {}));
var Pb;
(function (Pb) {
    var AddOrMoveDocumentsToFolderDialog = (function () {
        function AddOrMoveDocumentsToFolderDialog() {
        }
        AddOrMoveDocumentsToFolderDialog.open = function (options) {
            var addOrMoveDocumentsToFolderUrl = options.addOrMoveDocumentsToFolderUrl;
            var loadingElement = options.loadingElement;
            $(loadingElement).remote({
                url: addOrMoveDocumentsToFolderUrl,
                traditional: true,
                data: { documentIds: options.documentIds, binderId: options.binderId, folderId: options.folderId },
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-add-or-move-to-folder-ko-dialog\' }" data-dialog-width="50em"></div>');
                    var vm = new AddOrMoveDocumentsToFolderVm(data);
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        ;
        return AddOrMoveDocumentsToFolderDialog;
    }());
    Pb.AddOrMoveDocumentsToFolderDialog = AddOrMoveDocumentsToFolderDialog;
    var AddOrMoveDocumentsToFolderVm = (function () {
        function AddOrMoveDocumentsToFolderVm(data) {
            var _this = this;
            this.moveToFolder = function (vm, e) {
                _this.sendRequest({
                    loadingElement: e.target,
                    moveDocuments: true,
                    eventName: 'document.movedToFolder',
                    eventFriendlyMessage: _this.documentIds().length > 1 ? 'Documents moved to folder.' : 'Document moved to folder.'
                });
            };
            this.addToFolder = function (vm, e) {
                _this.sendRequest({
                    loadingElement: e.target,
                    moveDocuments: false,
                    eventName: 'document.addedToFolder',
                    eventFriendlyMessage: _this.documentIds().length > 1 ? 'Documents added to folder.' : 'Document added to folder.'
                });
            };
            this.sendRequest = function (options) {
                var data = ko.mapping.toJS(_this, { 'ignore': ['binderFolderNodes', 'addOrMoveDocumentsToFolderUrl'] });
                data.moveDocuments = options.moveDocuments;
                $(options.loadingElement).remote({
                    url: _this.addOrMoveDocumentsToFolderUrl(),
                    method: 'post',
                    traditional: true,
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    beforeRemote: function () {
                        _this.isSubmitting(true);
                    },
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                            _this.isSubmitting(false);
                        }
                        else {
                            Pb.Dialog.close();
                            Pb.raiseEvent(options.eventName, result.hadDuplicates ? options.eventFriendlyMessage + ' Duplicates ignored.' : options.eventFriendlyMessage, {
                                documentIds: result.documentIds,
                                folderId: result.folderId,
                                binderId: result.binderId
                            });
                        }
                    }
                });
            };
            this.errors = ko.observable({});
            this.selectedFolder = ko.observable();
            var createFolder = function (data) { return new Pb.FolderVm(data, undefined, undefined, undefined, createFolder); };
            ko.mapping.fromJS(data, {
                'binderFolderNodes': {
                    create: function (options) { return createFolder(options.data); },
                }
            }, this);
            this.isSubmitting = ko.observable(false);
            this.addEnabled = ko.pureComputed(function () {
                return !_this.isSubmitting();
            });
            this.moveEnabled = ko.pureComputed(function () {
                return _this.currentFolderId() > 0
                    && _this.canMoveDocuments()
                    && !_this.isSubmitting();
            });
        }
        AddOrMoveDocumentsToFolderVm.prototype.close = function () {
            Pb.Dialog.close();
        };
        return AddOrMoveDocumentsToFolderVm;
    }());
    Pb.AddOrMoveDocumentsToFolderVm = AddOrMoveDocumentsToFolderVm;
    ;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var BinderFilterResultsMessageVm = (function () {
        function BinderFilterResultsMessageVm(data) {
            var _this = this;
            this.update = function (data) {
                _this.foldersResultsCount(data.foldersResultsCount);
                _this.filesResultCount(data.filesResultCount);
                _this.totalFilesInBinderCount(data.totalFilesInBinderCount);
                _this.pageCount(data.pageCount);
            };
            this.incrementFolders = function (options) {
                _this.foldersResultsCount(_this.foldersResultsCount() + (options.results || 0));
            };
            this.incrementFiles = function (options) {
                _this.filesResultCount(_this.filesResultCount() + (options.results || 0));
                _this.totalFilesInBinderCount(_this.totalFilesInBinderCount() + (options.total || 0));
            };
            this.decrementFolders = function (options) {
                _this.foldersResultsCount(_this.foldersResultsCount() - (options.results || 0));
            };
            this.decrementFiles = function (options) {
                _this.filesResultCount(_this.filesResultCount() - (options.results || 0));
                _this.totalFilesInBinderCount(_this.totalFilesInBinderCount() - (options.total || 0));
            };
            this.foldersResultsCount = ko.observable(data.foldersResultsCount);
            this.filesResultCount = ko.observable(data.filesResultCount);
            this.totalFilesInBinderCount = ko.observable(data.totalFilesInBinderCount);
            this.pageCount = ko.observable(data.pageCount);
            this.text = ko.pureComputed(function () {
                var itemsCount = _this.foldersResultsCount() + _this.filesResultCount();
                var itemsPart = itemsCount + " item" + (itemsCount === 1 ? '' : 's') + " (" + _this.filesResultCount() + " file" + (_this.filesResultCount() === 1 ? '' : 's') + ")";
                var pagingPart = _this.pageCount() > 1 ? "over " + _this.pageCount() + " pages" : null;
                var totalPart = _this.filesResultCount() != _this.totalFilesInBinderCount() ? "(" + _this.totalFilesInBinderCount() + " total file" + (_this.totalFilesInBinderCount() === 1 ? '' : 's') + " in binder)" : null;
                var parts = [
                    itemsPart,
                    pagingPart,
                    totalPart
                ];
                return parts.filter(function (x) { return !!x; }).join(' ');
            });
        }
        return BinderFilterResultsMessageVm;
    }());
    Pb.BinderFilterResultsMessageVm = BinderFilterResultsMessageVm;
})(Pb || (Pb = {}));
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var Pb;
(function (Pb) {
    var CreateDocumentFromTemplateDialog = (function () {
        function CreateDocumentFromTemplateDialog() {
        }
        CreateDocumentFromTemplateDialog.open = function (options) {
            $(options.loadingElement).remote({
                url: options.newDocumentFromTemplateUrl,
                afterRemote: function (result) {
                    var $editor = $('<div data-bind="template: { name: \'document-new-from-template-ko-dialog\' }" data-dialog-width="60em"></div>');
                    var vm = new DocumentCreateFromTemplateVm(result.urls, result.data, {
                        folderId: options.folderId,
                        binderId: options.binderId,
                        templateDataLoaders: options.templateDataLoaders,
                        onBeforeGenerateDocuments: options.onBeforeGenerateDocuments
                    });
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return CreateDocumentFromTemplateDialog;
    }());
    Pb.CreateDocumentFromTemplateDialog = CreateDocumentFromTemplateDialog;
    var DocumentCreateFromTemplateVm = (function () {
        function DocumentCreateFromTemplateVm(urls, data, options) {
            var _this = this;
            this.nameChanging = function (vm, e) {
                _this.name($(e.target).val());
            };
            this.toggleSelectAll = function () {
                var value = !_this.allSelected();
                _this.selectedResults.pause();
                _this.visibleResults.pause();
                _.each(_this.visibleResults(), function (result) { return result.selected(value); });
                _this.selectedResults.resume();
                _this.visibleResults.resume();
            };
            this.selectAll = function () {
                _this.selectedResults.pause();
                _this.visibleResults.pause();
                _.each(_this.results(), function (result) { return result.selected(true); });
                _this.selectedResults.resume();
                _this.visibleResults.resume();
            };
            this.generate = function (vm, e) {
                _this.generateDocuments($(e.target))
                    .then(_this.raiseDocumentCreatedEvent);
            };
            this.loadTemplateData = function (templateId) {
                _this.filters([]);
                _this.results([]);
                _this.headers([]);
                var dataRetrieved = {
                    "templateDefaults": _this.urls.getTemplateDefaultsUrl ? false : true,
                    "templateRows": false
                };
                _this.templateDataLoaders.forEach(function (templateDataLoader, index) {
                    dataRetrieved["templateDataLoader" + index] = false;
                });
                var setDataRetrieved = function (key) {
                    dataRetrieved[key] = true;
                    if (Object.keys(dataRetrieved).every(function (k) { return dataRetrieved[k]; })) {
                        _this.isUserVisible(true);
                        _this.isLoadingTemplateResults(false);
                    }
                };
                _this.isLoadingTemplateResults(true);
                if (_this.urls.getTemplateDefaultsUrl) {
                    $(_this.loadingElement()).remote({
                        url: _this.urls.getTemplateDefaultsUrl,
                        showSpinner: false,
                        allowSimultaneousRequests: true,
                        data: { templateId: templateId },
                        afterRemote: function (data) {
                            if (!_this.isTemplateDisabled() && data.defaultFileName)
                                _this.name(data.defaultFileName);
                            setDataRetrieved("templateDefaults");
                        }
                    });
                }
                _this.templateDataLoaders.forEach(function (templateDataLoader, index) {
                    templateDataLoader.loadTemplateData(_this, templateId).then(function () {
                        setDataRetrieved("templateDataLoader" + index);
                    });
                });
                $(_this.loadingElement()).remote({
                    url: _this.urls.getTemplateRowsUrl,
                    showSpinner: false,
                    allowSimultaneousRequests: true,
                    data: { templateId: templateId },
                    afterRemote: function (data) {
                        _.each(data.results, function (result) {
                            result.selected = ko.observable(false);
                            result.toggle = function () { return result.selected(!result.selected()); };
                        });
                        if (data.filters) {
                            _this.filters(_.map(data.filters, function (filter) { return ko.mapping.fromJS(filter, { copy: ["options"] }); }));
                            _.each(_this.filters(), function (filter) {
                                filter.selectedValues.subscribe(function () { return _this.applyFilters(); });
                            });
                        }
                        _.map(data.results, function (r) { return r.isVisible = ko.observable(true); });
                        _this.headers(data.headers);
                        _this.selectedResults.pause();
                        _this.visibleResults.pause();
                        _this.results(data.results);
                        setDataRetrieved("templateRows");
                        _this.selectAll();
                        _this.selectedResults.resume();
                        _this.visibleResults.resume();
                        Pb.Grid.initializeScrollingGrid($(_this.resultsGridElement()));
                        _this.applyFilters();
                    }
                });
            };
            this.applyFilters = function () {
                _this.selectedResults.pause();
                _this.visibleResults.pause();
                var filterData = _.map(_this.filters(), function (filter) {
                    return {
                        memberId: filter.fieldsetMemberId(),
                        memberIndex: _.findIndex(_this.headers(), function (header) { return header.fieldsetMemberId == filter.fieldsetMemberId(); }),
                        selectedValues: filter.selectedValues(),
                    };
                });
                if (!filterData.length) {
                    _.each(_this.results(), function (result) { return result.isVisible(true); });
                    return;
                }
                var matches = _.filter(_this.results(), function (result) {
                    return _.every(filterData, function (filter) { return filter.memberIndex < 0 || _.any(filter.selectedValues, function (val) { return val == result.values[filter.memberIndex]; }); });
                });
                _.each(_this.results(), function (result) { return result.isVisible(false); });
                _.each(matches, function (match) { return match.isVisible(true); });
                var nonmatches = _.filter(_this.results(), function (result) { return !result.isVisible(); });
                _.each(nonmatches, function (result) { return result.selected(true); });
                _this.selectedResults.resume();
                _this.visibleResults.resume();
            };
            this.generateDocuments = function ($remoteElement) { return __awaiter(_this, void 0, void 0, function () {
                var deferred;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            deferred = $.Deferred();
                            if (!this.onBeforeGenerateDocuments) return [3, 2];
                            return [4, this.onBeforeGenerateDocuments(this)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            $remoteElement.remote({
                                url: this.urls.generateDocumentsFromTemplateUrl,
                                method: 'post',
                                data: JSON.stringify(this.getDataForGenerate()),
                                contentType: 'application/json',
                                afterRemote: function (result) {
                                    if (result.errors) {
                                        _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                                        deferred.reject();
                                    }
                                    else {
                                        deferred.resolve(result);
                                    }
                                }
                            });
                            return [2, deferred.promise()];
                    }
                });
            }); };
            this.getDataForGenerate = function () {
                var data = ko.mapping.toJS(_this, { ignore: ['officeTemplates', 'officeTemplatesDefaultGenerationTypes'] });
                return __assign({}, data, { selectedChildIds: _.map(_this.selectedResultsFromTop100(), function (result) { return result.childKeyValue; }) });
            };
            this.raiseDocumentCreatedEvent = function (result) {
                result.folderId = _this.folderId;
                result.binderId = _this.binderId;
                Pb.Dialog.close(function () {
                    _.each(result.documentIds, function (documentId) {
                        result.id = documentId;
                        Pb.raiseEvent('document.created', 'Document created.', result);
                        if (result.folderId) {
                            Pb.raiseEvent('document.addedToFolder', 'Document added to folder.', {
                                documentIds: [result.id],
                                folderId: result.folderId,
                                binderId: result.binderId,
                                suppressFlashMessage: result.folderId == Pb.CustomFolderTree.notInBinderId
                            });
                        }
                    });
                    if (result.davUrl) {
                        Pb.WebDav.editDocumentInOffice(result.davUrl);
                    }
                });
            };
            this.urls = urls;
            var options = options || {};
            ko.mapping.fromJS(data, { copy: ['officeTemplatesDefaultGenerationTypes'] }, this);
            this.errors = ko.observable({});
            this.isUserVisible = ko.observable(false);
            this.binderId = options.binderId;
            this.folderId = options.folderId;
            this.isLoadingTemplateResults = ko.observable(false);
            this.loadingElement = ko.observable();
            this.filters = ko.observableArray([]);
            this.results = ko.observableArray([]);
            this.headers = ko.observableArray([]);
            this.documentGenerationType('SingleFile');
            this.resultsGridElement = ko.observable();
            this.templateDataLoaders = options.templateDataLoaders || [];
            this.onBeforeGenerateDocuments = options.onBeforeGenerateDocuments;
            this.pagePerResultLabel = ko.pureComputed(function () {
                var selectedResults = _this.selectedResultsFromTop100().length;
                return selectedResults == 1
                    ? 'Merge this 1 result into a single file'
                    : 'Merge these ' + selectedResults + ' results into a single file';
            });
            this.documentPerResultLabel = ko.pureComputed(function () { return 'Create one file for each selected result'; });
            this.templateNameLabel = ko.pureComputed(function () { return _this.documentGenerationType() == 'PerResult' ? "File Name Prefix" : "File Name"; });
            this.exampleName = ko.pureComputed(function () {
                var firstResult = _this.results()[0];
                var name = _this.name() ? _this.name() + ' ' : '';
                var exampleNameText = name + (firstResult ? firstResult.displayName : '');
                return exampleNameText.trim() ? 'e.g. ' + exampleNameText : '';
            });
            this.hasResults = ko.pureComputed(function () {
                return _this.results().length > 0;
            });
            this.visibleResults = ko.pauseableComputed(function () {
                return _.filter(_this.results(), function (result) { return result.isVisible(); });
            }, this);
            this.topHundredVisibleResults = ko.pureComputed(function () {
                return _.take(_this.visibleResults(), 100);
            });
            this.selectedResultsFromTop100 = ko.pureComputed(function () {
                return _.filter(_this.topHundredVisibleResults(), function (result) { return result.selected(); });
            });
            this.selectedResults = ko.pauseableComputed(function () {
                return _.filter(_this.results(), function (result) { return result.selected() && result.isVisible(); });
            }, this);
            this.allSelected = ko.pureComputed(function () { return _this.visibleResults().length == _this.selectedResults().length; });
            this.selectedResultsText = ko.pureComputed(function () {
                if (_this.visibleResults().length <= 100) {
                    var areAllResultsSelected = _this.topHundredVisibleResults.length == _this.results().length;
                    var resultsWord = _this.results().length == 1 ? ' result' : ' results';
                    return areAllResultsSelected ? (_this.results().length + resultsWord) : ('Showing ' + _this.visibleResults().length + ' of ' + _this.results().length + resultsWord);
                }
                else {
                    return _this.visibleResults().length == _this.results().length
                        ? _this.visibleResults().length + ' results, showing top 100'
                        : _this.visibleResults().length + ' results of ' + _this.results().length + ', showing top 100';
                }
            });
            this.selectedTemplateId = ko.computed(function () {
                var templateValue = _this.selectedTemplateValue();
                if (!templateValue)
                    return null;
                return parseInt(templateValue.substring(templateValue.indexOf("-") + 1));
            });
            this.selectedTemplateId.subscribe(function (templateId) {
                if (templateId) {
                    var defaultDocumentGenerationType = _this.officeTemplatesDefaultGenerationTypes.find(function (officeTemplate) { return officeTemplate.templateId === templateId; }).defaultDocumentGenerationType;
                    _this.documentGenerationType(defaultDocumentGenerationType);
                    _this.loadTemplateData(templateId);
                }
                else
                    _this.results([]);
            });
            setTimeout(function () {
                if (!!_this.selectedTemplateValue()) {
                    var value = _this.selectedTemplateValue();
                    var templateId = value.substring(value.indexOf('-') + 1);
                    _this.loadTemplateData(templateId);
                }
            });
        }
        return DocumentCreateFromTemplateVm;
    }());
    Pb.DocumentCreateFromTemplateVm = DocumentCreateFromTemplateVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var CreateDocumentVersionDialog = (function () {
        function CreateDocumentVersionDialog() {
        }
        CreateDocumentVersionDialog.open = function (options) {
            $(options.loadingElement).remote({
                url: options.createNewDocumentVersionUrl,
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-version-new--ko-dialog\' }" data-dialog-width="55em"></div>');
                    var vm = new DocumentCreateVersionVm(data.urls, data.viewModel, { closeDialog: true });
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return CreateDocumentVersionDialog;
    }());
    Pb.CreateDocumentVersionDialog = CreateDocumentVersionDialog;
    var DocumentCreateVersionVm = (function () {
        function DocumentCreateVersionVm(urls, data, options) {
            var _this = this;
            this.onFileChange = function (vm, e) {
                _this.file(e.target.files[0]);
            };
            this.onSubmitClick = function (vm, e) {
                var $submit = $(e.target);
                _this.validate($submit)
                    .then(_this.uploadFile($submit))
                    .then(_this.raiseDocumentVersionCreatedEvent)
                    .fail(function () { return _this.isUploading(false); });
                return false;
            };
            this.validate = function ($element) {
                var deferred = $.Deferred();
                $element.remote({
                    url: _this.urls.validateDocumentVersionUrl,
                    method: 'post',
                    data: ko.toJSON(_this),
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                            deferred.reject();
                        }
                        else {
                            _this.errors({});
                            deferred.resolve();
                        }
                    }
                });
                return deferred.promise();
            };
            this.uploadFile = function ($element) {
                return function () {
                    var deferred = $.Deferred();
                    $element.remote({
                        url: _this.urls.createDocumentVersionUrl,
                        showSpinner: false,
                        contentType: false,
                        processData: false,
                        data: _this.getUploadData(),
                        beforeRemote: function () {
                            _this.isUploading(true);
                        },
                        progress: function (current, total) {
                            _this.uploadPercent(Math.floor(current / total * 100.0));
                        },
                        afterRemote: function (result) {
                            if (result.errors) {
                                _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                                deferred.reject();
                            }
                            else {
                                deferred.resolve(result);
                            }
                        },
                        error: function () {
                            _this.isUploading(false);
                        },
                        file: _this.file()
                    });
                    return deferred.promise();
                };
            };
            this.getUploadData = function () {
                var formData = new FormData();
                var antiForgeryToken = Pb.JQueryAntiForgery.getToken();
                formData.append('viewModel', ko.toJSON(_this));
                formData.append('file', _this.file());
                formData.append(antiForgeryToken.name, antiForgeryToken.value);
                return formData;
            };
            this.urls = urls;
            options = options || {};
            ko.mapping.fromJS(data, {}, this);
            this.errors = ko.observable({});
            this.file = ko.observable();
            this.isUploading = ko.observable(false);
            this.uploadPercent = ko.observable(0);
            this.uploadStatus = ko.pureComputed(function () { return _this.uploadPercent() == 100 ? "Processing..." : _this.uploadPercent() + '%'; });
            this.uploadButtonEnabled = ko.pureComputed(function () { return !_this.isUploading(); });
            this.uploadButtonTitle = ko.pureComputed(function () { return _this.isUploading() ? 'Uploading...' : ''; });
            this.file.subscribe(function (value) {
                _this.fileMetadata.fileName(value ? value.name : null);
                _this.fileMetadata.length(value ? value.size : 0);
            });
        }
        DocumentCreateVersionVm.prototype.raiseDocumentVersionCreatedEvent = function (result) {
            Pb.Dialog.close(function () { return Pb.raiseEvent('document.versioncreated', 'Document version created.', result); });
        };
        return DocumentCreateVersionVm;
    }());
    Pb.DocumentCreateVersionVm = DocumentCreateVersionVm;
    ;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var CreateDocumentDialog = (function () {
        function CreateDocumentDialog(options) {
            var _this = this;
            this.open = function (additionalNewDocumentData, documentCreatedCallback) {
                $(_this.options.loadingElement).remote({
                    url: _this.options.newDocumentUrl,
                    data: additionalNewDocumentData ? additionalNewDocumentData : undefined,
                    method: 'get',
                    afterRemote: function (data) {
                        var vm = new DocumentCreateVm(data.urls, data.viewModel, {
                            folderId: _this.options.folderId,
                            binderId: _this.options.binderId,
                            acceptedFileExtensions: _this.options.acceptedFileExtensions,
                            closeDialog: true,
                            documentCreatedCallback: documentCreatedCallback,
                            uploadButtonText: _this.options.uploadButtonText,
                            fieldsToIgnore: _this.options.fieldsToIgnore
                        });
                        _this.onView(vm);
                    }
                });
            };
            this.options = options;
        }
        CreateDocumentDialog.prototype.onView = function (vm) {
            var $editor = $('<div data-bind="template: { name: \'document-new-ko-dialog\' }" data-dialog-width="55em"></div>');
            ko.applyBindings(vm, $editor[0]);
            Pb.Dialog.open({ content: $editor, confirmUnload: true });
        };
        return CreateDocumentDialog;
    }());
    Pb.CreateDocumentDialog = CreateDocumentDialog;
    var DocumentCreateVm = (function () {
        function DocumentCreateVm(urls, data, options) {
            var _this = this;
            this.onFileChange = function (vm, e) {
                _this.file(e.target.files[0]);
            };
            this.onSubmitClick = function (vm, e) {
                var $submit = $(e.target);
                var callback = _this.options.documentCreatedCallback ? function (result, documentCreateVm) {
                    _this.options.documentCreatedCallback(result, documentCreateVm);
                    return result;
                } : function (result, documentCreateVm) { return result; };
                _this.validate($submit)
                    .then(function () {
                    if (ko.unwrap(_this.urls.createDocumentUrl)) {
                        return _this.uploadFile($submit)()
                            .then(callback)
                            .then(_this.raiseDocumentEvents);
                    }
                    else {
                        return callback(_this.getSaveRequest(), _this);
                    }
                })
                    .fail(function () { return _this.isUploading(false); });
                return false;
            };
            this.validate = function ($element) {
                var deferred = $.Deferred();
                $element.remote({
                    url: _this.urls.validateDocumentUrl,
                    method: 'post',
                    data: JSON.stringify(_this.unmapSelfForValidateAndUpload()),
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                            deferred.reject();
                        }
                        else {
                            _this.errors({});
                            deferred.resolve();
                        }
                    }
                });
                return deferred.promise();
            };
            this.uploadFile = function ($element) {
                return function () {
                    var deferred = $.Deferred();
                    $element.remote({
                        url: _this.urls.createDocumentUrl,
                        showSpinner: false,
                        contentType: false,
                        processData: false,
                        data: _this.getUploadData(),
                        beforeRemote: function () {
                            _this.isUploading(true);
                        },
                        progress: function (current, total) {
                            _this.totalBytes(total);
                            _this.uploadedBytes(current);
                            _this.uploadPercent(Math.floor(current / total * 100.0));
                        },
                        afterRemote: function (result) {
                            if (result.errors) {
                                _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                                deferred.reject();
                            }
                            else if (!result.success) {
                                _this.errors({ '': result.errorMessage });
                                _this.showUploadError(result.errorMessage);
                                _this.isUploading(false);
                                deferred.reject();
                            }
                            else {
                                _this.isUploaded(true);
                                deferred.resolve(result);
                            }
                        },
                        error: function () {
                            _this.isUploading(false);
                        },
                        file: _this.file(),
                        allowSimultaneousRequests: _this.allowSimultaneousRequests
                    });
                    return deferred.promise();
                };
            };
            this.getUploadData = function () {
                var saveRequest = _this.getSaveRequest();
                var formData = new FormData();
                Pb.FormDataSerializer.appendObject(saveRequest, formData);
                return formData;
            };
            this.unmapSelfForValidateAndUpload = function () {
                var mapping = {
                    'ignore': [
                        'documentFolderNodes',
                        'documentSources',
                        'documentTypes',
                        'errors',
                        'isUploaded',
                        'isUploading',
                        'uploadButtonEnabled',
                        'uploadButtonTitle',
                        'uploadPercent',
                        'uploadStatus',
                        'uploadedBytes'
                    ].concat(_this.options.fieldsToIgnore || [])
                };
                var data = ko.mapping.toJS(_this, mapping);
                if (data.caseDefendantSelector && data.caseDefendantSelector.cases) {
                    delete data.caseDefendantSelector.cases;
                }
                return data;
            };
            this.getSaveRequest = function () {
                var request = _this.unmapSelfForValidateAndUpload();
                request.file = _this.file();
                var antiForgeryToken = Pb.JQueryAntiForgery.getToken();
                request[antiForgeryToken.name] = antiForgeryToken.value;
                return request;
            };
            this.close = function (callback) {
                Pb.Dialog.close(callback);
            };
            this.raiseDocumentEvents = function (result) {
                result.folderId = _this.folderId();
                result.binderId = _this.binderId();
                if (_this.options.closeDialog) {
                    _this.close(raiseEvents);
                }
                else {
                    raiseEvents();
                }
                function raiseEvents() {
                    Pb.raiseEvent('document.created', 'Document created.', result);
                    if (result.folderId) {
                        Pb.raiseEvent('document.addedToFolder', 'Document added to folder.', {
                            documentIds: [result.id],
                            folderId: result.folderId,
                            binderId: result.binderId,
                            suppressFlashMessage: result.folderId == Pb.CustomFolderTree.notInBinderId
                        });
                    }
                }
            };
            this.updateTypeName = function () {
                var selectedType = _this.findDocumentTypeTreeNode(_this.typeId(), _this.documentTypes());
                _this.typeName(selectedType && selectedType.text());
            };
            this.findDocumentTypeTreeNode = function (typeId, treeNodes) {
                var selectedType = _.find(treeNodes, function (t) { return t.value() == typeId; });
                if (selectedType)
                    return selectedType;
                var allChildTreeNodes = _.flatten(treeNodes.map(function (n) { return n.children(); }));
                if (allChildTreeNodes.length === 0)
                    return null;
                return _this.findDocumentTypeTreeNode(typeId, allChildTreeNodes);
            };
            this.showUploadError = function (errorMessage) {
                Pb.MessageBox.show({
                    title: 'Upload Failed',
                    message: errorMessage
                });
            };
            this.urls = urls;
            this.options = options || {};
            ko.mapping.fromJS(data, {}, this);
            this.errors = ko.observable({});
            this.hasErrors = ko.pureComputed(function () { return _.keys(_this.errors()).length > 0; });
            this.binderId = ko.observable(options.binderId);
            this.folderId = ko.observable(options.folderId);
            this.file = ko.observable();
            this.isUploading = ko.observable(false);
            this.isUploaded = ko.observable(false);
            this.uploadedBytes = ko.observable(0);
            this.totalBytes = ko.observable(0);
            this.uploadPercent = ko.observable(0);
            this.uploadStatus = ko.pureComputed(function () { return _this.uploadPercent() == 100 ? "Processing..." : _this.uploadPercent() + '%'; });
            this.uploadButtonEnabled = ko.pureComputed(function () { return !_this.isUploading(); });
            this.uploadButtonTitle = ko.pureComputed(function () { return _this.isUploading() ? 'Uploading...' : ''; });
            this.uploadButtonText = ko.observable(options.uploadButtonText || "Save");
            this.acceptedFileExtensions = ko.observable(options.acceptedFileExtensions);
            this.file.subscribe(function (value) {
                _this.name(Pb.FileName.getName(value ? value.name : ''));
                _this.fileMetadata.fileName(value ? value.name : null);
                _this.fileMetadata.length(value ? value.size : 0);
            });
            this.isOtherDocumentSourceSelected = ko.computed(function () { return _this.documentSource() === "Other"; });
            this.documentSource.subscribe(function (value) {
                if (!_this.isOtherDocumentSourceSelected()) {
                    _this.documentSourceOtherValue(null);
                }
            });
            this.typeId.subscribe(function () { return _this.updateTypeName(); });
            this.updateTypeName();
        }
        return DocumentCreateVm;
    }());
    Pb.DocumentCreateVm = DocumentCreateVm;
    ;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var BinderContext = (function () {
        function BinderContext() {
        }
        return BinderContext;
    }());
    Pb.BinderContext = BinderContext;
    var DocumentBinderVm = (function () {
        function DocumentBinderVm(bindersVm, data) {
            var _this = this;
            this.select = function (vm, e) {
                if (_this.isSelected())
                    return;
                if (_this.isCreate)
                    _this.bindersVm.onCreateBinderRequested(e.target);
                else
                    _this.bindersVm.onBinderSelected(_this);
            };
            this.equals = function (other) {
                return (_this.isCustomFolders && _this.id === other.id) || (!_this.isCustomFolders && _this.systemBinderType === other.systemBinderType);
            };
            this.bindersVm = bindersVm;
            this.id = data.id;
            this.systemBinderType = data.systemBinderType;
            this.folderId = data.folderId;
            this.name = data.binderName;
            this.description = data.binderDescription;
            this.isAllFiles = data.isAllFiles;
            this.isRecycleBin = data.isRecycleBin;
            this.isChildAttachmentBinder = data.isChildAttachmentBinder;
            this.isCreate = data.isCreate;
            this.isCustomFolders = data.isCustomFolders;
            this.iconClass = data.binderIconClass;
            this.isSelected = ko.observable(data.isSelected);
            this.canAddNewFiles = data.canAddNewFiles;
            this.cannotAddNewFilesReason = data.cannotAddNewFilesReason;
            this.isReadonly = ko.observable(data.isReadonly);
            this.sortByField = data.sortByField;
            this.sortDesc = data.sortDesc;
        }
        return DocumentBinderVm;
    }());
    Pb.DocumentBinderVm = DocumentBinderVm;
    var DocumentsBindersVm = (function () {
        function DocumentsBindersVm(data, binderFactory) {
            var _this = this;
            this.update = function (data) {
                var mapping = {
                    'binders': {
                        create: function (options) {
                            return _this.binderFactory
                                ? _this.binderFactory(_this, options.data)
                                : new DocumentBinderVm(_this, options.data);
                        }
                    }
                };
                ko.mapping.fromJS(data, mapping, _this);
            };
            this.onBinderSelected = function (selectedBinder) {
                _.each(_this.binders(), function (binder) { return binder.isSelected(false); });
                selectedBinder.isSelected(true);
                Pb.raiseEvent('document.binderSelected', 'Binder selected.', { binder: selectedBinder });
            };
            this.selectDefaultBinder = function () {
                var defaultBinder = _.find(_this.binders(), function (binder) { return binder.systemBinderType == 'AllFiles'; });
                _this.onBinderSelected(defaultBinder);
            };
            this.addBinderItem = function (binderItem) {
                var i;
                for (i = 0; i < _this.binders().length; i++) {
                    var currentBinderItem = _this.binders()[i];
                    if (_this.isSystemBinder(currentBinderItem))
                        continue;
                    if (binderItem.name < currentBinderItem.name || currentBinderItem.isCreate)
                        break;
                }
                _this.binders.splice(i, 0, binderItem);
            };
            this.refresh = function () {
                $('<div></div>').remote({
                    url: _this.getDocumentBindersUrl(),
                    afterRemote: function (data) {
                        _.each(data.binders, function (binder) {
                            binder.isSelected = _this.selectedBinder().equals(binder);
                        });
                        _this.update(data);
                    }
                });
            };
            this.binderFactory = binderFactory;
            this.update(data);
            this.selectedBinder = ko.pureComputed(function () {
                return _.find(_this.binders(), function (binder) { return binder.isSelected(); });
            });
            this.hasSelectedBinder = ko.pureComputed(function () {
                return !!(_this.selectedBinder() && _this.selectedBinder().id);
            });
            this.selectedBinderName = ko.pureComputed(function () {
                var selectedBinder = _this.selectedBinder();
                return selectedBinder != null ? selectedBinder.name : '';
            });
            this.selectedBinderDescription = ko.pureComputed(function () {
                var selectedBinder = _this.selectedBinder();
                return selectedBinder != null ? selectedBinder.description : '';
            });
            this.hasSelectedCustomFolderBinder = ko.pureComputed(function () {
                var selectedBinder = _this.selectedBinder();
                return selectedBinder != null ? selectedBinder.isCustomFolders : false;
            });
            this.hasSelectedChildAttachmentsBinder = ko.pureComputed(function () {
                var selectedBinder = _this.selectedBinder();
                return selectedBinder != null ? selectedBinder.isChildAttachmentBinder : false;
            });
        }
        DocumentsBindersVm.prototype.onCreateBinderRequested = function (loadingElement) {
            Pb.DocumentBinderDialog.open({
                createDocumentBinderUrl: this.createDocumentBinderUrl(),
                loadingElement: loadingElement
            });
        };
        ;
        DocumentsBindersVm.prototype.isSelectedBinderReadonly = function () {
            if (!this.selectedBinder())
                return false;
            return this.selectedBinder().isReadonly();
        };
        DocumentsBindersVm.prototype.isSystemBinder = function (binder) {
            return binder.isAllFiles || binder.isRecycleBin || binder.isChildAttachmentBinder;
        };
        ;
        return DocumentsBindersVm;
    }());
    Pb.DocumentsBindersVm = DocumentsBindersVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentChildAttachments = (function () {
        function DocumentChildAttachments() {
        }
        DocumentChildAttachments.showAttachmentsDialog = function (content) {
            Pb.Dialog.open({
                id: 'attachments-dialog',
                content: content
            });
        };
        DocumentChildAttachments.onAttachmentsSaved = function () {
            Pb.Dialog.close(function () {
                Pb.raiseEvent('document.attachmentsUpdated', 'Attachments updated.');
            });
        };
        DocumentChildAttachments.onAttachmentsDeleted = function () {
            Pb.Dialog.close(function () {
                Pb.raiseEvent('document.attachmentsDeleted', 'Attachments deleted.');
            });
        };
        return DocumentChildAttachments;
    }());
    Pb.DocumentChildAttachments = DocumentChildAttachments;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentContextMenuBuilder = (function () {
        function DocumentContextMenuBuilder(documentVm) {
            this.documentVm = documentVm;
        }
        DocumentContextMenuBuilder.prototype.buildContextMenu = function (contextMenuItems) {
            var _this = this;
            var makeSearchableMenuItem = _.find(contextMenuItems, function (m) { return ko.unwrap(m.text) === 'Make Searchable'; });
            if (makeSearchableMenuItem && this.isOcrDocumentVm(this.documentVm)) {
                makeSearchableMenuItem.enable = ko.computed(function () {
                    var ocrDocumentVm = _this.documentVm;
                    return ocrDocumentVm.fileExtension() === 'pdf' && ocrDocumentVm.ocrStatus() === 'Unknown';
                });
                makeSearchableMenuItem.disabledTooltip = ko.computed(function () {
                    var ocrDocumentVm = _this.documentVm;
                    if (ocrDocumentVm.ocrStatus() === 'Searchable') {
                        return "This file is already searchable.";
                    }
                    else if (ocrDocumentVm.ocrStatus() === 'Unsearchable') {
                        return "This file does not have searchable content.";
                    }
                    else if (ocrDocumentVm.ocrStatus() === 'Queued') {
                        return "This file is being processed for searchable content.";
                    }
                    else if (ocrDocumentVm.fileExtension() !== 'pdf') {
                        return "This file type cannot be made searchable.";
                    }
                    else {
                        return null;
                    }
                });
            }
            return new Pb.ContextMenuVm({ context: this.documentVm, items: contextMenuItems });
        };
        DocumentContextMenuBuilder.prototype.isOcrDocumentVm = function (documentVm) {
            return documentVm.ocrStatus !== undefined;
        };
        return DocumentContextMenuBuilder;
    }());
    Pb.DocumentContextMenuBuilder = DocumentContextMenuBuilder;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentsGridMultiselectContextMenu = (function () {
        function DocumentsGridMultiselectContextMenu(gridVm, getSelectedBinderContext, menuItems) {
            var _this = this;
            this.download = function (contextMenuItemVm, e) {
                if (_this.gridVm.selectedDocuments().length > 0) {
                    _this.gridVm.selectedDocuments().forEach(function (documentVm) {
                        var documentFileVm = documentVm;
                        if (documentFileVm.hasBeenViewedByUser) {
                            documentFileVm.hasBeenViewedByUser(true);
                        }
                    });
                    _this.getDownloadData();
                    $('.download-selection-form .submit-selected-downloads').click();
                }
            };
            this.getDownloadData = function () {
                var documentIds = _this.gridVm.selectedDocuments().map(function (document) { return document.id; });
                $('.download-selection-form .hidden-ids').val(documentIds.toString());
            };
            this.recycle = function (contextMenuItemVm, e) {
                var recycleData = _this.getRecycleData();
                Pb.Confirmation.show({
                    message: 'Are you sure you want to recycle these ' + _this.gridVm.selectedDocuments().length + ' files from the current folder?', yesCaption: 'Recycle Files', noCaption: 'Cancel',
                    stayOpen: true,
                    callback: function (data) {
                        data.$button.remote({
                            url: contextMenuItemVm.source.linkUrl,
                            data: recycleData,
                            traditional: true,
                            method: 'post',
                            afterRemote: function (result) {
                                data.closePopup();
                                result.isMultiselect = true;
                                result.documents = _.filter(_this.gridVm.documents(), function (doc) { return _.contains(result.recycledDocIds, doc.id); });
                                Pb.raiseEvent('document.recycled', 'Documents recycled.', result);
                            }
                        });
                    }
                });
            };
            this.hasBeenViewedByUser = function () {
                return _this.gridVm.selectedDocuments()
                    .some(function (documentVm) {
                    var documentFileVm = documentVm;
                    return documentFileVm.hasBeenViewedByUser && documentFileVm.hasBeenViewedByUser();
                });
            };
            this.hasNotBeenViewedByUser = function () {
                return _this.gridVm.selectedDocuments()
                    .some(function (documentVm) {
                    var documentFileVm = documentVm;
                    return documentFileVm.hasBeenViewedByUser && !documentFileVm.hasBeenViewedByUser();
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                var documentIds = _this.gridVm.selectedDocuments().map(function (x) { return x.id; });
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    traditional: true,
                    method: 'post',
                    data: { documentIds: documentIds },
                    afterRemote: function () {
                        _this.gridVm.selectedDocuments().forEach(function (documentVm) {
                            var documentFileVm = documentVm;
                            if (documentFileVm.hasBeenViewedByUser) {
                                documentFileVm.hasBeenViewedByUser(true);
                            }
                        });
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                var documentIds = _this.gridVm.selectedDocuments().map(function (x) { return x.id; });
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    traditional: true,
                    method: 'post',
                    data: { documentIds: documentIds },
                    afterRemote: function () {
                        _this.gridVm.selectedDocuments().forEach(function (documentVm) {
                            var documentFileVm = documentVm;
                            if (documentFileVm.hasBeenViewedByUser) {
                                documentFileVm.hasBeenViewedByUser(false);
                            }
                        });
                    }
                });
            };
            this.isSuitableForRelease = function () {
                return _this.gridVm.selectedDocuments()
                    .some(function (documentVm) {
                    var documentFileVm = documentVm;
                    return documentFileVm.isSuitableForRelease && documentFileVm.isSuitableForRelease();
                });
            };
            this.isNotSuitableForRelease = function () {
                return _this.gridVm.selectedDocuments()
                    .some(function (documentVm) {
                    var documentFileVm = documentVm;
                    return documentFileVm.isSuitableForRelease && !documentFileVm.isSuitableForRelease();
                });
            };
            this.markSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open(_this.gridVm.selectedDocuments().map(function (x) { return x.id; }));
            };
            this.undoSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open(_this.gridVm.selectedDocuments().map(function (x) { return x.id; }));
            };
            this.getRecycleData = function () {
                var documentIds = _.map(_this.gridVm.selectedDocuments(), function (document) { return document.id; });
                return { documentIds: documentIds };
            };
            this.restore = function (contextMenuItemVm, e) {
                var restoreData = _this.getRestoreData();
                Pb.Confirmation.show({
                    title: 'Restore Files?',
                    message: 'Are you sure you want to restore these ' + _this.gridVm.selectedDocuments().length + ' files?', yesCaption: 'Restore', noCaption: 'Cancel',
                    stayOpen: true,
                    callback: function (data) {
                        data.$button.remote({
                            url: contextMenuItemVm.source.linkUrl,
                            data: restoreData,
                            traditional: true,
                            method: 'post',
                            afterRemote: function (result) {
                                data.closePopup();
                                result = result || {};
                                result.isMultiselect = true;
                                result.documents = _.filter(_this.gridVm.documents(), function (doc) { return _.contains(result.restoredDocIds, doc.id); });
                                Pb.raiseEvent('document.restored', 'Documents restored.', result);
                            }
                        });
                    }
                });
            };
            this.getRestoreData = function () {
                var documentIds = _.map(_this.gridVm.selectedDocuments(), function (document) { return document.id; });
                return { documentIds: documentIds };
            };
            this.delete = function (contextMenuItemVm, e) {
                var deleteData = _this.getDeleteData();
                Pb.Confirmation.show({
                    message: 'Are you sure you want to permanently delete these ' + _this.gridVm.selectedDocuments().length + ' files?',
                    yesCaption: 'Permanently Delete Files', noCaption: 'Cancel',
                    stayOpen: true,
                    callback: function (data) {
                        data.$button.remote({
                            url: contextMenuItemVm.source.linkUrl,
                            data: deleteData,
                            method: 'post',
                            traditional: true,
                            afterRemote: function (result) {
                                data.closePopup();
                                result.isMultiselect = true;
                                result.documents = _.filter(_this.gridVm.documents(), function (doc) { return _.contains(result.deletedDocIds, doc.id); });
                                Pb.raiseEvent('document.deleted', 'Documents deleted.', result);
                            }
                        });
                    }
                });
            };
            this.getDeleteData = function () {
                var documentIds = _.map(_this.gridVm.selectedDocuments(), function (document) { return document.id; });
                return { documentIds: documentIds };
            };
            this.removeDocumentFromFolder = function (contextMenuItemVm, e) {
                var docIds = _.map(_this.gridVm.selectedDocuments(), function (doc) { return doc.id; });
                Pb.Confirmation.show({
                    title: 'Remove Files from Folder?',
                    message: 'Are you sure you want to remove these ' + _this.gridVm.selectedDocuments().length + ' files from the current folder?',
                    yesCaption: 'Remove', noCaption: 'Cancel',
                    stayOpen: true,
                    callback: function (data) {
                        data.$button.remote({
                            url: contextMenuItemVm.source.linkUrl,
                            data: {
                                documentIds: docIds,
                                documentFolderId: _this.getSelectedBinderContext().selectedFolderId
                            },
                            method: 'post',
                            traditional: true,
                            afterRemote: function (result) {
                                data.closePopup();
                                Pb.raiseEvent('document.removedFromFolder', 'Documents removed from folder.', {
                                    documentIds: docIds,
                                    folderId: Pb.CustomFolderTree.notInBinderId,
                                    binderId: _this.getSelectedBinderContext().selectedBinderId
                                });
                            }
                        });
                    }
                });
            };
            this.addOrMoveToFolder = function (contextMenuItemVm, e) {
                var docIds = _.map(_this.gridVm.selectedDocuments(), function (doc) { return doc.id; });
                Pb.AddOrMoveDocumentsToFolderDialog.open({
                    addOrMoveDocumentsToFolderUrl: contextMenuItemVm.source.linkUrl,
                    documentIds: docIds,
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.getSelectedBinderContext().selectedFolderId,
                    loadingElement: $(e.target)
                });
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                var documentIds = _this.gridVm.selectedDocuments().map(function (d) { return d.id; });
                var params = new URLSearchParams();
                for (var _i = 0, documentIds_1 = documentIds; _i < documentIds_1.length; _i++) {
                    var documentId = documentIds_1[_i];
                    params.append('documentIds', documentId.toString());
                }
                var seperator = contextMenuItemVm.source.linkUrl.indexOf('?') !== -1 ? '&' : '?';
                var url = "" + contextMenuItemVm.source.linkUrl + seperator + params.toString();
                $(e.currentTarget).remote({
                    url: url,
                    method: 'POST',
                    afterRemote: function () {
                        for (var _i = 0, documentIds_2 = documentIds; _i < documentIds_2.length; _i++) {
                            var documentId = documentIds_2[_i];
                            Pb.raiseEvent('document.updated', 'Document updated.', { id: documentId });
                        }
                    }
                });
            };
            this.gridVm = gridVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            Pb.ContextMenuVm.call(this, { context: this, items: menuItems });
            this.missingFilesTooltip = ko.pureComputed(function () {
                var anyMissingSelected = _this.gridVm.selectedDocuments()
                    .some(function (d) { return Pb.isDocumentRowVm(d) && d.isFileMissing(); });
                if (anyMissingSelected)
                    return 'A selected file is not available.';
            });
            this.noSelectedFilesAreMissing = ko.pureComputed(function () {
                return !_this.missingFilesTooltip();
            });
            var items = this.items;
            items.subscribe(function () {
                var missingFileItems = items().filter(function (m) { return ko.unwrap(m.disabledTooltip) === 'missingFilesTooltip'; });
                if (missingFileItems.length)
                    missingFileItems.forEach(function (x) { return x.disabledTooltip = _this.missingFilesTooltip; });
            });
        }
        return DocumentsGridMultiselectContextMenu;
    }());
    Pb.DocumentsGridMultiselectContextMenu = DocumentsGridMultiselectContextMenu;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentRowVm = (function () {
        function DocumentRowVm(data, displayVm, getSelectedBinderContext) {
            var _this = this;
            this.requestOcr = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: _this.ocrRequestUrl,
                    method: 'POST',
                    afterRemote: function (data) {
                        _this.ocrStatus(data.ocrStatus);
                        _this.pollOcr();
                        Pb.FlashMessage.show("Making document searchable...");
                    }
                });
            };
            this.pollOcr = function () {
                var numAttempts = 0;
                var poll = function () {
                    $.get(_this.ocrPollUrl)
                        .done(function (data) {
                        if (data.isCompleted) {
                            _this.ocrStatus(data.ocrStatus);
                            _this.fileExtensionClass(data.fileExtensionClass);
                        }
                        else {
                            setTimeout(poll, 1000 * Math.pow(++numAttempts, 2));
                        }
                    });
                };
                setTimeout(poll, 1000 * Math.pow(++numAttempts, 2));
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterRestore
                    });
                };
                var afterRestore = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.restored', 'Document restored.', result);
                };
                Pb.Confirmation.show({
                    title: 'Restore File?',
                    message: 'Are you sure you want to restore this file?', yesCaption: 'Restore', noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterRecycle
                    });
                };
                var afterRecycle = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.recycled', 'Document recycled.', result);
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'File', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'post',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'post',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.delete = function (contextMenuItemVm, e) {
                var onDelete = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterDelete
                    });
                };
                var afterDelete = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.deleted', 'Document deleted.', result);
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'File', verb: 'Permanently Delete',
                    callback: onDelete
                });
            };
            this.addOrMoveToFolder = function (contextMenuItemVm, e) {
                Pb.AddOrMoveDocumentsToFolderDialog.open({
                    addOrMoveDocumentsToFolderUrl: contextMenuItemVm.source.linkUrl,
                    documentIds: [_this.id],
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.getSelectedBinderContext().selectedFolderId,
                    loadingElement: $(e.target)
                });
            };
            this.removeDocumentFromFolder = function (contextMenuItemVm, e) {
                var onRemoveDocumentFromFolder = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        data: { documentFolderId: _this.getSelectedBinderContext().selectedFolderId },
                        method: 'post',
                        afterRemote: afterRemoveDocumentFromFolder
                    });
                };
                var afterRemoveDocumentFromFolder = function (result) {
                    Pb.raiseEvent('document.removedFromFolder', 'Document removed from folder.', {
                        documentIds: [_this.id],
                        folderId: Pb.CustomFolderTree.notInBinderId,
                        binderId: _this.getSelectedBinderContext().selectedBinderId
                    });
                };
                Pb.Confirmation.show({
                    title: 'Remove File from Folder?',
                    message: 'Are you sure you want to remove this file from the current folder?',
                    yesCaption: 'Remove', noCaption: 'Cancel',
                    callback: onRemoveDocumentFromFolder
                });
            };
            this.manageAttachments = function (contextMenuItem, e) {
                $(e.target).remote({
                    url: _this.actions.documentChildAttachmentsUrl,
                    afterRemote: Pb.DocumentChildAttachments.showAttachmentsDialog
                });
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                var documentIds = [_this.id];
                var params = new URLSearchParams();
                for (var _i = 0, documentIds_3 = documentIds; _i < documentIds_3.length; _i++) {
                    var documentId = documentIds_3[_i];
                    params.append('documentIds', documentId.toString());
                }
                var seperator = contextMenuItemVm.source.linkUrl.indexOf('?') !== -1 ? '&' : '?';
                var url = "" + contextMenuItemVm.source.linkUrl + seperator + params.toString();
                $(e.currentTarget).remote({
                    url: url,
                    method: 'POST',
                    afterRemote: function () {
                        for (var _i = 0, documentIds_4 = documentIds; _i < documentIds_4.length; _i++) {
                            var documentId = documentIds_4[_i];
                            Pb.raiseEvent('document.updated', 'Document updated.', { id: documentId });
                        }
                    }
                });
            };
            this.markSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open([_this.id]);
            };
            this.undoSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open([_this.id]);
            };
            this.displayVm = displayVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.actions = data.actions;
            this.createdBy = data.createdBy;
            this.createdOn = data.createdOn;
            this.discriminator = data.discriminator;
            this.id = data.id;
            this.documentVersionId = ko.observable(data.documentVersionId);
            this.key = data.key;
            this.order = ko.observable(data.order);
            this.active = ko.observable(false);
            this.activityFrom = ko.observable(data.activityFrom);
            this.activityThru = ko.observable(data.activityThru);
            this.areRedactionsEnabled = ko.observable(data.areRedactionsEnabled);
            this.areSignedDocumentsEnabled = ko.observable(data.areSignedDocumentsEnabled);
            this.deleted = ko.observable(false);
            this.description = ko.observable(data.description);
            this.isDescriptionPreformatted = ko.observable(data.isDescriptionPreformatted);
            this.fileExtension = ko.observable(data.fileExtension);
            this.fileExtensionClass = ko.observable(data.fileExtensionClass);
            this.fileExtensionTitle = ko.observable(data.fileExtensionTitle);
            this.isConfidential = ko.observable(data.isConfidential);
            this.fileSize = ko.observable(data.fileSize);
            this.formattedAttachmentCount = ko.observable(data.formattedAttachmentCount);
            this.formattedAttachmentName = ko.observable(data.formattedAttachmentName);
            this.groupId = ko.observable(data.groupId);
            this.groupName = ko.observable(data.groupName);
            this.hidden = ko.observable(false);
            this.index = ko.observable(data.index);
            this.reviewState = ko.observable(data.reviewState);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.hasNotBeenViewedByUser = ko.computed(function () { return !_this.hasBeenViewedByUser(); });
            this.inserted = ko.observable(false);
            this.isEditEnabled = ko.observable(data.isEditEnabled);
            this.isOriginalStoredInFile = ko.observable(data.isOriginalStoredInFile);
            this.lastModifiedBy = ko.observable(data.lastModifiedBy);
            this.lastModifiedOn = ko.observable(data.lastModifiedOn);
            this.name = ko.observable(data.name);
            this.redactionsCount = ko.observable(data.redactionsCount);
            this.signedDocumentsCount = ko.observable(data.signedDocumentsCount);
            this.references = ko.observable(data.references);
            this.selected = ko.observable(false);
            this.type = ko.observable(data.type);
            this.typeId = ko.observable(data.typeId);
            this.typeName = ko.observable(data.typeName);
            this.versionsCount = ko.observable(data.versionsCount);
            this.isCourtFiling = ko.observable(data.isCourtFiling);
            this.sources = ko.observable(data.sources);
            this.isRestricted = ko.observable(data.isRestricted);
            this.isSuitableForRelease = ko.observable(data.isSuitableForRelease);
            this.isNotSuitableForRelease = ko.pureComputed(function () { return !_this.isSuitableForRelease(); });
            this.numRedactionsSuitableForRelease = ko.observable(data.numRedactionsSuitableForRelease);
            this.isFileValid = ko.observable(data.isFileValid);
            this.fileValidationError = ko.observable(data.fileValidationError);
            this.isFileMissing = ko.observable(data.isFileMissing);
            this.filedOn = ko.observable(data.filedOn);
            this.ocrStatus = ko.observable(data.ocrStatus);
            this.ocrRequestUrl = data.ocrRequestUrl;
            this.ocrPollUrl = data.ocrPollUrl;
            this.isRestricted = ko.observable(data.isRestricted);
            this.manageSecurityUrl = data.manageSecurityUrl;
            this.restrictUrl = data.restrictUrl;
            this.derestrictUrl = data.derestrictUrl;
            this.grantAccessUrl = data.grantAccessUrl;
            this.revokeAccessUrl = data.revokeAccessUrl;
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
            this.deleted.subscribe(function (value) {
                if (value) {
                    Pb.raiseEvent('document.rowRemoved', '', { document: _this });
                }
            });
            this.isDragging = ko.observable(false);
            this.isShowingFolder = ko.pureComputed(function () {
                var binderContext = _this.getSelectedBinderContext();
                return binderContext.selectedBinderId
                    && binderContext.selectedFolderId
                    && !binderContext.isSelectedFolderFilesNotInBinder;
            });
            this.isShowingNonReadonlyFolder = ko.pureComputed(function () {
                var binderContext = _this.getSelectedBinderContext();
                if (!binderContext.selectedBinder())
                    return true;
                return _this.isShowingFolder() && !binderContext.selectedBinder().isReadonly();
            });
            this.canOpenInEditor = ko.computed(function () {
                return _this.isEditEnabled() && _this.redactionsCount() === 0 && _this.actions.canOpenInEditor;
            });
            this.viewDocumentPermissionLink = {
                canPerformAction: this.actions.canViewDocument,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    Pb.openDocumentInNewWindow(_this.actions.documentOpenUrl);
                }
            };
            this.viewDocumentReferencesPermissionLink = {
                canPerformAction: this.actions.canViewDocumentReferences,
                onClick: function (e) {
                    Pb.openDocumentInNewWindow(_this.actions.documentReferencesUrl);
                }
            };
            this.viewDocumentVersionsPermissionLink = {
                canPerformAction: this.actions.canViewDocumentVersions,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    Pb.openDocumentInNewWindow(_this.actions.documentVersionsUrl);
                }
            };
            this.viewDocumentRedactionsPermissionLink = {
                canPerformAction: this.actions.canViewDocumentRedactions,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    Pb.openDocumentInNewWindow(_this.actions.documentRedactionsUrl);
                }
            };
            this.viewDocumentSignedDocumentsPermissionLink = {
                canPerformAction: this.actions.canViewDocumentSignedDocuments,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    Pb.openDocumentInNewWindow(_this.actions.documentSignedDocumentsUrl);
                }
            };
        }
        DocumentRowVm.prototype.update = function (data) {
            this.active(data.active);
            this.activityFrom(data.activityFrom);
            this.activityThru(data.activityThru);
            this.areRedactionsEnabled(data.areRedactionsEnabled);
            this.areSignedDocumentsEnabled(data.areSignedDocumentsEnabled);
            this.deleted(data.deleted);
            this.description(data.description);
            this.isDescriptionPreformatted(data.isDescriptionPreformatted);
            this.documentVersionId(data.documentVersionId);
            this.fileExtension(data.fileExtension);
            this.fileExtensionClass(data.fileExtensionClass);
            this.fileExtensionTitle(data.fileExtensionTitle);
            this.isConfidential(data.isConfidential);
            this.fileSize(data.fileSize);
            this.formattedAttachmentCount(data.formattedAttachmentCount);
            this.formattedAttachmentName(data.formattedAttachmentName);
            this.groupId(data.groupId);
            this.groupName(data.groupName);
            this.hidden(data.hidden);
            this.index(data.index);
            this.reviewState(data.reviewState);
            this.hasBeenViewedByUser(data.hasBeenViewedByUser);
            this.inserted(data.inserted);
            this.isEditEnabled(data.isEditEnabled);
            this.isOriginalStoredInFile(data.isOriginalStoredInFile);
            this.lastModifiedBy(data.lastModifiedBy);
            this.lastModifiedOn(data.lastModifiedOn);
            this.name(data.name);
            this.order(data.order);
            this.redactionsCount(data.redactionsCount);
            this.signedDocumentsCount(data.signedDocumentsCount);
            this.references(data.references);
            this.type(data.type);
            this.typeId(data.typeId);
            this.typeName(data.typeName);
            this.versionsCount(data.versionsCount);
            this.isCourtFiling(data.isCourtFiling);
            this.sources(data.sources);
            this.ocrStatus(data.ocrStatus);
            this.isRestricted(data.isRestricted);
            this.isSuitableForRelease(data.isSuitableForRelease);
            this.numRedactionsSuitableForRelease(data.numRedactionsSuitableForRelease);
            this.isFileValid(data.isFileValid);
            this.fileValidationError(data.fileValidationError);
            this.isFileMissing(data.isFileMissing);
            this.filedOn(data.filedOn);
            this.contextMenu(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        };
        ;
        DocumentRowVm.prototype.viewDetails = function (contextMenuItemVm, e) {
            window.location.href = contextMenuItemVm.source.linkUrl;
        };
        DocumentRowVm.prototype.editProperties = function (contextMenuItemVm, e) {
            var dialog = new Pb.EditDocumentDialog({
                editDocumentUrl: contextMenuItemVm.source.linkUrl,
                loadingElement: $(e.target)
            });
            dialog.open();
        };
        DocumentRowVm.prototype.open = function (contextMenuItemVm, e) {
            Pb.openDocumentInNewWindow(contextMenuItemVm.source.linkUrl);
        };
        DocumentRowVm.prototype.download = function (contextMenuItemVm, e) {
            this.hasBeenViewedByUser(true);
            window.location.href = contextMenuItemVm.source.linkUrl;
        };
        return DocumentRowVm;
    }());
    Pb.DocumentRowVm = DocumentRowVm;
    function isDocumentRowVm(documentRowVm) {
        return documentRowVm.discriminator !== 'Folder'
            && documentRowVm.discriminator !== 'LocalFileStore'
            && documentRowVm.discriminator !== 'MatrixFileStore'
            && documentRowVm.isFileMissing !== undefined;
    }
    Pb.isDocumentRowVm = isDocumentRowVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentExplorer;
    (function (DocumentExplorer) {
        var ActionsVm = (function () {
            function ActionsVm(parent, permissions, isFolderSelected, hasDocuments) {
                this.createNewDocumentDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canCreateDocument,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        }
                    ]
                };
                this.createNewDocumentFromScanningDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canCreateDocumentFromScanning,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        }
                    ]
                };
                this.newFolderDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canCreateFolder,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        }
                    ],
                    onClick: function () { return parent.newFolder(); }
                };
                this.editFolderDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canUpdateFolder,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        },
                        {
                            canPerformAction: isFolderSelected,
                            cannotPerformMessage: 'There is no folder selected.'
                        }
                    ],
                    onClick: function () { return parent.editFolder(); }
                };
                this.deleteFolderDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canDeleteFolder,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        },
                        {
                            canPerformAction: isFolderSelected,
                            cannotPerformMessage: 'There is no folder selected.'
                        }
                    ],
                    onClick: function () { return parent.deleteFolder(); }
                };
                this.downloadAllDisableAction = {
                    conditions: [
                        {
                            canPerformAction: permissions.canDownloadDocument,
                            cannotPerformMessage: 'You do not have permission to execute this action.'
                        },
                        {
                            canPerformAction: hasDocuments,
                            cannotPerformMessage: 'There are no files to download.'
                        }
                    ],
                    onClick: function () { return parent.downloadAll(); }
                };
            }
            return ActionsVm;
        }());
        DocumentExplorer.ActionsVm = ActionsVm;
        var DocumentExplorerMultiselectContextMenu = (function (_super) {
            __extends(DocumentExplorerMultiselectContextMenu, _super);
            function DocumentExplorerMultiselectContextMenu(root, gridVm, getSelectedBinderContext, menuItems) {
                var _this = _super.call(this, gridVm, getSelectedBinderContext, menuItems) || this;
                _this.super_getDownloadData = _this.getDownloadData;
                _this.getDownloadData = function () {
                    _this.super_getDownloadData();
                    $(".download-selection-form #folderIdentifier").val(_this.root.documentListIdentifier());
                };
                _this.super_getRecycleData = _this.getRecycleData;
                _this.getRecycleData = function () {
                    var data = _this.super_getRecycleData();
                    data.folderIdentifier = _this.root.documentListIdentifier();
                    return data;
                };
                _this.super_getRestoreData = _this.getRestoreData;
                _this.getRestoreData = function () {
                    var data = _this.super_getRestoreData();
                    data.folderIdentifier = _this.root.documentListIdentifier();
                    return data;
                };
                _this.super_getDeleteData = _this.getDeleteData;
                _this.getDeleteData = function () {
                    var data = _this.super_getDeleteData();
                    data.folderIdentifier = _this.root.documentListIdentifier();
                    return data;
                };
                _this.moveToFolder = function (contextMenuItemVm, e) {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        data: {
                            folderIdentifier: _this.root.documentListIdentifier()
                        },
                        afterRemote: function (data) {
                            new DocumentExplorer.MoveToFolderDialog(_this.gridVm.selectedDocuments(), data).open();
                        }
                    });
                };
                _this.root = root;
                return _this;
            }
            return DocumentExplorerMultiselectContextMenu;
        }(Pb.DocumentsGridMultiselectContextMenu));
        DocumentExplorer.DocumentExplorerMultiselectContextMenu = DocumentExplorerMultiselectContextMenu;
        var DocumentExplorerDocumentRowVm = (function (_super) {
            __extends(DocumentExplorerDocumentRowVm, _super);
            function DocumentExplorerDocumentRowVm(data, displayVm, getSelectedBinderContext) {
                var _this = _super.call(this, data, displayVm, getSelectedBinderContext) || this;
                _this.super_restore = _this.restore;
                _this.restore = function (contextMenuItemVm, e) {
                    Pb.Confirmation.show({
                        title: 'Restore File?',
                        message: 'Are you sure you want to restore this file?', yesCaption: 'Restore', noCaption: 'Cancel',
                        callback: function () {
                            $.get(contextMenuItemVm.source.linkUrl)
                                .done(function (data, textStatus, xhr) { return _this.openRestoreDialog(data); })
                                .fail(function (xhr, textStatus, errorThrown) { return console.error("Failed to restore document: " + textStatus + " - " + errorThrown); });
                        }
                    });
                };
                _this.openRestoreDialog = function (data) {
                    var viewModel = new RestoreDocumentViewModel(data, function (result) {
                        result.documents = [_this];
                        Pb.raiseEvent('document.restored', 'Document restored.', result);
                    });
                    var $content = $("<div data-bind=\"template: { name: 'document-explorer-restore-document-ko-dialog' }\" data-dialog-width=\"50em\"></div>");
                    ko.applyBindings(viewModel, $content[0]);
                    Pb.Dialog.open({ content: $content, confirmUnload: true });
                };
                _this.moveToFolder = function (contextMenuItemVm, e) {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        afterRemote: function (data) {
                            new DocumentExplorer.MoveToFolderDialog([_this], data).open();
                        }
                    });
                };
                return _this;
            }
            return DocumentExplorerDocumentRowVm;
        }(Pb.DocumentRowVm));
        DocumentExplorer.DocumentExplorerDocumentRowVm = DocumentExplorerDocumentRowVm;
        var IndexViewModel = (function () {
            function IndexViewModel(data) {
                var _this = this;
                this.buildMultiselectContextMenu = function (gridVm, getSelectedBinderContext, menuItems) {
                    return new DocumentExplorerMultiselectContextMenu(_this, gridVm, getSelectedBinderContext, menuItems);
                };
                this.wireupEvents = function () {
                    Pb.on('document.searched', function (e, eventData) { return _this.onDocumentSearch(eventData.data); });
                    Pb.on('document.created', function (e, eventData) { return _this.onDocumentCreated(eventData.data); });
                    Pb.on('document.updated', function (e, eventData) { return _this.onDocumentUpdated(eventData.data); });
                    Pb.on('document.recycled', function (e, eventData) {
                        _this.onDocumentRecycled(eventData.data);
                        _this.flashMessage(eventData.data, eventData.friendlyEventName);
                    });
                    Pb.on('document.restored', function (e, eventData) {
                        _this.onDocumentRestored(eventData.data);
                        _this.flashMessage(eventData.data, eventData.friendlyEventName);
                    });
                    Pb.on('document.deleted', function (e, eventData) {
                        _this.onDocumentDeleted(eventData.data);
                        _this.flashMessage(eventData.data, eventData.friendlyEventName);
                    });
                };
                this.beforeSearch = function () {
                    _this.searching(true);
                    _this.displayVm().update({ documents: [] });
                };
                this.search = function (filterData) {
                    _this.beforeSearch();
                    var filterArgs = ko.toJS(filterData || _this.filterVm.data);
                    var displayArgs = _this.displayVm().getSearchArgs();
                    var args = __assign({ folderIdentifier: _this.documentListIdentifier() }, filterArgs, { displayMode: _this.displayMode() }, displayArgs);
                    $.get(_this.urls.indexUrl, args, function (data) {
                        _this.afterSearch();
                        Pb.raiseEvent('document.searched', 'Search completed.', data);
                    });
                };
                this.afterSearch = function () {
                    _this.searching(false);
                };
                this.onDocumentSearch = function (data) {
                    _this.filterTabs.update(data.filterTabs);
                    _this.filterVm.pager.update(data.pager);
                    _this.filterResultsMessage.update(data.filterResultsMessage);
                    if (_this.displayVm().displayMode !== _this.displayMode()) {
                        _this.displayVm().dispose();
                        _this.displayVm(_this.displayVmFactory.createDisplayVm(_this.displayMode(), data.searchResults));
                        if (_this.displayVm().displayMode === Pb.DocumentsDisplayMode.List) {
                            Pb.Grid.initializeScrollingGrid($('.grid-full'));
                        }
                    }
                    _this.displayVm().update(data.searchResults);
                };
                this.onDocumentCreated = function (data) {
                    var promises = [];
                    if (data.documents) {
                        for (var _i = 0, _a = data.documents; _i < _a.length; _i++) {
                            var result = _a[_i];
                            promises.push(_this.getDocumentRow(result));
                        }
                    }
                    else {
                        promises.push(_this.getDocumentRow(data));
                    }
                    Promise.all(promises).then(function (values) {
                        var sortedValues = values.sort(function (a, b) { return a - b; });
                        for (var _i = 0, sortedValues_1 = sortedValues; _i < sortedValues_1.length; _i++) {
                            var value = sortedValues_1[_i];
                            var existingRow = _this.displayVm().getDocumentById(value.id);
                            if (existingRow) {
                                _this.updateExistingDocumentRow(value);
                            }
                            else {
                                _this.addNewDocumentRow(value);
                                _this.filterResultsMessage.increment({ results: 1, total: 1 });
                            }
                        }
                    });
                };
                this.getDocumentRow = function (data) {
                    if (_this.selectedFolderId() === data.documentFolderId) {
                        var args_1 = {
                            documentId: data.documentId,
                            folderIdentifier: _this.documentListIdentifier()
                        };
                        return new Promise(function (resolve) {
                            $.getJSON(_this.urls.getDocumentUrl, args_1, function (rowData) { return resolve(rowData); });
                        });
                    }
                };
                this.onDocumentUpdated = function (data) {
                    if (_this.selectedFolderId() == data.documentFolderId) {
                        var args = {
                            documentId: data.id,
                            folderIdentifier: _this.documentListIdentifier()
                        };
                        $.getJSON(_this.urls.getDocumentUrl, args, function (documentData) {
                            _this.displayVm().updateDocument(data.documentId, documentData);
                        });
                    }
                    else {
                        var document_1 = _this.displayVm().getDocumentById(data.documentId);
                        document_1.deleted(true);
                        _this.filterResultsMessage.decrement({ results: 1, total: 1 });
                        Pb.FlashMessage.show("Document moved to folder " + data.documentFolderName + ".");
                    }
                };
                this.onDocumentRecycled = function (data) {
                    if (data.error) {
                        var messageTitle = data.isMultiselect
                            ? 'Some documents could not be recycled'
                            : 'Document may not be recycled';
                        _this.showErrorMessage(messageTitle, data.error);
                    }
                    _.each(data.documents, function (document) {
                        document.deleted(true);
                        _this.filterResultsMessage.decrement({ results: 1, total: 1 });
                    });
                };
                this.onDocumentRestored = function (data) {
                    if (data.error) {
                        _this.showErrorMessage('Error', data.error);
                    }
                    _.each(data.documents, function (document) {
                        document.deleted(true);
                        _this.filterResultsMessage.decrement({ results: 1, total: 1 });
                    });
                };
                this.onDocumentDeleted = function (data) {
                    if (data.error) {
                        var messageTitle = data.isMultiselect
                            ? 'Some documents may not be deleted'
                            : 'Document may not be deleted';
                        _this.showErrorMessage(messageTitle, data.error);
                    }
                    _.each(data.documents, function (document) {
                        document.deleted(true);
                        _this.filterResultsMessage.decrement({ results: 1, total: 1 });
                    });
                };
                this.onDisplayDocumentAdded = function (document) {
                    var groupTab = _this.filterTabs.findByKey("" + document.groupId()) || _this.createGroupFilterTab(document);
                    var typeTab = groupTab.findByKey("" + document.typeId()) || _this.createTypeFilterTab(groupTab, document);
                    typeTab.incrementCount();
                };
                this.onDisplayDocumentRemoved = function (document) {
                    var groupTab = _this.filterTabs.findByKey("" + document.groupId());
                    var typeTab = groupTab.findByKey("" + document.typeId());
                    typeTab.decrementCount({ removeIfEmpty: true });
                };
                this.createGroupFilterTab = function (document) {
                    return _this.filterTabs.addTab({
                        key: "" + document.groupId(),
                        label: document.groupName(),
                        isActive: false,
                        isGroup: true,
                        isAll: false,
                        count: 0,
                        hasTypes: false,
                        fixedCount: null,
                        displayLabel: document.groupName(),
                        tabs: []
                    });
                };
                this.createTypeFilterTab = function (group, document) {
                    return group.addTab({
                        key: "" + document.typeId(),
                        label: document.typeName(),
                        isActive: false,
                        isGroup: false,
                        isAll: false,
                        count: 0,
                        hasTypes: false,
                        fixedCount: null,
                        displayLabel: document.typeName(),
                        tabs: []
                    });
                };
                this.onFilterTabClick = function (vm, e) {
                    if (!e.isDefaultPrevented()) {
                        _this.filterVm.tab(vm);
                    }
                };
                this.getSelectedBinderContext = function () {
                    return {
                        selectedBinder: ko.pureComputed(function () { return null; }),
                        selectedBinderId: null,
                        selectedFolderId: _this.selectedFolderId(),
                        isSelectedFolderFilesNotInBinder: false,
                        isShowingFolders: ko.pureComputed(function () { return false; })
                    };
                };
                this.onCreateNewDocument = function (vm, e) {
                    var dialog = new Pb.CreateDocumentDialog({
                        newDocumentUrl: _this.urls.newDocumentUrl,
                        folderId: _this.selectedFolderId(),
                        binderId: _this.getSelectedBinderContext().selectedBinderId,
                        loadingElement: $(e.target)
                    });
                    dialog.open();
                };
                this.onCreateNewDocumentFromScanning = function (vm, e) {
                    window.open("" + _this.urls.newDocumentFromScanningUrl + (vm.selectedFolderId() ? "?folderId=" + vm.selectedFolderId() : ''));
                };
                this.addNewDocumentRow = function (documentData) {
                    _this.displayVm().addDocument(documentData);
                };
                this.updateExistingDocumentRow = function (data) {
                    _this.displayVm().updateDocument(data.id, data);
                };
                this.newFolder = function () {
                    $.get(_this.urls.newFolderUrl, { parentFolderId: _this.selectedFolderId() })
                        .done(function (data, textStatus, xhr) { return _this.handleNewFolderResponse(data); })
                        .fail(function (xhr, textStatus, errorThrown) { return console.error("Failed to create folder: " + textStatus + " - " + errorThrown); });
                };
                this.handleNewFolderResponse = function (data) {
                    if (data.hasError) {
                        _this.showMissingFolderMessage(data);
                    }
                    else {
                        _this.openNewDialog(data);
                    }
                };
                this.openNewDialog = function (data) {
                    var viewModel = new CreateFolderViewModel(data, _this.onFolderCreated);
                    _this.openDialog('document-explorer-new-folder-ko-dialog', viewModel);
                };
                this.onFolderCreated = function (folderId) {
                    $.get(_this.urls.foldersUrl)
                        .done(function (data, textStatus, xhr) {
                        _this.refreshFolders({
                            documentFolderNodes: data.documentFolderNodes,
                            documentListIdentifier: "" + folderId
                        });
                        Pb.FlashMessage.show("Folder created.");
                    });
                };
                this.editFolder = function () {
                    $.get(_this.urls.editFolderUrl, { folderId: _this.selectedFolderId() })
                        .done(function (data, textStatus, xhr) { return _this.handleEditFolderResponse(data); })
                        .fail(function (xhr, textStatus, errorThrown) { return console.error("Failed to edit folder: " + textStatus + " - " + errorThrown); });
                };
                this.handleEditFolderResponse = function (data) {
                    if (data.hasError) {
                        _this.showMissingFolderMessage(data);
                    }
                    else {
                        _this.openEditDialog(data);
                    }
                };
                this.openEditDialog = function (data) {
                    var viewModel = new UpdateFolderViewModel(data, _this.onFolderUpdateSucceeded, _this.onFolderUpdateFailed);
                    _this.openDialog('document-explorer-edit-folder-ko-dialog', viewModel);
                };
                this.onFolderUpdateSucceeded = function (folderId) {
                    $.get(_this.urls.foldersUrl)
                        .done(function (data, textStatus, xhr) {
                        _this.refreshFolders({
                            documentFolderNodes: data.documentFolderNodes,
                            documentListIdentifier: "" + folderId
                        });
                        Pb.FlashMessage.show("Folder saved.");
                    });
                };
                this.onFolderUpdateFailed = function (data) {
                    Pb.MessageBox.show(__assign({}, data.messageBoxData, { callback: function () { return _this.refreshFolders(data); } }));
                };
                this.deleteFolder = function () {
                    Pb.Confirmation.show({
                        title: "Delete Folder?",
                        message: "Are you sure you want to delete this folder and any subfolders and documents it contains?",
                        yesCaption: "Delete",
                        noCaption: "Cancel",
                        callback: function () {
                            $.post(_this.urls.deleteFolderUrl, { folderId: _this.selectedFolderId() })
                                .done(function (data, textStatus, xhr) { return _this.handleDeleteFolderResponse(data); })
                                .fail(function (xhr, textStatus, errorThrown) { return console.error("Failed to delete folder: " + textStatus + " - " + errorThrown); });
                        }
                    });
                };
                this.downloadAll = function () {
                    $(".download-all-form #folderIdentifier").val(_this.documentListIdentifier());
                    $(".download-all-form #filter").val(ko.toJSON(_this.filterVm.data));
                    $(".download-all-form .submit-all-downloads").click();
                };
                this.handleDeleteFolderResponse = function (data) {
                    if (data.hasError) {
                        _this.showMissingFolderMessage(data);
                    }
                    else {
                        _this.refreshFolders(data);
                        Pb.FlashMessage.show("Folder deleted.");
                    }
                };
                this.showMissingFolderMessage = function (data) {
                    Pb.MessageBox.show(__assign({}, data.messageBoxData, { callback: function () { return _this.refreshFolders(data); } }));
                };
                this.refreshFolders = function (data) {
                    _this.documentFolderNodes(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                    _this.documentListIdentifier(data.documentListIdentifier);
                };
                this.documentListIdentifier = ko.observable(data.documentListIdentifier);
                this.documentFolderNodes = ko.observableArray(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                this.urls = data.urls;
                this.searching = ko.observable(false);
                this.showEmptyMessageWithAddLink = ko.pureComputed(function () {
                    return !_this.filterVm.isRecycled() && !_this.filterVm.isSearch();
                });
                this.emptyMessageText = ko.pureComputed(function () {
                    return _this.filterVm.isRecycled()
                        ? "No recycled documents found."
                        : "No documents were returned with the current filter.";
                });
                this.isToggleDisplayModeEnabled = data.displayModes.length > 1;
                this.displayMode = ko.observable(data.displayMode);
                this.displayMode.subscribe(function (newDisplayMode) { return _this.search(); });
                this.filterVm = new Pb.DocumentsFilterVm(data.filterData, data.pagerData, this);
                this.filterResultsMessage = new Pb.FilterResultsMessageVm(data.filterResultsMessageData);
                this.filterTabs = new Pb.FilterTabsVm(data.tabData);
                this.displayVmFactory = new Pb.DocumentDisplayVmFactory(data.displayModes, this, this.urls, this.filterVm, null, this.getSelectedBinderContext, this.onDisplayDocumentAdded, this.onDisplayDocumentRemoved, this.buildDocumentRow, undefined, this.buildMultiselectContextMenu);
                this.displayVm = ko.observable(this.displayVmFactory.createDisplayVm(data.displayMode, data.documents));
                this.selectedFolderId = ko.computed(function () {
                    var folderId = parseInt(_this.documentListIdentifier());
                    return isNaN(folderId) ? null : folderId;
                });
                this.isFolderSelected = ko.computed(function () { return !!_this.selectedFolderId(); });
                this.hasDocuments = ko.computed(function () { return _this.displayVm().resultsCount() > 0; });
                this.actionsVm = new ActionsVm(this, data.permissions, this.isFolderSelected, this.hasDocuments);
                this.isScanningEnabled = data.isScanningEnabled;
                this.displayVm().update(data.documents);
                this.wireupEvents();
                this.documentListIdentifier.subscribe(function (newDocumentListIdentifier) {
                    _this.filterVm.data.isRecycled(newDocumentListIdentifier === 'Recycle Bin');
                    _this.search();
                });
            }
            IndexViewModel.prototype.buildDocumentRow = function (data, displayVm, getSelectedBinderContext) {
                return new DocumentExplorerDocumentRowVm(data, displayVm, getSelectedBinderContext);
            };
            IndexViewModel.prototype.flashMessage = function (data, message) {
                if (!data.error && !data.suppressFlashMessage) {
                    Pb.FlashMessage.show(message);
                }
            };
            IndexViewModel.prototype.showErrorMessage = function (title, message) {
                Pb.MessageBox.show({
                    title: title,
                    message: message,
                });
            };
            ;
            IndexViewModel.prototype.openDialog = function (templateName, viewModel) {
                var $content = $("<div data-bind=\"template: { name: '" + templateName + "' }\" data-dialog-width=\"50em\"></div>");
                ko.applyBindings(viewModel, $content[0]);
                Pb.Dialog.open({ content: $content, confirmUnload: true });
            };
            return IndexViewModel;
        }());
        DocumentExplorer.IndexViewModel = IndexViewModel;
        var CreateFolderViewModel = (function () {
            function CreateFolderViewModel(data, onFolderCreated) {
                var _this = this;
                this.update = function (data) {
                    _this.documentFolderNodes(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                    _this.parentFolderId(data.parentFolderId);
                    _this.name(data.name);
                };
                this.onCreateFolder = function (vm, e) {
                    $(e.target).remote({
                        url: _this.createFolderUrl,
                        method: 'POST',
                        data: {
                            name: _this.name(),
                            parentFolderId: _this.parentFolderId()
                        },
                        afterRemote: _this.handleCreateResponse
                    });
                };
                this.handleCreateResponse = function (response) {
                    if (response.hasError) {
                        _this.errors(response.errors);
                        if (response.viewModel) {
                            _this.update(response.viewModel);
                        }
                    }
                    else if (response.errors) {
                        _this.errors(response.errors);
                    }
                    else {
                        Pb.Dialog.close();
                        _this.onFolderCreated(response.id);
                    }
                };
                this.documentFolderNodes = ko.observableArray(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                this.hasParentFolders = this.documentFolderNodes().length > 0;
                this.parentFolderPlaceholder = data.parentFolderPlaceholder;
                this.createFolderUrl = data.createFolderUrl;
                this.name = ko.observable(data.name);
                this.parentFolderId = ko.observable(data.parentFolderId);
                this.errors = ko.observable({});
                this.onFolderCreated = onFolderCreated;
            }
            return CreateFolderViewModel;
        }());
        DocumentExplorer.CreateFolderViewModel = CreateFolderViewModel;
        var UpdateFolderViewModel = (function () {
            function UpdateFolderViewModel(data, onFolderUpdateSucceeded, onFolderUpdateFailed) {
                var _this = this;
                this.update = function (data) {
                    _this.documentFolderNodes(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                    _this.parentFolderId(data.parentFolderId);
                    _this.name(data.name);
                };
                this.onUpdateFolder = function (vm, e) {
                    $(e.target).remote({
                        url: _this.updateFolderUrl,
                        method: 'POST',
                        data: {
                            name: _this.name(),
                            parentFolderId: _this.parentFolderId()
                        },
                        afterRemote: _this.handleUpdateResponse
                    });
                };
                this.handleUpdateResponse = function (response) {
                    if (response.hasError) {
                        Pb.Dialog.close();
                        _this.onFolderUpdateFailed(response);
                    }
                    else if (response.errors) {
                        _this.errors(response.errors);
                        if (response.viewModel) {
                            _this.update(response.viewModel);
                        }
                    }
                    else {
                        Pb.Dialog.close();
                        _this.onFolderUpdateSucceeded(response.id);
                    }
                };
                this.documentFolderNodes = ko.observableArray(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                this.hasParentFolders = this.documentFolderNodes().length > 0;
                this.parentFolderPlaceholder = data.parentFolderPlaceholder;
                this.updateFolderUrl = data.updateFolderUrl;
                this.folderId = data.folderId;
                this.name = ko.observable(data.name);
                this.parentFolderId = ko.observable(data.parentFolderId);
                this.errors = ko.observable({});
                this.onFolderUpdateSucceeded = onFolderUpdateSucceeded;
                this.onFolderUpdateFailed = onFolderUpdateFailed;
            }
            return UpdateFolderViewModel;
        }());
        DocumentExplorer.UpdateFolderViewModel = UpdateFolderViewModel;
        var RestoreDocumentViewModel = (function () {
            function RestoreDocumentViewModel(data, onDocumentRestored) {
                var _this = this;
                this.onRestore = function (vm, e) {
                    $(e.target).remote({
                        url: _this.saveUrl,
                        method: 'POST',
                        data: { documentFolderId: _this.documentFolderId() },
                        afterRemote: _this.handleRestoreResponse
                    });
                };
                this.handleRestoreResponse = function (response) {
                    if (response.errors) {
                        _this.errors(response.errors);
                    }
                    else {
                        Pb.Dialog.close();
                        if (_this.onDocumentRestored) {
                            _this.onDocumentRestored(response);
                        }
                    }
                };
                this.documentFolderId = ko.observable(data.documentFolderId);
                this.documentFolderNodes = ko.observableArray(data.documentFolderNodes.map(function (m) { return new Pbs.Web.DropDowns.SelectTreeNode(m); }));
                this.recycledFromPath = ko.observable(data.recycledFromPath);
                this.saveUrl = data.saveUrl;
                this.errors = ko.observable({});
                this.onDocumentRestored = onDocumentRestored;
            }
            return RestoreDocumentViewModel;
        }());
        DocumentExplorer.RestoreDocumentViewModel = RestoreDocumentViewModel;
    })(DocumentExplorer = Pb.DocumentExplorer || (Pb.DocumentExplorer = {}));
})(Pb || (Pb = {}));
var MatrixDocs;
(function (MatrixDocs) {
    var PreviewApi = (function () {
        function PreviewApi() {
        }
        PreviewApi.prototype.isPdfAvailable = function (url, callback, data) {
            $.get(url, data, callback);
        };
        ;
        PreviewApi.prototype.requestConversion = function (url, data) {
            $.post(url, data);
        };
        return PreviewApi;
    }());
    MatrixDocs.PreviewApi = PreviewApi;
    var PreviewUi = (function () {
        function PreviewUi($iframeContainer) {
            var _this = this;
            this.startSpinner = function () {
                _this.$spinner.loading({
                    lines: 8,
                    length: 12,
                    width: 6,
                    radius: 12,
                    shadow: false
                });
            };
            this.stopSpinner = function () {
                _this.$spinner.doneLoading();
            };
            this.appendFrame = function (viewUrl, onFrameLoaded) {
                var $existingFrame = $('#view-document', _this.$iframeContainer);
                if ($existingFrame.length > 0) {
                    $existingFrame[0].src = viewUrl;
                }
                else {
                    var $frame = $("<iframe id='view-document' src='" + viewUrl + "'></iframe>");
                    $frame.on('load', onFrameLoaded);
                    _this.$iframeContainer.append($frame);
                }
            };
            this.$iframeContainer = $iframeContainer;
            this.$spinner = $('#preview-spinner');
        }
        return PreviewUi;
    }());
    MatrixDocs.PreviewUi = PreviewUi;
    function loadPreview(api, ui, pdfUrl, isPdfAvailableUrl, requestConversionUrl, data) {
        var whenPdfIsAvailable = function (action) {
            var isPdfAvailableCallback = function (isPdfAvailable) {
                if (isPdfAvailable) {
                    action();
                }
                else {
                    setTimeout(whenPdfIsAvailable, 1000, action);
                }
            };
            api.isPdfAvailable(isPdfAvailableUrl, isPdfAvailableCallback, data);
        };
        var displayPdf = function () {
            if (data) {
                var keys = _.keys(data);
                _.each(keys, function (key) {
                    pdfUrl = Pb.UrlBuilder.addQuery(pdfUrl, key, data[key]);
                });
            }
            ui.appendFrame(pdfUrl, ui.stopSpinner);
        };
        ui.startSpinner();
        if (requestConversionUrl) {
            api.requestConversion(requestConversionUrl, data);
        }
        whenPdfIsAvailable(displayPdf);
    }
    MatrixDocs.loadPreview = loadPreview;
})(MatrixDocs || (MatrixDocs = {}));
var Pb;
(function (Pb) {
    var DocumentThumbnailVm = (function () {
        function DocumentThumbnailVm(data, displayVm, getSelectedBinderContext) {
            var _this = this;
            this.viewDocument = function (vm, e) {
                if (_this.actions.canViewDocument) {
                    _this.openDocumentEditor(_this.actions.documentOpenUrl);
                }
            };
            this.addOrMoveToFolder = function (contextMenuItemVm, e) {
                Pb.AddOrMoveDocumentsToFolderDialog.open({
                    addOrMoveDocumentsToFolderUrl: contextMenuItemVm.source.linkUrl,
                    documentIds: [_this.id],
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.getSelectedBinderContext().selectedFolderId,
                    loadingElement: $(e.target)
                });
            };
            this.removeDocumentFromFolder = function (contextMenuItemVm, e) {
                var onRemoveDocumentFromFolder = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        data: { documentFolderId: _this.getSelectedBinderContext().selectedFolderId },
                        method: 'post',
                        afterRemote: afterRemoveDocumentFromFolder
                    });
                };
                var afterRemoveDocumentFromFolder = function (result) {
                    Pb.raiseEvent('document.removedFromFolder', 'Document removed from folder.', {
                        documentIds: [_this.id],
                        folderId: Pb.CustomFolderTree.notInBinderId,
                        binderId: _this.getSelectedBinderContext().selectedBinderId
                    });
                };
                Pb.Confirmation.show({
                    title: 'Remove File from Folder?',
                    message: 'Are you sure you want to remove this file from the current folder?',
                    yesCaption: 'Remove', noCaption: 'Cancel',
                    callback: onRemoveDocumentFromFolder
                });
            };
            this.manageAttachments = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: _this.actions.documentChildAttachmentsUrl,
                    afterRemote: Pb.DocumentChildAttachments.showAttachmentsDialog
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterRecycle
                    });
                };
                var afterRecycle = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.recycled', 'Document recycled.', result);
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'File', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterRestore
                    });
                };
                var afterRestore = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.restored', 'Document restored.', result);
                };
                Pb.Confirmation.show({
                    title: 'Restore File?',
                    message: 'Are you sure you want to restore this file?', yesCaption: 'Restore', noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.delete = function (contextMenuItemVm, e) {
                var onDelete = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'post',
                        afterRemote: afterDelete
                    });
                };
                var afterDelete = function (result) {
                    if (!result.error) {
                        result.documents = [_this];
                    }
                    Pb.raiseEvent('document.deleted', 'Document deleted.', result);
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'File', verb: 'Permanently Delete',
                    callback: onDelete
                });
            };
            this.editName = function () {
                if (_this.canEditProperties) {
                    _this.isEditingName(true);
                }
            };
            this.onEditNameKeydown = function (vm, evt) {
                if (evt.keyCode === 27) {
                    _this.editedName(_this.originalName);
                    _this.isEditingName(false);
                }
                else if (evt.keyCode === 13) {
                    _this.isEditingName(false);
                }
                else {
                    return true;
                }
            };
            this.updateName = function (vm) {
                if (vm.editedName() !== vm.originalName) {
                    var antiForgeryToken = Pb.JQueryAntiForgery.getToken();
                    var form = new FormData();
                    form.append(antiForgeryToken.name, antiForgeryToken.value);
                    form.append("Name", vm.editedName());
                    $.ajax({
                        url: _this.updateNameUrl,
                        data: form,
                        contentType: false,
                        processData: false,
                        method: 'POST',
                        success: function (data, textStatus, xhr) {
                            _this.originalName = _this.editedName();
                            _this.name(_this.editedName());
                        },
                        error: function (xhr, textStatus, errorThrown) {
                            _this.editedName(_this.originalName);
                            console.error(textStatus + ": " + errorThrown);
                        }
                    });
                }
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'post',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'post',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.markSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open([_this.id]);
            };
            this.undoSuitableForRelease = function (contextMenuItemVm, e) {
                var dialog = new Pb.MarkSuitableForReleaseDialog({
                    url: contextMenuItemVm.source.linkUrl,
                    loadingElement: $(e.target)
                });
                dialog.open([_this.id]);
            };
            this.displayVm = displayVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.left = ko.observable('0px');
            this.top = ko.observable('0px');
            this.discriminator = data.discriminator;
            this.key = data.key;
            this.id = data.id;
            this.documentVersionId = ko.observable(data.documentVersionId);
            this.name = ko.observable(data.name);
            this.description = ko.observable(data.description);
            this.typeId = ko.observable(data.typeId);
            this.typeName = ko.observable(data.typeName);
            this.groupId = ko.observable(data.groupId);
            this.groupName = ko.observable(data.groupName);
            this.index = ko.observable(data.index);
            this.source = ko.observable(data.source);
            this.fileExtension = ko.observable(data.fileExtension);
            this.fileExtensionClass = ko.observable(data.fileExtensionClass);
            this.fileExtensionTitle = ko.observable(data.fileExtensionTitle);
            this.isConfidential = ko.observable(data.isConfidential);
            this.fileSize = ko.observable(data.formattedFileSize);
            this.thumbnailId = ko.observable(data.thumbnailId);
            this.thumbnailWidth = ko.observable(data.thumbnailWidth);
            this.thumbnailHeight = ko.observable(data.thumbnailHeight);
            this.thumbnailUrl = ko.observable(data.thumbnailUrl);
            this.versionsCount = ko.observable(data.versionsCount);
            this.redactionsCount = ko.observable(data.redactionsCount);
            this.formattedDateReceived = ko.observable(data.formattedDateReceived);
            this.isOriginalStoredInFile = ko.observable(data.isOriginalStoredInFile);
            this.createdOn = data.createdOn;
            this.createdBy = data.createdBy;
            this.formattedCreated = this.createdBy + " on " + this.createdOn;
            this.lastModifiedOn = ko.observable(data.lastModifiedOn);
            this.lastModifiedBy = ko.observable(data.lastModifiedBy);
            this.formattedModified = ko.pureComputed(function () { return _this.lastModifiedBy() + " on " + _this.lastModifiedOn(); });
            this.thumbnailTemplateName = ko.pureComputed(function () { return _this.thumbnailId() ? "document-thumbnail" : "document-thumbnail-placeholder"; });
            this.displayWidth = ko.observable(this.thumbnailWidth());
            this.displayHeight = ko.observable(this.thumbnailHeight());
            this.displayWidthPx = ko.pureComputed(function () { return _this.displayWidth() + "px"; });
            this.displayHeightPx = ko.pureComputed(function () { return _this.displayHeight() + "px"; });
            this.formattedType = ko.pureComputed(function () { return _this.typeName() + " (" + _this.groupName() + ")"; });
            this.canEditProperties = data.canEditProperties;
            this.originalName = data.name;
            this.editedName = ko.observable(data.name);
            this.isEditingName = ko.observable(false);
            this.updateNameUrl = data.updateNameUrl;
            this.editPropertiesUrl = data.editPropertiesUrl;
            this.ocrStatus = ko.observable(data.ocrStatus);
            this.ocrRequestUrl = data.ocrRequestUrl;
            this.ocrPollUrl = data.ocrPollUrl;
            this.isRestricted = ko.observable(data.isRestricted);
            this.manageSecurityUrl = data.manageSecurityUrl;
            this.restrictUrl = data.restrictUrl;
            this.derestrictUrl = data.derestrictUrl;
            this.grantAccessUrl = data.grantAccessUrl;
            this.revokeAccessUrl = data.revokeAccessUrl;
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
            this.actions = data.actions;
            this.isEditEnabled = ko.observable(data.isEditEnabled);
            this.canOpenInEditor = ko.computed(function () {
                return _this.isEditEnabled() && _this.redactionsCount() === 0 && _this.actions.canOpenInEditor;
            });
            this.isShowingFolder = ko.pureComputed(function () {
                var binderContext = _this.getSelectedBinderContext();
                return binderContext.selectedBinderId
                    && binderContext.selectedFolderId
                    && !binderContext.isSelectedFolderFilesNotInBinder;
            });
            this.isShowingNonReadonlyFolder = ko.pureComputed(function () {
                var binderContext = _this.getSelectedBinderContext();
                if (!binderContext.selectedBinder())
                    return true;
                return _this.isShowingFolder() && !binderContext.selectedBinder().isReadonly();
            });
            this.selected = ko.observable(false);
            this.deleted = ko.observable(false);
            this.deleted.subscribe(function (newValue) {
                if (newValue) {
                    Pb.raiseEvent("document.rowRemoved", "", { document: _this });
                }
            });
            this.hidden = ko.observable(false);
            this.isDragging = ko.observable(false);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.hasNotBeenViewedByUser = ko.computed(function () { return !_this.hasBeenViewedByUser(); });
            this.isSuitableForRelease = ko.observable(data.isSuitableForRelease);
            this.isNotSuitableForRelease = ko.pureComputed(function () { return !_this.isSuitableForRelease(); });
            this.isFileValid = ko.observable(data.isFileValid);
            this.fileValidationError = ko.observable(data.fileValidationError);
        }
        DocumentThumbnailVm.prototype.update = function (data) {
            this.documentVersionId(data.documentVersionId);
            this.name(data.name);
            this.originalName = data.name;
            this.editedName(data.name);
            this.description(data.description);
            this.typeId(data.typeId);
            this.typeName(data.typeName);
            this.groupId(data.groupId);
            this.groupName(data.groupName);
            this.index(data.index);
            this.source(data.source);
            this.fileExtension(data.fileExtension);
            this.fileExtensionClass(data.fileExtensionClass);
            this.fileExtensionTitle(data.fileExtensionTitle);
            this.isConfidential(data.isConfidential);
            this.fileSize(data.formattedFileSize);
            this.thumbnailId(data.thumbnailId);
            this.thumbnailWidth(data.thumbnailWidth);
            this.thumbnailHeight(data.thumbnailHeight);
            this.thumbnailUrl(data.thumbnailUrl);
            this.versionsCount(data.versionsCount);
            this.redactionsCount(data.redactionsCount);
            this.formattedDateReceived(data.formattedDateReceived);
            this.isOriginalStoredInFile(data.isOriginalStoredInFile);
            this.lastModifiedOn(data.lastModifiedOn);
            this.lastModifiedBy(data.lastModifiedBy);
            this.isEditEnabled(data.isEditEnabled);
            this.ocrStatus(data.ocrStatus);
            this.isRestricted(data.isRestricted);
            this.contextMenu(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
            this.hasBeenViewedByUser(data.hasBeenViewedByUser);
            this.isSuitableForRelease(data.isSuitableForRelease);
            this.isFileValid(data.isFileValid);
            this.fileValidationError(data.fileValidationError);
        };
        ;
        DocumentThumbnailVm.prototype.open = function (contextMenuItemVm, e) {
            if (this.actions.canViewDocument) {
                this.openDocumentEditor(contextMenuItemVm.source.linkUrl);
            }
        };
        DocumentThumbnailVm.prototype.openDocumentEditor = function (url) {
            Pb.openDocumentInNewWindow(url);
        };
        DocumentThumbnailVm.prototype.download = function (contextMenuItemVm, e) {
            window.location.href = contextMenuItemVm.source.linkUrl;
        };
        DocumentThumbnailVm.prototype.editProperties = function (vm, e) {
            $(document).mouseup();
            var dialog = new Pb.EditDocumentDialog({
                editDocumentUrl: this.actions.documentEditUrl,
                loadingElement: $(e.target)
            });
            dialog.open();
        };
        return DocumentThumbnailVm;
    }());
    Pb.DocumentThumbnailVm = DocumentThumbnailVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentsDisplayMode;
    (function (DocumentsDisplayMode) {
        DocumentsDisplayMode["List"] = "List";
        DocumentsDisplayMode["Thumbnails"] = "Thumbnails";
        DocumentsDisplayMode["FullText"] = "FullText";
    })(DocumentsDisplayMode = Pb.DocumentsDisplayMode || (Pb.DocumentsDisplayMode = {}));
    var DocumentsDisplayModeConfigurationVm = (function () {
        function DocumentsDisplayModeConfigurationVm() {
        }
        return DocumentsDisplayModeConfigurationVm;
    }());
    Pb.DocumentsDisplayModeConfigurationVm = DocumentsDisplayModeConfigurationVm;
    var DocumentDisplayVmFactory = (function () {
        function DocumentDisplayVmFactory(displayModeConfigurations, searchesDocuments, actionUrls, filterVm, gridColumnHeadersVm, getSelectedBinderContext, onDisplayDocumentAdded, onDisplayDocumentRemoved, buildRowFactory, buildThumbnailFactory, buildMultiselectContextMenuFactory, folderRowFactory, folderThumbnailFactory, selectFolder, getAcceptedFileExtensions) {
            this.displayModeConfigurations = displayModeConfigurations;
            this.searchesDocuments = searchesDocuments;
            this.actionUrls = actionUrls;
            this.filterVm = filterVm;
            this.gridColumnHeadersVm = gridColumnHeadersVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.getAcceptedFileExtensions = getAcceptedFileExtensions;
            this.onDisplayDocumentAdded = onDisplayDocumentAdded;
            this.onDisplayDocumentRemoved = onDisplayDocumentRemoved;
            this.buildRowFactory = buildRowFactory;
            this.buildThumbnailFactory = buildThumbnailFactory;
            this.buildMultiselectContextMenuFactory = buildMultiselectContextMenuFactory;
            this.folderRowFactory = folderRowFactory;
            this.folderThumbnailFactory = folderThumbnailFactory;
            this.selectFolder = selectFolder;
        }
        DocumentDisplayVmFactory.prototype.createDisplayVm = function (displayMode, searchResults, thumbnailHeight) {
            var config = _.find(this.displayModeConfigurations, function (m) { return m.displayMode == displayMode; }).configuration;
            if (displayMode == DocumentsDisplayMode.Thumbnails) {
                return new Pb.DocumentThumbnailsVm(config, searchResults, this.searchesDocuments, this.actionUrls, this.getSelectedBinderContext, this.onDisplayDocumentAdded, this.onDisplayDocumentRemoved, this.buildThumbnailFactory || this.buildThumbnail, thumbnailHeight, this.filterVm, this.folderThumbnailFactory || this.buildFolderThumbnail, this.selectFolder || (function () { }));
            }
            else if (displayMode == DocumentsDisplayMode.List || displayMode == DocumentsDisplayMode.FullText) {
                var gridVm = new Pb.DocumentsGridVm(config, searchResults, this.actionUrls, this.filterVm, this.gridColumnHeadersVm, this.getSelectedBinderContext, this.onDisplayDocumentAdded, this.onDisplayDocumentRemoved, this.buildRowFactory || this.buildRow, this.buildMultiselectContextMenuFactory || this.buildMultiselectContextMenu, this.folderRowFactory || this.buildFolderRow, this.selectFolder || (function () { }), this.getAcceptedFileExtensions);
                gridVm.displayMode = displayMode;
                return gridVm;
            }
            else {
                return null;
            }
        };
        DocumentDisplayVmFactory.prototype.buildRow = function (data, displayVm, getSelectedBinderContext) {
            return new Pb.DocumentRowVm(data, displayVm, getSelectedBinderContext);
        };
        DocumentDisplayVmFactory.prototype.buildThumbnail = function (data, displayVm, getSelectedBinderContext) {
            if (data.discriminator === 'LocalFileStore')
                return new Pb.LocalFileStoreThumbnailVm(data, displayVm);
            else if (data.discriminator === 'MatrixFileStore')
                return new Pb.MatrixFileStoreThumbnailVm(data, displayVm);
            else
                return new Pb.DocumentThumbnailVm(data, displayVm, getSelectedBinderContext);
        };
        DocumentDisplayVmFactory.prototype.buildMultiselectContextMenu = function (gridVm, getSelectedBinderContext, menuItems) {
            return new Pb.DocumentsGridMultiselectContextMenu(gridVm, getSelectedBinderContext, menuItems);
        };
        DocumentDisplayVmFactory.prototype.buildFolderRow = function (data, filterVm, getSelectedBinderContext, actionUrls) {
            return new Pb.FolderVm(data, filterVm, getSelectedBinderContext, actionUrls, this.buildFolderRow);
        };
        DocumentDisplayVmFactory.prototype.buildFolderThumbnail = function (data, filterVm, getSelectedBinderContext, actionUrls) {
            return new Pb.FolderThumbnailVm(data, filterVm, getSelectedBinderContext, actionUrls, this.buildFolderThumbnail);
        };
        return DocumentDisplayVmFactory;
    }());
    Pb.DocumentDisplayVmFactory = DocumentDisplayVmFactory;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentsFilterVm = (function () {
        function DocumentsFilterVm(filterData, pager, searchesDocuments) {
            var _this = this;
            this.isRecycled = function () { return _this.data.isRecycled(); };
            this.isSearch = function () { return _this.data.searchText() && _this.data.searchText().trim().length > 0; };
            this.filter = function (options) {
                options = options || {};
                if (_this.suppressFilter > 0)
                    return;
                if (_this.isFilterUnchanged() && !options.forceRefresh)
                    return;
                _this.storeCurrentState();
                return new Promise(function (resolve) {
                    _this.searchesDocuments.search(_this.data, resolve);
                });
            };
            this.isFilteringByAttachment = function () {
                return !!_this.data.entityId() && !!_this.data.entityType();
            };
            this.getEntityTypeFromTabKey = function (pipeDelimitedTabKey) {
                return _this.splitOnPipe(pipeDelimitedTabKey)[0];
            };
            this.getEntityIdFromTabKey = function (pipeDelimitedTabKey) {
                return _this.splitOnPipe(pipeDelimitedTabKey)[1];
            };
            this.tab = function (tab) {
                if (_this.isAllTab(tab)) {
                    _this.all();
                }
                else if (_this.isAllAttachmentTab(tab)) {
                    _this.allAttachments();
                }
                else if (_this.hasNoChildAttachmentTab(tab)) {
                    _this.noChildAttachments();
                }
                else if (_this.isAttachedTab(tab)) {
                    _this.childAttachmentBinder();
                }
                else if (_this.isAttachmentTab(tab)) {
                    var entityType = _this.getEntityTypeFromTabKey(tab.key());
                    var entityId = _this.getEntityIdFromTabKey(tab.key());
                    _this.childAttachment(entityType, entityId);
                }
                else if (tab.isGroup()) {
                    _this.filterByGroup(tab.key());
                }
                else {
                    _this.filterByType(tab.key());
                }
            };
            this.resetFilter = function () {
                _this.data.groupId(null);
                _this.data.typeId(null);
                _this.data.binderId(null);
                _this.data.folderId(null);
                _this.data.isRecycled(false);
                _this.data.isChildAttachmentBinder(false);
                _this.data.isNotInBinder(false);
                _this.data.entityType(null);
                _this.data.entityId(null);
                _this.data.isUnattached(null);
                _this.data.noChildAttachments(null);
                _this.pager.page(1);
            };
            this.filterBy = function (applyFilter) {
                _this.searchesDocuments.beforeSearch();
                _this.suppressFilter++;
                applyFilter();
                _this.suppressFilter--;
                _this.filter();
            };
            this.all = function () { return _this.filterBy(function () {
                var isRecycled = _this.data.isRecycled();
                _this.resetFilter();
                _this.data.isRecycled(isRecycled);
            }); };
            this.allAttachments = function () { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.isChildAttachmentBinder(true);
            }); };
            this.recycled = function () { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.isRecycled(true);
                _this.data.sortByField('LastModifiedOn');
            }); };
            this.childAttachmentBinder = function () { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.sortByField('LastModifiedOn');
                _this.data.sortDesc(true);
                _this.data.isChildAttachmentBinder(true);
            }); };
            this.childAttachment = function (entityType, entityId) { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.isChildAttachmentBinder(true);
                _this.data.entityType(entityType);
                _this.data.entityId(entityId);
                _this.data.sortByField('ChildAttachmentName');
                _this.data.sortDesc(false);
            }); };
            this.noChildAttachments = function () { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.isChildAttachmentBinder(true);
                _this.data.noChildAttachments(true);
            }); };
            this.allFilesBinder = function () { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.sortByField('LastModifiedOn');
                _this.data.sortDesc(true);
            }); };
            this.notInBinder = function (binderId) { return _this.filterBy(function () {
                _this.resetFilter();
                _this.data.sortByField('LastModifiedOn');
                _this.data.sortDesc(true);
                _this.data.binderId(binderId);
                _this.data.isNotInBinder(true);
            }); };
            this.filterByGroup = function (groupId) {
                _this.suppressFilter++;
                if (groupId) {
                    _this.data.groupId(groupId);
                    _this.data.typeId(null);
                    _this.pager.page(1);
                }
                _this.suppressFilter--;
                _this.filter();
            };
            this.filterByType = function (typeId) {
                _this.suppressFilter++;
                if (typeId) {
                    _this.data.groupId(null);
                    _this.data.typeId(typeId);
                    _this.pager.page(1);
                }
                _this.suppressFilter--;
                _this.filter();
            };
            this.searchTextChanged = function () {
                _this.suppressFilter++;
                _this.pager.page(1);
                _this.suppressFilter--;
                _this.filter();
            };
            this.getSortState = function () {
                return {
                    sortByField: _this.data.sortByField(),
                    sortDesc: _this.data.sortDesc()
                };
            };
            this.changeSort = function (sortByField, sortDesc) {
                _this.data.sortByField(sortByField);
                _this.data.sortDesc(sortDesc);
                _this.filter();
            };
            this.repaginate = function () {
                if (_this.pager.visible()) {
                    if (_this.pager.nextPageEnabled())
                        _this.filter({ forceRefresh: true });
                    else if (_this.pager.previousPageEnabled())
                        _this.pager.goToPreviousPage();
                }
            };
            this.storeCurrentState = function () {
                _this.lastData = ko.mapping.toJS(_this.data);
            };
            this.isFilterUnchanged = function () {
                return Pb.isEqual(ko.mapping.toJS(_this.data), _this.lastData);
            };
            this.suppressFilter = 0;
            this.searchesDocuments = searchesDocuments;
            this.pager = new Pb.PagerViewModel(this.filter);
            this.data = {
                searchText: ko.observable(filterData.searchText),
                groupId: ko.observable(filterData.groupId),
                typeId: ko.observable(filterData.typeId),
                binderId: ko.observable(filterData.binderId),
                folderId: ko.observable(filterData.folderId),
                entityType: ko.observable(filterData.entityType),
                entityId: ko.observable(filterData.entityId),
                isRecycled: ko.observable(filterData.isRecycled),
                isChildAttachmentBinder: ko.observable(filterData.isChildAttachmentBinder),
                noChildAttachments: ko.observable(filterData.noChildAttachments),
                isUnattached: ko.observable(filterData.isUnattached),
                isNotInBinder: ko.observable(filterData.isNotInBinder),
                sortByField: ko.observable(filterData.sortByField),
                sortDesc: ko.observable(filterData.sortDesc),
                page: ko.pureComputed(function () { return _this.pager.page(); }),
                restrictedOnly: ko.observable(filterData.restrictedOnly)
            };
            this.pager.update(pager);
            this.storeCurrentState();
        }
        DocumentsFilterVm.prototype.isAllTab = function (tab) {
            return tab.key() === 'all';
        };
        DocumentsFilterVm.prototype.isAllAttachmentTab = function (tab) {
            return tab.key() === 'all-attachments';
        };
        DocumentsFilterVm.prototype.hasNoChildAttachmentTab = function (tab) {
            return tab.key() === 'has-no-child-attachments';
        };
        DocumentsFilterVm.prototype.isAttachmentTab = function (tab) {
            return /^[a-zA-Z]+\|[1-9][0-9]*$/.test(tab.key());
        };
        DocumentsFilterVm.prototype.isAttachedTab = function (tab) {
            return tab.key() == "has-child-attachment";
        };
        DocumentsFilterVm.prototype.splitOnPipe = function (pipeDelimitedString) {
            return pipeDelimitedString.split("|");
        };
        DocumentsFilterVm.prototype.binder = function (binderId, folderId) {
            var _this = this;
            this.filterBy(function () {
                _this.resetFilter();
                if (!binderId || typeof binderId === 'number') {
                    _this.data.sortByField('Order');
                    _this.data.sortDesc(false);
                    _this.data.binderId(binderId);
                    _this.data.folderId(folderId);
                }
                else {
                    var sort = binderId;
                    _this.data.sortByField(sort.sortByField);
                    _this.data.sortDesc(sort.sortDesc);
                    _this.data.binderId(binderId.id);
                    _this.data.folderId(binderId.folderId);
                }
            });
        };
        ;
        DocumentsFilterVm.prototype.folder = function (binderId, folderId) {
            var _this = this;
            if (!binderId || typeof binderId === 'number') {
                if (this.data.binderId() !== binderId || this.data.folderId() !== folderId) {
                    this.filterBy(function () {
                        if (_this.data.binderId() !== binderId) {
                            _this.data.sortByField('Order');
                            _this.data.sortDesc(false);
                        }
                        _this.resetFilter();
                        _this.data.binderId(binderId);
                        _this.data.folderId(folderId);
                    });
                }
            }
            else {
                if (this.data.binderId() !== binderId.id || this.data.folderId() !== folderId) {
                    this.filterBy(function () {
                        if (_this.data.binderId() !== binderId) {
                            _this.data.sortByField(binderId.sortByField);
                            _this.data.sortDesc(binderId.sortDesc);
                        }
                        _this.resetFilter();
                        _this.data.binderId(binderId.id);
                        _this.data.folderId(folderId);
                    });
                }
            }
        };
        ;
        return DocumentsFilterVm;
    }());
    Pb.DocumentsFilterVm = DocumentsFilterVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentsDragAndDropVm = (function () {
        function DocumentsDragAndDropVm(displayVm, actionUrls, getSelectedBinderContext, getAcceptedFileExtensions) {
            var _this = this;
            this.fileDrop = function ($dropArea, fileList, e) {
                $dropArea.removeClass('over');
                var files = _this.filterFilesByAcceptedFileExtensions(fileList);
                if (files.length === 0) {
                    _this.showAcceptedFileExtensionsWarning();
                    return;
                }
                var binderContext = _this.getSelectedBinderContext();
                if (binderContext.selectedBinder() && !binderContext.selectedBinder().canAddNewFiles) {
                    Pb.MessageBox.show({
                        type: 'warning',
                        title: 'Cannot Add Files',
                        message: binderContext.selectedBinder().cannotAddNewFilesReason
                    });
                    return;
                }
                Pb.MultipleCreateDocumentDialog.open({
                    loadingElement: $('<div></div>'),
                    files: files,
                    newDocumentUrl: _this.actionUrls.newDocumentUrl,
                    folderId: binderContext.selectedFolderId,
                    binderId: binderContext.selectedBinderId
                });
            };
            this.filterFilesByAcceptedFileExtensions = function (fileList) {
                if (!_this.getAcceptedFileExtensions) {
                    return fileList;
                }
                var acceptedFileExtensions = _this.getAcceptedFileExtensions();
                if (!acceptedFileExtensions || acceptedFileExtensions.length === 0) {
                    return fileList;
                }
                var files = [];
                for (var i = 0; i < fileList.length; i++) {
                    if (acceptedFileExtensions.some(function (ext) { return fileList[i].name.endsWith(ext); })) {
                        files.push(fileList[i]);
                    }
                }
                return files;
            };
            this.showAcceptedFileExtensionsWarning = function () {
                var acceptedFileExtensions = _this.getAcceptedFileExtensions
                    ? _this.getAcceptedFileExtensions()
                    : [];
                var message = 'Only the following file types can be added:<br/><br/>'
                    + acceptedFileExtensions.join(', ');
                Pb.MessageBox.show({
                    type: 'warning',
                    title: 'Cannot Add Files',
                    message: message
                });
            };
            this.notFileDrop = function ($dropArea, e) {
                $dropArea.removeClass('over');
                if (e.dataTransfer) {
                    for (var i = 0; i < e.dataTransfer.items.length; i++) {
                        var item = e.dataTransfer.items[i];
                        Pb.MessageBox.show({
                            type: 'warning',
                            title: 'Upload Failed',
                            message: "Drag and Drop does not support uploading '" + item.type + "' items"
                        });
                    }
                }
            };
            this.reapplyBindingsToDragHelper = function (vm) {
                ko.cleanNode(_this.documentDragCountElement());
                ko.applyBindings(vm, _this.documentDragCountElement());
            };
            this.displayVm = displayVm;
            this.actionUrls = actionUrls;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.getAcceptedFileExtensions = getAcceptedFileExtensions;
            this.documentsListSectionElement = ko.observable();
            this.documentDragElement = ko.observable();
            this.documentDragCountElement = ko.observable();
            this.dragOptions = ko.pureComputed(function () {
                return {
                    addClasses: false,
                    appendTo: 'body',
                    containment: _this.documentsListSectionElement(),
                    delay: 100,
                    disabled: !_this.getSelectedBinderContext().isShowingFolders(),
                    cursor: '-webkit-grabbing',
                    cursorAt: { left: 5, top: 5 },
                    helper: function () { return _this.documentDragElement(); },
                    scope: 'document',
                    start: function (e, ui) {
                        var document = ko.dataFor(e.target);
                        _this.reapplyBindingsToDragHelper(_this.displayVm);
                        if (document) {
                            document.isDragging(true);
                            displayVm.isDragging(true);
                        }
                    },
                    stop: function (e, ui) {
                        var document = ko.dataFor(e.target);
                        if (document) {
                            document.isDragging(false);
                            displayVm.isDragging(false);
                        }
                    }
                };
            });
        }
        return DocumentsDragAndDropVm;
    }());
    Pb.DocumentsDragAndDropVm = DocumentsDragAndDropVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentThumbnailsVm = (function () {
        function DocumentThumbnailsVm(config, searchResults, searchesDocuments, actionUrls, getSelectedBinderContext, onDocumentAdded, onDocumentRemoved, thumbnailFactory, thumbnailHeight, filterVm, folderThumbnailFactory, selectFolder) {
            var _this = this;
            this.dispose = function () {
                $(window).off('resize', _this.lazyCalculateLayout);
            };
            this.update = function (data) {
                var documentVms = data.documents.map(function (documentData) { return _this.thumbnailFactory(documentData, _this, _this.getSelectedBinderContext); });
                var folderVms = data.folders
                    ? data.folders.map(function (x) { return _this.folderThumbnailFactory(x, _this.filterVm, _this.getSelectedBinderContext, _this.actionUrls, _this.folderThumbnailFactory); })
                    : [];
                window.requestAnimationFrame(function () {
                    _this.calculateLayout(documentVms, folderVms);
                    _this.documents(documentVms);
                    _this.folders(folderVms);
                    _this.resultsCount(data.resultsCount);
                });
            };
            this.clear = function () { return _this.documents.removeAll(); };
            this.getDocumentById = function (documentId) {
                return _this.documents().find(function (d) { return d.id === documentId; });
            };
            this.addDocument = function (data) {
                var document = _this.thumbnailFactory(data, _this, _this.getSelectedBinderContext);
                document.selected(true);
                _this.documents.unshift(document);
                _this.calculateLayout(_this.documents(), _this.folders());
                _this.onDocumentAdded(document);
                return document;
            };
            this.removeDocument = function (document) {
                if (_this.documents().indexOf(document) >= 0) {
                    _this.documents.remove(document);
                    _this.calculateLayout(_this.documents(), _this.folders());
                    _this.onDocumentRemoved(document);
                }
                return document;
            };
            this.updateDocument = function (documentId, data) {
                var document = _.find(_this.documents(), function (d) { return d.id === documentId; });
                if (document) {
                    _this.onDocumentRemoved(document);
                    document.update(data);
                    document.selected(true);
                    _this.onDocumentAdded(document);
                }
                return document;
            };
            this.getLocalFileStoreById = function (localFileStoreId) {
                return _this.documents().find(function (lfs) { return lfs.id === localFileStoreId && lfs.discriminator === 'LocalFileStore'; });
            };
            this.addLocalFileStore = function (data) {
                var localFileStore = _this.thumbnailFactory(data, _this, _this.getSelectedBinderContext);
                localFileStore.inserted(true);
                localFileStore.active(true);
                _this.documents.unshift(localFileStore);
                _this.onDocumentAdded(localFileStore);
                return localFileStore;
            };
            this.updateLocalFileStore = function (localFileStoreId, data) {
                var localFileStore = _this.getLocalFileStoreById(localFileStoreId);
                if (localFileStore) {
                    localFileStore.update(data);
                    localFileStore.inserted(true);
                    localFileStore.active(true);
                }
                return localFileStore;
            };
            this.removeLocalFileStore = function (localFileStore) {
                if (_this.documents().indexOf(localFileStore) >= 0) {
                    _this.documents.remove(localFileStore);
                    _this.onDocumentRemoved(localFileStore);
                }
                return localFileStore;
            };
            this.getMatrixFileStoreById = function (matrixFileStoreId) {
                return _.find(_this.documents(), function (document) {
                    return document.id === matrixFileStoreId && document.discriminator === 'MatrixFileStore';
                });
            };
            this.addMatrixFileStore = function (data) {
                var matrixFileStore = _this.thumbnailFactory(data, _this, _this.getSelectedBinderContext);
                matrixFileStore.inserted(true);
                matrixFileStore.active(true);
                _this.documents.unshift(matrixFileStore);
                _this.onDocumentAdded(matrixFileStore);
                return matrixFileStore;
            };
            this.updateMatrixFileStore = function (matrixFileStoreId, data) {
                var matrixFileStore = _this.getMatrixFileStoreById(matrixFileStoreId);
                if (matrixFileStore) {
                    matrixFileStore.update(data);
                    matrixFileStore.inserted(true);
                    matrixFileStore.active(true);
                }
                return matrixFileStore;
            };
            this.removeMatrixFileStore = function (matrixFileStore) {
                if (_this.documents().indexOf(matrixFileStore) >= 0) {
                    _this.documents.remove(matrixFileStore);
                    _this.onDocumentRemoved(matrixFileStore);
                }
                return matrixFileStore;
            };
            this.increaseThumbnailSize = function () {
                var index = _this.thumbnailHeights.indexOf(_this.thumbnailHeight());
                _this.thumbnailHeight(_this.thumbnailHeights[index + 1]);
            };
            this.decreaseThumbnailSize = function () {
                var index = _this.thumbnailHeights.indexOf(_this.thumbnailHeight());
                _this.thumbnailHeight(_this.thumbnailHeights[index - 1]);
            };
            this.getSearchArgs = function () {
                return {
                    thumbnailHeight: _this.thumbnailHeight()
                };
            };
            this.getDocumentArgs = function () {
                return {
                    thumbnailHeight: _this.thumbnailHeight()
                };
            };
            this.onRightClick = function (vm, evt) {
                vm.selected(true);
                _this.documents()
                    .filter(function (d) { return d !== vm; })
                    .filter(function (d) { return d.selected(); })
                    .forEach(function (d) { return d.selected(false); });
                var contextMenu = vm.contextMenu();
                contextMenu.openContextMenu();
            };
            this.onClick = function (vm, evt) {
                vm.selected(!vm.selected());
                _this.documents()
                    .filter(function (d) { return d !== vm; })
                    .filter(function (d) { return d.selected(); })
                    .forEach(function (d) { return d.selected(false); });
            };
            this.templateName = 'document-view-thumbnails';
            this.footerTemplateName = 'document-view-thumbnails-footer';
            this.displayMode = Pb.DocumentsDisplayMode.Thumbnails;
            this.actionUrls = actionUrls;
            this.thumbnailHeights = config.thumbnailHeights;
            this.thumbnailHeight = ko.observable(thumbnailHeight || this.thumbnailHeights[Math.floor(this.thumbnailHeights.length / 2)]);
            this.isIncreaseThumbnailSizeEnabled = ko.pureComputed(function () {
                return _this.thumbnailHeights.indexOf(_this.thumbnailHeight()) < _this.thumbnailHeights.length - 1;
            });
            this.isDecreaseThumbnailSizeEnabled = ko.pureComputed(function () {
                return _this.thumbnailHeights.indexOf(_this.thumbnailHeight()) > 0;
            });
            this.thumbnailHeight.subscribe(function (newThumbnailSize) { return searchesDocuments.search(); });
            this.documents = ko.observableArray();
            this.folders = ko.observableArray();
            this.items = ko.pureComputed(function () {
                var folders = _this.folders && _this.folders() || [];
                var documents = _this.documents && _this.documents() || [];
                return folders.concat(documents);
            });
            this.resultsCount = ko.observable(0);
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.onDocumentAdded = onDocumentAdded;
            this.onDocumentRemoved = onDocumentRemoved;
            this.thumbnailFactory = thumbnailFactory;
            this.filterVm = filterVm;
            this.folderThumbnailFactory = folderThumbnailFactory;
            this.selectFolder = selectFolder;
            this.dragAndDropVm = new Pb.DocumentsDragAndDropVm(this, actionUrls, getSelectedBinderContext);
            this.isDragging = ko.observable(false);
            this.isDragging.subscribe(function (value) {
                _.each(_this.selectedDocuments(), function (document) { return document.isDragging(value); });
            });
            this.draggingDocuments = ko.pureComputed(function () {
                return _.filter(_this.documents(), function (document) { return document.isDragging(); });
            });
            this.containerHeight = ko.observable('0px');
            this.selectedDocuments = ko.pureComputed(function () { return _this.documents().filter(function (d) { return d.selected(); }); });
            this.hasDocuments = ko.pureComputed(function () { return _this.documents().length > 0; });
            this.hasFolders = ko.pureComputed(function () { return _this.folders().length > 0; });
            this.hasItems = ko.pureComputed(function () { return _this.items().length > 0; });
            this.lazyCalculateLayout = _.debounce(function () { return _this.calculateLayout(_this.documents(), _this.folders()); }, 300);
            $(window).resize(this.lazyCalculateLayout);
        }
        DocumentThumbnailsVm.prototype.calculateLayout = function (documentVms, folderVms) {
            var folders = folderVms.map(function (x) { return ({
                width: x.thumbnailWidth(),
                height: x.thumbnailHeight(),
                value: x
            }); });
            var documents = documentVms.map(function (x) { return ({
                width: x.thumbnailWidth(),
                height: x.thumbnailHeight(),
                value: x
            }); });
            var input = folders
                .concat(documents);
            if (input.length > 0) {
                var config = {
                    containerWidth: $(".documents-content").width(),
                    containerPadding: 10,
                    boxSpacing: { horizontal: 10, vertical: 60 },
                    targetRowHeight: input[0].height
                };
                var output = window.justifiedLayout(input, config);
                for (var i = 0; i < output.boxes.length; i++) {
                    input[i].value.displayWidth(output.boxes[i].width);
                    input[i].value.displayHeight(output.boxes[i].height);
                }
            }
        };
        return DocumentThumbnailsVm;
    }());
    Pb.DocumentThumbnailsVm = DocumentThumbnailsVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentsGridVm = (function () {
        function DocumentsGridVm(config, searchResults, actionUrls, filterVm, columnHeadersVm, getSelectedBinderContext, onDocumentAdded, onDocumentRemoved, rowFactory, multiselectContextMenuFactory, folderRowFactory, selectFolder, getAcceptedFileExtensions) {
            var _this = this;
            this.dispose = function () {
                Pb.WindowFiller.autoFillOff($('.documents-content-scroll'));
            };
            this.update = function (data) {
                var mapping = {
                    'documents': {
                        key: function (data) { return ko.unwrap(data.key); },
                        create: function (options) { return _this.rowFactory(options.data, _this, _this.getSelectedBinderContext); },
                        update: function (options) { return ko.mapping.fromJS(options.data, { 'ignore': ['selected'] }, options.target); }
                    },
                    'folders': {
                        key: function (data) { return data.id; },
                        create: function (options) { return _this.folderRowFactory(options.data, _this.filterVm, _this.getSelectedBinderContext, _this.actionUrls, _this.folderRowFactory); },
                        update: function (options) { return options.data ? _this.folderRowFactory(options.data, _this.filterVm, _this.getSelectedBinderContext, _this.actionUrls, _this.folderRowFactory) : null; }
                    },
                    'multiselectContextMenu': {
                        update: function (options) {
                            return ko.observable(_this.multiselectContextMenuFactory(_this, _this.getSelectedBinderContext, options.data.menuItems));
                        }
                    }
                };
                ko.mapping.fromJS(data, mapping, _this);
            };
            this.waitForElement = function (selector) {
                if (document.querySelector(selector)) {
                    return Promise.resolve(true);
                }
                else {
                    return new Promise(function (resolve, reject) { return requestAnimationFrame(resolve); })
                        .then(function () { return _this.waitForElement(selector); });
                }
            };
            this.clear = function () {
                _this.documents([]);
            };
            this.getDocumentById = function (documentId) {
                return _.find(_this.documents(), function (document) {
                    return document.id === documentId && document.discriminator === 'Document';
                });
            };
            this.addDocument = function (data) {
                var document = _this.rowFactory(data, _this, _this.getSelectedBinderContext);
                document.inserted(true);
                document.active(true);
                _this.documents.unshift(document);
                _this.onDocumentAdded(document);
                return document;
            };
            this.updateDocument = function (documentId, data) {
                var document = _this.getDocumentById(documentId);
                if (document) {
                    _this.onDocumentRemoved(document);
                    document.update(data);
                    document.inserted(true);
                    document.active(true);
                    _this.onDocumentAdded(document);
                }
                return document;
            };
            this.removeDocument = function (document) {
                if (_this.documents().indexOf(document) >= 0) {
                    _this.documents.remove(document);
                    _this.onDocumentRemoved(document);
                }
                return document;
            };
            this.getLocalFileStoreById = function (localFileStoreId) {
                return _.find(_this.documents(), function (document) {
                    return document.id === localFileStoreId && document.discriminator === 'LocalFileStore';
                });
            };
            this.addLocalFileStore = function (data) {
                var localFileStore = _this.rowFactory(data, _this, _this.getSelectedBinderContext);
                localFileStore.inserted(true);
                localFileStore.active(true);
                _this.documents.unshift(localFileStore);
                _this.onDocumentAdded(localFileStore);
                return localFileStore;
            };
            this.updateLocalFileStore = function (localFileStoreId, data) {
                var localFileStore = _this.getLocalFileStoreById(localFileStoreId);
                if (localFileStore) {
                    localFileStore.update(data);
                    localFileStore.inserted(true);
                    localFileStore.active(true);
                }
                return localFileStore;
            };
            this.removeLocalFileStore = function (localFileStore) {
                if (_this.documents().indexOf(localFileStore) >= 0) {
                    _this.documents.remove(localFileStore);
                    _this.onDocumentRemoved(localFileStore);
                }
                return localFileStore;
            };
            this.getMatrixFileStoreById = function (matrixFileStoreId) {
                return _.find(_this.documents(), function (document) {
                    return document.id === matrixFileStoreId && document.discriminator === 'MatrixFileStore';
                });
            };
            this.addMatrixFileStore = function (data) {
                var matrixFileStore = _this.rowFactory(data, _this, _this.getSelectedBinderContext);
                matrixFileStore.inserted(true);
                matrixFileStore.active(true);
                _this.documents.unshift(matrixFileStore);
                _this.onDocumentAdded(matrixFileStore);
                return matrixFileStore;
            };
            this.updateMatrixFileStore = function (matrixFileStoreId, data) {
                var matrixFileStore = _this.getMatrixFileStoreById(matrixFileStoreId);
                if (matrixFileStore) {
                    matrixFileStore.update(data);
                    matrixFileStore.inserted(true);
                    matrixFileStore.active(true);
                }
                return matrixFileStore;
            };
            this.removeMatrixFileStore = function (matrixFileStore) {
                if (_this.documents().indexOf(matrixFileStore) >= 0) {
                    _this.documents.remove(matrixFileStore);
                    _this.onDocumentRemoved(matrixFileStore);
                }
                return matrixFileStore;
            };
            this.unselectAll = function () {
                _.each(_this.selectedDocuments(), function (document) { return document.selected(false); });
            };
            this.getSearchArgs = function () { return null; };
            this.getDocumentArgs = function () { return null; };
            this.templateName = 'document-view-list';
            this.footerTemplateName = null;
            this.displayMode = Pb.DocumentsDisplayMode.List;
            this.actionUrls = actionUrls;
            this.filterVm = filterVm;
            this.columnHeadersVm = columnHeadersVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.onDocumentAdded = onDocumentAdded;
            this.onDocumentRemoved = onDocumentRemoved;
            this.rowFactory = rowFactory;
            this.multiselectContextMenuFactory = multiselectContextMenuFactory;
            this.folderRowFactory = folderRowFactory;
            this.selectFolder = selectFolder;
            this.dragAndDropVm = new Pb.DocumentsDragAndDropVm(this, actionUrls, getSelectedBinderContext, getAcceptedFileExtensions);
            this.documents = ko.observableArray([]);
            this.folders = ko.observableArray([]);
            this.items = ko.pureComputed(function () {
                var folders = _this.folders && _this.folders() || [];
                var documents = _this.documents && _this.documents() || [];
                var sortState = _this.filterVm.getSortState();
                var sortDocumentsFirst = (sortState.sortByField === 'Name' && sortState.sortDesc) || sortState.sortByField === 'DocumentsNameFoldersOrder';
                return sortDocumentsFirst ? documents.concat(folders) : folders.concat(documents);
            });
            this.resultsCount = ko.observable(0);
            this.multiselectContextMenu = ko.observable(multiselectContextMenuFactory(this, this.getSelectedBinderContext, searchResults.menuItems));
            this.hasDocuments = ko.pureComputed(function () {
                return _this.documents().length > 0;
            });
            this.hasFolders = ko.pureComputed(function () {
                return _this.folders() && _this.folders().length > 0;
            });
            this.hasItems = ko.pureComputed(function () {
                return _this.items().length > 0;
            });
            this.selectedDocuments = ko.pureComputed(function () {
                return _.filter(_this.documents(), function (document) { return document.selected(); });
            });
            this.isDragging = ko.observable(false);
            this.isDragging.subscribe(function (value) {
                _.each(_this.selectedDocuments(), function (document) { return document.isDragging(value); });
            });
            this.draggingDocuments = ko.pureComputed(function () {
                return _.filter(_this.documents(), function (document) { return document.isDragging(); });
            });
        }
        return DocumentsGridVm;
    }());
    Pb.DocumentsGridVm = DocumentsGridVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var EditDocumentDialog = (function () {
        function EditDocumentDialog(options) {
            var _this = this;
            this.open = function () {
                $(_this.options.loadingElement).remote({
                    url: _this.options.editDocumentUrl,
                    afterRemote: function (data) {
                        var vm = new DocumentEditVm(data.urls, data.viewModel);
                        _this.onView(vm);
                    }
                });
            };
            this.options = options;
        }
        EditDocumentDialog.prototype.onView = function (vm) {
            var $editor = $('<div data-bind="template: { name: \'document-edit-ko-dialog\' }" data-dialog-width="55em"></div>');
            ko.applyBindings(vm, $editor[0]);
            Pb.Dialog.open({ content: $editor, confirmUnload: true });
        };
        return EditDocumentDialog;
    }());
    Pb.EditDocumentDialog = EditDocumentDialog;
    var DocumentEditVm = (function () {
        function DocumentEditVm(urls, data) {
            var _this = this;
            this.onSaveClick = function (vm, e) {
                var $button = $(e.target);
                _this.submit($button)
                    .then(_this.raiseDocumentUpdatedEvent);
                return false;
            };
            this.submit = function ($element) {
                var deferred = $.Deferred();
                var data = ko.mapping.toJS(_this, {
                    ignore: [
                        'urls', 'documentTypes', 'documentSources'
                    ].concat(_this.customIgnorePropertyNames || [])
                });
                $element.remote({
                    url: _this.urls.updateDocumentUrl,
                    method: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                            deferred.reject();
                        }
                        else {
                            _this.errors({});
                            deferred.resolve(__assign({ id: _this.id() }, result));
                        }
                    }
                });
                return deferred.promise();
            };
            this.makeSearchable = function (vm, e) {
                $(e.target).remote({
                    url: _this.ocrRequestUrl,
                    method: 'POST',
                    afterRemote: function (data, textStatus, xhr) {
                        _this.isMakeSearchableVisible(false);
                        _this.isMakingSearchable(true);
                        _this.searchableStatus(data.searchableStatus);
                        _this.pollOcr();
                    }
                });
            };
            this.pollOcr = function () {
                var numAttempts = 0;
                var poll = function () {
                    $.get(_this.ocrPollUrl)
                        .done(function (data) {
                        if (data.isCompleted) {
                            _this.isMakingSearchable(false);
                            _this.fileExtensionClass(data.fileExtensionClass);
                            _this.searchableStatus(data.searchableStatus);
                        }
                        else {
                            setTimeout(poll, 1000 * Math.pow(++numAttempts, 2));
                        }
                    });
                };
                setTimeout(poll, 1000 * Math.pow(++numAttempts, 2));
            };
            this.urls = urls;
            ko.mapping.fromJS(data, {
                'copy': ['ocrRequestUrl', 'ocrPollUrl', 'systemDocumentSourceUrl']
            }, this);
            this.isMakingSearchable = ko.observable(false);
            this.errors = ko.observable({});
            this.isOtherDocumentSourceSelected = ko.computed(function () { return _this.documentSource() === "Other"; });
            this.documentSource.subscribe(function (value) {
                if (!_this.isOtherDocumentSourceSelected()) {
                    _this.documentSourceOtherValue(null);
                }
            });
        }
        DocumentEditVm.prototype.raiseDocumentUpdatedEvent = function (result) {
            Pb.Dialog.close(function () {
                Pb.raiseEvent('document.updated', 'Document updated.', result);
            });
        };
        return DocumentEditVm;
    }());
    Pb.DocumentEditVm = DocumentEditVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var EditRedactionDialog = (function () {
        function EditRedactionDialog(options) {
            var _this = this;
            this.open = function () {
                var onSave = function (vm, e) {
                    $(e.target).remote({
                        url: vm.saveUrl,
                        data: vm.getFormData(),
                        processData: false,
                        contentType: false,
                        afterRemote: function (data) {
                            if (data.errors) {
                                _this.vm.errors(ko.bindingHandlers.matrixPropertyError.map(data.errors));
                            }
                            else {
                                _this.callback(data);
                                Pb.Dialog.close();
                            }
                        }
                    });
                };
                var show = function (data) {
                    _this.vm = new EditRedactionVm(data, {
                        onSaveCallback: onSave
                    });
                    var $content = $("<div>")
                        .attr("data-bind", "template: { name: '" + _this.templateId + "' }")
                        .attr("data-dialog-width", "55em");
                    ko.applyBindings(_this.vm, $content[0]);
                    Pb.Dialog.open({ content: $content, confirmUnload: true });
                };
                $(_this.loadingElement).remote({
                    url: _this.editRedactionUrl,
                    afterRemote: show
                });
            };
            this.templateId = options.templateId;
            this.loadingElement = options.loadingElement;
            this.editRedactionUrl = options.editRedactionUrl;
            this.callback = options.callback;
            this.vm = null;
        }
        return EditRedactionDialog;
    }());
    Pb.EditRedactionDialog = EditRedactionDialog;
    var EditRedactionVm = (function () {
        function EditRedactionVm(data, options) {
            var _this = this;
            this.getFormData = function () {
                var antiForgeryToken = Pb.JQueryAntiForgery.getToken();
                var formData = new FormData();
                formData.append(antiForgeryToken.name, antiForgeryToken.value);
                formData.append('comments', _this.comments() ? _this.comments() : "");
                formData.append('reviewStateId', _this.reviewStateId() != null ? _this.reviewStateId().toString() : "");
                formData.append('reviewStateSameAsOriginalFile', _this.reviewStateSameAsOriginalFile().toString());
                return formData;
            };
            this.saveUrl = data.saveUrl;
            this.comments = ko.observable(data.comments);
            this.reviewStateId = ko.observable(data.reviewStateId);
            this.documentReviewStateId = ko.observable(data.documentReviewStateId);
            this.reviewStateSameAsOriginalFile = ko.observable(data.reviewStateSameAsOriginalFile);
            this.reviewStateSameAsOriginalFile.subscribe(function (value) {
                _this.reviewStateId(value ? _this.documentReviewStateId() : null);
            });
            this.documentReviewStates = ko.observableArray(data.documentReviewStates.map(function (t) { return new Pbs.Web.DropDowns.MultiSelectListItem(t); }));
            this.onSaveCallback = options.onSaveCallback;
            this.errors = ko.observable();
        }
        EditRedactionVm.prototype.onSave = function (vm, e) {
            if (vm.onSaveCallback) {
                vm.onSaveCallback(vm, e);
            }
        };
        return EditRedactionVm;
    }());
    Pb.EditRedactionVm = EditRedactionVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var EditDocumentVersionDialog = (function () {
        function EditDocumentVersionDialog(options) {
            var _this = this;
            this.open = function () {
                $(_this.loadingElement).remote({
                    url: _this.editUrl,
                    afterRemote: function (data) {
                        var vm = new DocumentVersionEditVm(data, {
                            callback: _this.callback
                        });
                        var $content = $('<div>')
                            .attr("data-bind", "template: { name: 'document-version-edit-ko-dialog' }")
                            .attr("data-dialog-width", "55em");
                        ko.applyBindings(vm, $content[0]);
                        Pb.Dialog.open({
                            content: $content,
                            confirmUnload: true
                        });
                    }
                });
            };
            this.loadingElement = options.loadingElement;
            this.editUrl = options.editUrl;
            this.callback = options.callback;
        }
        return EditDocumentVersionDialog;
    }());
    Pb.EditDocumentVersionDialog = EditDocumentVersionDialog;
    var DocumentVersionEditVm = (function () {
        function DocumentVersionEditVm(data, options) {
            this.getFormData = function () {
                var antiForgeryToken = Pb.JQueryAntiForgery.getToken();
                var formData = new FormData();
                formData.append(antiForgeryToken.name, antiForgeryToken.value);
                formData.append('comments', this.comments());
                return formData;
            };
            this.onSave = function (vm, e) {
                $(e.target).remote({
                    url: vm.updateUrl,
                    method: 'POST',
                    data: vm.getFormData(),
                    contentType: false,
                    processData: false,
                    afterRemote: function (data) {
                        if (data.errors) {
                            vm.errors(ko.bindingHandlers.matrixPropertyError.map(data.errors));
                        }
                        else {
                            if (vm.callback) {
                                vm.callback(data);
                            }
                            Pb.Dialog.close();
                        }
                    }
                });
            };
            this.comments = ko.observable(data.comments);
            this.errors = ko.observable({});
            this.updateUrl = data.updateUrl;
            this.callback = options.callback;
        }
        return DocumentVersionEditVm;
    }());
    Pb.DocumentVersionEditVm = DocumentVersionEditVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var FinalizeRedactionDialog = (function () {
        function FinalizeRedactionDialog() {
            this.open = function (user, datetimestamp, finalize) {
                var vm = new FinalizeRedactionVm(user, datetimestamp, finalize);
                var $editor = $('<div data-bind="template: { name: \'redaction-finalize-ko-dialog\' }" data-dialog-width="70em"></div>');
                ko.applyBindings(vm, $editor[0]);
                Pb.Dialog.open({ content: $editor, confirmUnload: true });
            };
        }
        return FinalizeRedactionDialog;
    }());
    Pb.FinalizeRedactionDialog = FinalizeRedactionDialog;
    var FinalizeRedactionVm = (function () {
        function FinalizeRedactionVm(user, datetimestamp, finalize) {
            var _this = this;
            this.cancel = function () {
                Pb.Dialog.close();
            };
            this.submit = function (vm, e) {
                _this.finalize(_this.isSuitableForRelease());
            };
            this.suitableForReleaseMessage = user + " approves this redaction for release on " + datetimestamp + ".";
            this.isSuitableForRelease = ko.observable(false);
            this.finalize = finalize;
        }
        return FinalizeRedactionVm;
    }());
    Pb.FinalizeRedactionVm = FinalizeRedactionVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentFolders = (function () {
        function DocumentFolders() {
        }
        DocumentFolders.delete = function (options) {
            var recordName = options.isBinder ? 'binder' : 'folder';
            Pb.Confirmation.show({
                title: 'Delete ' + recordName,
                message: 'Are you sure you want to delete this ' + recordName + (options.isBinder ? '?' : ' and remove all documents inside it from the binder?'),
                yesCaption: 'Delete ' + recordName,
                noCaption: 'Cancel',
                callback: function () {
                    $(options.loadingElement).remote({
                        url: options.deleteFolderUrl,
                        data: { folderId: options.folderId },
                        method: 'post',
                        afterRemote: function (result) {
                            result = result || {};
                            result.folderId = options.folderId;
                            if (options.isBinder) {
                                Pb.raiseEvent('document.binderDeleted', 'Binder deleted.', result);
                            }
                            else {
                                Pb.raiseEvent('document.folderDeleted', 'Folder deleted.', result);
                            }
                        }
                    });
                }
            });
        };
        return DocumentFolders;
    }());
    Pb.DocumentFolders = DocumentFolders;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentFolderEditVm = (function () {
        function DocumentFolderEditVm(data) {
            var _this = this;
            this.createFolder = function (vm, e) {
                var data = ko.toJSON({
                    name: vm.name,
                    parentFolderId: vm.parentFolderId
                });
                $(e.target).remote({
                    url: _this.createFolderUrl(),
                    method: 'post',
                    data: data,
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                        }
                        else {
                            Pb.Dialog.close();
                            Pb.raiseEvent('document.folderCreated', 'Folder created.', result);
                        }
                    }
                });
            };
            this.renameFolder = function (vm, e) {
                var data = ko.mapping.toJSON(vm, {});
                $(e.target).remote({
                    url: _this.renameFolderSaveUrl(),
                    method: 'post',
                    data: data,
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                        }
                        else {
                            Pb.Dialog.close();
                            var eventName = _this.isRootFolder() ? 'document.binderRenamed' : 'document.folderRenamed';
                            var eventFriendlyMessage = _this.isRootFolder() ? 'Binder renamed.' : 'Folder renamed.';
                            Pb.raiseEvent(eventName, eventFriendlyMessage, result);
                        }
                    }
                });
            };
            ko.mapping.fromJS(data, {}, this);
            this.errors = ko.observable({});
        }
        DocumentFolderEditVm.prototype.close = function () {
            Pb.Dialog.close();
        };
        return DocumentFolderEditVm;
    }());
    Pb.DocumentFolderEditVm = DocumentFolderEditVm;
    ;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var CustomFolderTree = (function () {
        function CustomFolderTree() {
        }
        CustomFolderTree.notInBinderId = -1;
        return CustomFolderTree;
    }());
    Pb.CustomFolderTree = CustomFolderTree;
    var FolderVm = (function () {
        function FolderVm(data, filterVm, getSelectedBinderContext, actionUrls, folderVmFactory) {
            var _this = this;
            this.selectedBinderIsNotReadonly = function () {
                return !(_this.getSelectedBinderContext && _this.getSelectedBinderContext().selectedBinder() && _this.getSelectedBinderContext().selectedBinder().isReadonly());
            };
            this.onDocumentAdded = function (count) {
                count = count || 1;
                _this.count(_this.count() + count);
                if (_this.parent)
                    _this.parent.onDocumentAdded(count);
            };
            this.onDocumentRemoved = function (count) {
                count = count || 1;
                _this.count(_this.count() - count);
                if (_this.parent)
                    _this.parent.onDocumentRemoved(count);
            };
            this.openContextMenu = function (item, e) {
                _this.contextMenu.openContextMenu(item);
            };
            this.createFolder = function (contextMenuItemVm, e) {
                Pb.DocumentNewFolderDialog.open({
                    createDocumentFolderUrl: contextMenuItemVm.source.linkUrl,
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.value,
                    loadingElement: $(e.target)
                });
            };
            this.renameFolder = function (contextMenuItemVm, e) {
                Pb.DocumentRenameFolderDialog.open({
                    renameDocumentFolderUrl: contextMenuItemVm.source.linkUrl,
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.value,
                    loadingElement: $(e.target)
                });
            };
            this.deleteFolder = function (contextMenuItemVm, e) {
                var binderContext = _this.getSelectedBinderContext();
                Pb.DocumentFolders.delete({
                    deleteFolderUrl: contextMenuItemVm.source.linkUrl,
                    isBinder: binderContext.selectedBinder().folderId === _this.id,
                    binderId: binderContext.selectedBinderId,
                    folderId: _this.value,
                    loadingElement: $(e.target)
                });
            };
            this.reorderFolder = function (contextMenuItemVm, e) {
                var reorderFolderDialog = new Pb.ReorderDialog();
                reorderFolderDialog.open({
                    loadingElement: $(e.target),
                    reorderEditUrl: contextMenuItemVm.source.linkUrl,
                    binderId: _this.getSelectedBinderContext().selectedBinderId,
                    folderId: _this.value,
                    afterSave: function () {
                        _this.filterVm.filter({ forceRefresh: true });
                    }
                });
            };
            this.downloadBinder = function (contextMenuItemVm, e) {
                var url = contextMenuItemVm.source.linkUrl;
                var binderId = _this.getSelectedBinderContext().selectedBinderId;
                var a = document.createElement('a');
                a.href = url + "?binderId=" + binderId;
                a.click();
            };
            this.downloadFolder = function (contextMenuItemVm, e) {
                var url = contextMenuItemVm.source.linkUrl;
                var binderId = _this.getSelectedBinderContext().selectedBinderId;
                var folderId = _this.value;
                var a = document.createElement('a');
                a.href = url + "?binderId=" + binderId + "&folderId=" + folderId;
                a.click();
            };
            this.discriminator = 'Folder';
            this.id = parseInt(data.value, 10) || CustomFolderTree.notInBinderId;
            this.filterVm = filterVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.folderDragAndDropVm = new Pb.FolderDragAndDropVm(this, getSelectedBinderContext, actionUrls);
            this.folderVmFactory = folderVmFactory;
            this.additionalClasses = data.additionalClasses;
            this.binderId = data.binderId;
            this.children = data.children.map(function (m) {
                m.parent = _this;
                return _this.folderVmFactory(m, filterVm, getSelectedBinderContext, actionUrls, _this.folderVmFactory);
            });
            this.contextMenu = new Pb.ContextMenuVm({ context: this, items: !data.contextMenu ? [] : data.contextMenu.menuItems });
            this.count = ko.observable(data.count);
            this.folderCount = ko.pureComputed(function () {
                return _this.children.reduce(function (total, folder) { return total + 1 + folder.folderCount(); }, 0);
            });
            this.itemCount = ko.pureComputed(function () {
                return _this.folderCount() + _this.count();
            });
            this.data = data.data;
            this.fullPathText = data.fullPathText;
            this.name = ko.observable(data.name);
            this.open = ko.observable(data.open);
            this.value = data.value;
            this.parent = data.parent;
            this.cssClasses = { 'tree-value-node': data.value };
            this.cssClasses['jstree-open'] = this.open;
            this.cssClasses['jstree-closed'] = ko.pureComputed(function () { return !_this.open(); });
            this.cssClasses['documents-folder-leaf-node'] = ko.pureComputed(function () {
                return !_.find(_this.children, function (folder) { return !folder.deleted(); });
            });
            _.each(data.additionalClasses, function (c) { return _this.cssClasses[c] = true; });
            this.deleted = ko.observable(false);
            this.deleted.subscribe(function (value) {
                _.each(_this.children, function (folder) { return folder.deleted(value); });
            });
            this.text = ko.pureComputed(function () { return _this.name() + " (" + _this.count() + ")"; });
            this.itemCountText = ko.pureComputed(function () { return _this.name() + " (" + _this.itemCount() + ")"; });
            this.totalCount = ko.pureComputed(function () {
                function getCount(folders) {
                    return folders
                        ? _.reduce(folders, function (totalCount, folder) {
                            return !folder.deleted()
                                ? totalCount + folder.count() + getCount(folder.children)
                                : totalCount;
                        }, 0)
                        : 0;
                }
                ;
                return getCount([_this]);
            });
            this.open.subscribe(function (value) {
                if (value && _this.parent)
                    _this.parent.open(true);
            });
        }
        return FolderVm;
    }());
    Pb.FolderVm = FolderVm;
    var CustomFolderTreeVm = (function () {
        function CustomFolderTreeVm(actionUrls, filterVm, bindersVm, data, folderVmFactory) {
            var _this = this;
            this.update = function (data) {
                var treeComparer = new Pb.CustomFolderTreeComparer();
                if (treeComparer.treesEqual(ko.unwrap(_this.customFolders), data.customFolders))
                    delete data.customFolders;
                var mapping = {
                    'customFolders': {
                        create: function (options) { return _this.folderVmFactory(options.data, _this.filterVm, _this.getSelectedBinderContext, _this.actionUrls, _this.folderVmFactory); }
                    }
                };
                _this.notInBinderValue(data.notInBinderValue);
                if (data.customFolders) {
                    _this.customFolders(data.customFolders.map(function (m) { return _this.folderVmFactory(m, _this.filterVm, _this.getSelectedBinderContext, _this.actionUrls, _this.folderVmFactory); }));
                }
                _this.updateSelectedFolder();
            };
            this.updateSelectedFolder = function () {
                if (_this.hasSelectedFolder && !_this.hasSelectedFolder()) {
                    _this.selectedCustomFolderId(_this.bindersVm.selectedBinder().folderId);
                }
            };
            this.getSelectedBinderContext = function () {
                return {
                    selectedBinder: _this.bindersVm.selectedBinder,
                    selectedBinderId: _this.bindersVm.selectedBinder() ? _this.bindersVm.selectedBinder().id : null,
                    selectedFolderId: _this.selectedCustomFolderId(),
                    isSelectedFolderFilesNotInBinder: _this.selectedCustomFolderId() === CustomFolderTree.notInBinderId,
                    isShowingFolders: _this.bindersVm.hasSelectedCustomFolderBinder
                };
            };
            this.getFolderById = function (folderId) {
                if (!folderId)
                    return null;
                function searchFolder(folder) {
                    return ko.unwrap(folder.id) == folderId
                        ? folder
                        : _.chain(folder.children)
                            .map(function (child) { return searchFolder(child); })
                            .filter(function (folder) { return folder != undefined; })
                            .value()[0];
                }
                ;
                return _.chain(_this.customFolders())
                    .map(function (folder) { return searchFolder(folder); })
                    .find(function (searchResult) { return searchResult != null; })
                    .value();
            };
            this.onFolderDeleting = function (folder) {
                var notInBinderFolder = _this.getFolderById(CustomFolderTree.notInBinderId);
                notInBinderFolder.count(notInBinderFolder.count() + folder.totalCount());
            };
            this.refreshFolders = function () {
                var deferred = $.Deferred();
                if (!_this.getSelectedBinderContext().selectedBinderId) {
                    deferred.resolve();
                    return deferred;
                }
                $('<div></div>').remote({
                    url: _this.actionUrls.getDocumentBinderTreeUrl,
                    data: {
                        binderId: _this.getSelectedBinderContext().selectedBinderId,
                        includeFilesNotInBinderNode: true
                    },
                    afterRemote: function (data) {
                        _this.update(data);
                        deferred.resolve();
                    }
                });
                return deferred;
            };
            this.actionUrls = actionUrls;
            this.filterVm = filterVm;
            this.bindersVm = bindersVm;
            this.folderVmFactory = folderVmFactory || (function (data, filterVm, getSelectedBinderContext, actionUrls) { return new FolderVm(data, filterVm, getSelectedBinderContext, actionUrls, _this.folderVmFactory); });
            this.notInBinderValue = ko.observable(null);
            this.customFolders = ko.observableArray([]);
            this.filesInBinderCount = ko.pureComputed(function () {
                return _.reduce(_this.customFolders(), function (totalCount, folder) {
                    return totalCount + (folder.id != CustomFolderTree.notInBinderId ? folder.count() : 0);
                }, 0);
            });
            this.hasSelectedFolder = ko.pureComputed(function () {
                return _this.getSelectedBinderContext().selectedBinderId !== null && !!_this.getFolderById(_this.selectedCustomFolderId());
            });
            this.isRootCustomFolderSelected = ko.pureComputed(function () {
                return _this.bindersVm.selectedBinder() && (_this.selectedCustomFolderId() === _this.bindersVm.selectedBinder().folderId);
            });
            this.isNotInBinderFolderSelected = ko.pureComputed(function () {
                return _this.selectedCustomFolderId() == CustomFolderTree.notInBinderId;
            });
            this.selectedFolder = ko.pureComputed(function () {
                return _this.getFolderById(_this.selectedCustomFolderId());
            });
            this.selectedCustomFolderValue = ko.observable();
            this.selectedCustomFolderId = ko.computed({
                read: function () {
                    var folderValue = _this.selectedCustomFolderValue();
                    if (!folderValue)
                        return null;
                    return folderValue === _this.notInBinderValue()
                        ? CustomFolderTree.notInBinderId
                        : parseInt(folderValue, 10);
                },
                write: function (value) {
                    if (value === CustomFolderTree.notInBinderId) {
                        _this.selectedCustomFolderValue(_this.notInBinderValue());
                    }
                    else {
                        _this.selectedCustomFolderValue(value ? value.toString() : null);
                    }
                }
            });
            this.selectedCustomFolderId(filterVm.data.folderId());
            this.selectedCustomFolderId.subscribe(function (value) {
                if (!value)
                    return;
                value === CustomFolderTree.notInBinderId
                    ? _this.filterVm.notInBinder(_this.bindersVm.selectedBinder().id)
                    : _this.filterVm.folder(_this.bindersVm.selectedBinder().id, value);
            });
            this.update(data);
        }
        return CustomFolderTreeVm;
    }());
    Pb.CustomFolderTreeVm = CustomFolderTreeVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var FolderThumbnailVm = (function (_super) {
        __extends(FolderThumbnailVm, _super);
        function FolderThumbnailVm(data, filterVm, getSelectedBinderContext, actionUrls, folderVmFactory) {
            var _this = _super.call(this, data, filterVm, getSelectedBinderContext, actionUrls, folderVmFactory) || this;
            _this.thumbnailHeight = ko.observable(data.height);
            _this.thumbnailWidth = ko.observable(data.width);
            _this.displayHeight = ko.observable(data.height);
            _this.displayWidth = ko.observable(data.width);
            return _this;
        }
        return FolderThumbnailVm;
    }(Pb.FolderVm));
    Pb.FolderThumbnailVm = FolderThumbnailVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var CustomFolderTreeComparer = (function () {
        function CustomFolderTreeComparer() {
            var _this = this;
            this.areSubtreesEqual = function (subtree1, subtree2) {
                if (subtree1.value !== subtree2.value || ko.unwrap(subtree1.text) !== ko.unwrap(subtree2.text))
                    return false;
                if (subtree1.children.length !== subtree2.children.length)
                    return false;
                var areSubtreeChildrenDifferent = _.find(subtree1.children, function (subtree1Child, ix) {
                    return !_this.areSubtreesEqual(subtree1Child, subtree2.children[ix]);
                });
                return !areSubtreeChildrenDifferent;
            };
            this.treesEqual = function (tree1, tree2) {
                if (!tree1 || !tree2 || !tree1.length || !tree2.length)
                    return false;
                return _.every(tree1, function (_, ix) {
                    return _this.areSubtreesEqual(tree1[ix], tree2[ix]);
                });
            };
        }
        return CustomFolderTreeComparer;
    }());
    Pb.CustomFolderTreeComparer = CustomFolderTreeComparer;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var FolderDragAndDropVm = (function () {
        function FolderDragAndDropVm(folderVm, getSelectedBinderContext, actionUrls) {
            var _this = this;
            this.fileDrop = function ($dropArea, files, e) {
                $dropArea.removeClass('over');
                if (!_this.canDrop())
                    return;
                Pb.MultipleCreateDocumentDialog.open({
                    loadingElement: $('<div></div>'),
                    files: files,
                    newDocumentUrl: _this.actionUrls.newDocumentUrl,
                    folderId: _this.folderVm.id,
                    binderId: _this.getSelectedBinderContext().selectedBinderId
                });
            };
            this.addOrMoveDocumentsToFolder = function (loadingElement, documents) {
                var currentFolderId = _this.getSelectedBinderContext().selectedFolderId;
                var moveDocuments = currentFolderId > 0;
                $(loadingElement).remote({
                    url: _this.actionUrls.addOrMoveDocumentsToFolderSaveUrl,
                    method: 'post',
                    data: JSON.stringify({
                        documentIds: _.map(documents, function (document) { return document.id; }),
                        currentFolderId: currentFolderId,
                        selectedFolderId: _this.folderVm.id,
                        moveDocuments: moveDocuments
                    }),
                    contentType: 'application/json',
                    allowSimultaneousRequests: true,
                    afterRemote: function (result) {
                        var recordName = documents.length == 1 ? 'Document' : 'Documents';
                        var eventName = moveDocuments ? 'document.movedToFolder' : 'document.addedToFolder';
                        var eventFriendlyMessage = result.errors
                            ? recordName + ' could not be ' + (moveDocuments ? ' moved to folder.' : ' added to folder.')
                            : recordName + (moveDocuments ? ' moved to folder.' : ' added to folder.');
                        if (result.hadDuplicates && !result.errors)
                            eventFriendlyMessage += ' Duplicates ignored.';
                        if (result.errors) {
                            _.each(documents, function (document) { return document.hidden(false); });
                            Pb.raiseEvent(eventName, eventFriendlyMessage, { error: eventFriendlyMessage });
                        }
                        else {
                            _.each(documents, function (document) { return document.deleted(true); });
                            Pb.raiseEvent(eventName, eventFriendlyMessage, { documentIds: result.documentIds, folderId: result.folderId, binderId: result.binderId });
                        }
                    }
                });
            };
            this.removeDocumentsFromFolder = function (loadingElement, documents) {
                var currentFolderId = _this.getSelectedBinderContext().selectedFolderId;
                var documentIds = _.map(documents, function (document) { return document.id(); });
                $(loadingElement).remote({
                    url: _this.actionUrls.removeDocumentFromFolderUrl,
                    method: 'post',
                    data: JSON.stringify({
                        documentIds: documentIds,
                        documentFolderId: currentFolderId,
                    }),
                    contentType: 'application/json',
                    allowSimultaneousRequests: true,
                    afterRemote: function (result) {
                        var recordName = documents.length == 1 ? 'Document' : 'Documents';
                        Pb.raiseEvent('document.removedFromFolder', recordName + ' removed from folder.', {
                            documentIds: documentIds,
                            folderId: Pb.CustomFolderTree.notInBinderId,
                            binderId: _this.getSelectedBinderContext().selectedBinderId
                        });
                    }
                });
            };
            this.folderVm = folderVm;
            this.getSelectedBinderContext = getSelectedBinderContext;
            this.actionUrls = actionUrls;
            this.canDrop = ko.pureComputed(function () {
                return _this.getSelectedBinderContext
                    && _this.folderVm.id != _this.getSelectedBinderContext().selectedFolderId
                    && getSelectedBinderContext().selectedBinder()
                    && !getSelectedBinderContext().selectedBinder().isReadonly();
            });
            this.dropOptions = ko.computed(function () {
                return {
                    addClasses: false,
                    hoverClass: _this.canDrop() ? 'document-drop-over' : '',
                    scope: 'document',
                    drop: function (e, ui) {
                        var document = ko.dataFor(ui.draggable[0]);
                        if (!document || !_this.canDrop())
                            return;
                        var documents = _.union([document], document.displayVm.selectedDocuments());
                        _.each(documents, function (document) { return document.hidden(true); });
                        var isRemovingFromFolder = _this.folderVm.id == Pb.CustomFolderTree.notInBinderId;
                        if (isRemovingFromFolder)
                            _this.removeDocumentsFromFolder(e.target, documents);
                        else
                            _this.addOrMoveDocumentsToFolder(e.target, documents);
                    }
                };
            });
        }
        return FolderDragAndDropVm;
    }());
    Pb.FolderDragAndDropVm = FolderDragAndDropVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var LocalFileStoreRowVm = (function () {
        function LocalFileStoreRowVm(data, displayVm) {
            var _this = this;
            this.createDirectory = function (contextMenuItemVm, e) {
                if (!_this.isRecycled()) {
                    _this.executeCommand(contextMenuItemVm.source.linkUrl, e);
                }
            };
            this.open = function (contextMenuItemVm, e) {
                _this.executeCommand(contextMenuItemVm.source.linkUrl, e);
            };
            this.executeCommand = function (url, e) {
                $(e.target).remote({
                    url: url,
                    method: 'POST',
                    afterRemote: function (result) {
                        new Pb.MatrixLocalFilesApplication(_this.getCookieName(), result.matrixLocalFilesDownloadUrl)
                            .sendCommand(new URL(result.url));
                    }
                });
            };
            this.getCookieName = function () {
                return 'MatrixLocalFilesInstallNotificationOptOut';
            };
            this.onOpen = function (vm, e) {
                _this.executeCommand(_this.actions.localFileStoreOpenUrl, e);
            };
            this.editProperties = function () {
                console.log("editProperties...");
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        Pb.raiseEvent('localFileStore.updated', 'Local File Store updated', {
                            id: _this.id
                        });
                    }
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('localFileStore.recycled', 'Local File Store recycled.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'Local File Store', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('localFileStore.restored', 'Local File Store restored.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    title: 'Restore Local File Store?',
                    message: 'Are you sure you want to restore this local file store?',
                    yesCaption: 'Restore',
                    noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.delete = function () {
            };
            this.discriminator = data.discriminator;
            this.key = data.key;
            this.id = data.id;
            this.documentVersionId = ko.observable(0);
            this.name = ko.observable(data.name);
            this.groupId = ko.observable(data.groupId);
            this.typeId = ko.observable(data.typeId);
            this.groupName = ko.observable(data.groupName);
            this.typeName = ko.observable(data.typeName);
            this.type = ko.observable(data.type);
            this.description = ko.observable(data.description);
            this.sources = ko.observable(data.sources);
            this.index = ko.observable(data.index);
            this.activityFrom = ko.observable(data.activityFrom);
            this.activityThru = ko.observable(data.activityThru);
            this.isOriginalStoredInFile = ko.observable(data.isOriginalStoredInFile);
            this.reviewState = ko.observable(data.reviewState);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.hasNotBeenViewedByUser = ko.computed(function () { return !_this.hasBeenViewedByUser(); });
            this.isDirectoryCreated = ko.observable(data.isDirectoryCreated);
            this.isDirectoryNotCreated = ko.computed(function () { return !_this.isDirectoryCreated(); });
            this.isRecycled = ko.observable(data.isRecycled);
            this.createdBy = data.createdBy;
            this.createdOn = data.createdOn;
            this.lastModifiedBy = ko.observable(data.lastModifiedBy);
            this.lastModifiedOn = ko.observable(data.lastModifiedOn);
            this.actions = data.actions;
            this.displayVm = displayVm;
            this.active = ko.observable(false);
            this.inserted = ko.observable(false);
            this.deleted = ko.observable(false);
            this.selected = ko.observable(false);
            this.hidden = ko.observable(false);
            this.isDragging = ko.observable(false);
            this.canOpenLocalFileStore = ko.pureComputed(function () {
                return _this.isDirectoryCreated()
                    && _this.actions.canOpenLocalFileStore.hasPermission;
            });
            this.openLocalFileStorePermissionLink = {
                canPerformAction: this.canOpenLocalFileStore,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    _this.executeCommand(_this.actions.localFileStoreOpenUrl, e);
                }
            };
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        }
        LocalFileStoreRowVm.prototype.update = function (data) {
            this.name(data.name);
            this.groupId(data.groupId);
            this.typeId(data.typeId);
            this.groupName(data.groupName);
            this.typeName(data.typeName);
            this.type(data.type);
            this.description(data.description);
            this.sources(data.sources);
            this.index(data.index);
            this.activityFrom(data.activityFrom);
            this.activityThru(data.activityThru);
            this.isOriginalStoredInFile(data.isOriginalStoredInFile);
            this.reviewState(data.reviewState);
            this.hasBeenViewedByUser(data.hasBeenViewedByUser);
            this.isDirectoryCreated(data.isDirectoryCreated);
            this.isRecycled(data.isRecycled);
            this.lastModifiedBy(data.lastModifiedBy);
            this.lastModifiedOn(data.lastModifiedOn);
            this.contextMenu(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        };
        LocalFileStoreRowVm.prototype.getCsrfToken = function () {
            var csrfField = document.querySelector('#page-anti-forgery-token > input[name="__RequestVerificationToken"]');
            return csrfField ? csrfField.value : '';
        };
        return LocalFileStoreRowVm;
    }());
    Pb.LocalFileStoreRowVm = LocalFileStoreRowVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var LocalFileStoreThumbnailVm = (function () {
        function LocalFileStoreThumbnailVm(data, displayVm) {
            var _this = this;
            this.update = function (data) {
                _this.name(data.name);
                _this.description(data.description);
                _this.typeName(data.typeName);
                _this.groupName(data.groupName);
                _this.index(data.index);
                _this.source(data.source);
                _this.formattedDateReceived(data.formattedDateReceived);
                _this.isOriginalFileRetained(data.isOriginalFileRetained);
                _this.reviewState(data.reviewState);
                _this.formattedCreated(data.formattedCreated);
                _this.formattedModified(data.formattedModified);
                _this.hasBeenViewedByUser(data.hasBeenViewedByUser);
                _this.isDirectoryCreated(data.isDirectoryCreated);
                _this.isRecycled(data.isRecycled);
                _this.contextMenu(new Pb.DocumentContextMenuBuilder(_this)
                    .buildContextMenu(data.contextMenu.menuItems));
            };
            this.createDirectory = function (contextMenuItemVm, e) {
                if (!_this.isRecycled()) {
                    _this.executeCommand(contextMenuItemVm.source.linkUrl, e);
                }
            };
            this.open = function (contextMenuItemVm, e) {
                if (_this.canOpenLocalFileStore()) {
                    _this.executeCommand(contextMenuItemVm.source.linkUrl, e);
                }
            };
            this.executeCommand = function (url, e) {
                $(e.target).remote({
                    url: url,
                    method: 'POST',
                    afterRemote: function (result) {
                        new Pb.MatrixLocalFilesApplication(_this.getCookieName(), result.matrixLocalFilesDownloadUrl)
                            .sendCommand(new URL(result.url));
                    }
                });
            };
            this.getCookieName = function () {
                return 'MatrixLocalFilesInstallNotificationOptOut';
            };
            this.onOpen = function (vm, e) {
                if (_this.canOpenLocalFileStore()) {
                    _this.executeCommand(_this.actions.localFileStoreOpenUrl, e);
                }
            };
            this.editProperties = function () {
                console.log("editProperties...");
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        Pb.raiseEvent('localFileStore.updated', 'Local File Store updated', {
                            id: _this.id
                        });
                    }
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('localFileStore.recycled', 'Local File Store recycled.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'Local File Store', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('localFileStore.restored', 'Local File Store restored.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    title: 'Restore Local File Store?',
                    message: 'Are you sure you want to restore this local file store?',
                    yesCaption: 'Restore',
                    noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.delete = function () {
            };
            this.discriminator = 'LocalFileStore';
            this.id = data.id;
            this.documentVersionId = ko.observable(0);
            this.key = data.key;
            this.name = ko.observable(data.name);
            this.description = ko.observable(data.description);
            this.typeName = ko.observable(data.typeName);
            this.groupName = ko.observable(data.groupName);
            this.index = ko.observable(data.index);
            this.source = ko.observable(data.source);
            this.formattedDateReceived = ko.observable(data.formattedDateReceived);
            this.isOriginalFileRetained = ko.observable(data.isOriginalFileRetained);
            this.reviewState = ko.observable(data.reviewState);
            this.formattedCreated = ko.observable(data.formattedCreated);
            this.formattedModified = ko.observable(data.formattedModified);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.isDirectoryCreated = ko.observable(data.isDirectoryCreated);
            this.isRecycled = ko.observable(data.isRecycled);
            this.canOpenLocalFileStore = ko.pureComputed(function () {
                return _this.isDirectoryCreated()
                    && _this.actions.canOpenLocalFileStore.hasPermission;
            });
            this.formattedType = ko.pureComputed(function () { return _this.typeName() + " (" + _this.groupName() + ")"; });
            this.hasNotBeenViewedByUser = ko.pureComputed(function () { return !_this.hasBeenViewedByUser(); });
            this.isDirectoryNotCreated = ko.pureComputed(function () { return !_this.isDirectoryCreated(); });
            this.canEditProperties = ko.pureComputed(function () {
                return _this.actions.canEditLocalFileStore.hasPermission;
            });
            this.displayVm = displayVm;
            this.thumbnailHeight = ko.observable(data.thumbnailHeight);
            this.thumbnailWidth = ko.observable(data.thumbnailWidth);
            this.displayHeight = ko.observable(data.thumbnailHeight);
            this.displayWidth = ko.observable(data.thumbnailWidth);
            this.displayWidthPx = ko.pureComputed(function () { return _this.displayWidth() + "px"; });
            this.displayHeightPx = ko.pureComputed(function () { return _this.displayHeight() + "px"; });
            this.active = ko.observable(false);
            this.inserted = ko.observable(false);
            this.deleted = ko.observable(false);
            this.selected = ko.observable(false);
            this.hidden = ko.observable(false);
            this.isDragging = ko.observable(false);
            this.actions = data.actions;
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        }
        LocalFileStoreThumbnailVm.prototype.getCsrfToken = function () {
            var csrfField = document.querySelector('#page-anti-forgery-token > input[name="__RequestVerificationToken"]');
            return csrfField ? csrfField.value : '';
        };
        return LocalFileStoreThumbnailVm;
    }());
    Pb.LocalFileStoreThumbnailVm = LocalFileStoreThumbnailVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var MarkSuitableForReleaseDialog = (function () {
        function MarkSuitableForReleaseDialog(options) {
            var _this = this;
            this.open = function (documentIds) {
                var params = new URLSearchParams();
                for (var _i = 0, documentIds_5 = documentIds; _i < documentIds_5.length; _i++) {
                    var documentId = documentIds_5[_i];
                    params.append('documentIds', documentId.toString());
                }
                var seperator = _this.options.url.indexOf('?') !== -1 ? '&' : '?';
                var url = "" + _this.options.url + seperator + params.toString();
                $(_this.options.loadingElement).remote({
                    url: url,
                    afterRemote: function (data) {
                        var vm = new MarkSuitableForReleaseVm(data.urls, data.viewModel);
                        _this.onView(vm);
                    }
                });
            };
            this.options = options;
        }
        MarkSuitableForReleaseDialog.prototype.onView = function (vm) {
            var $editor = $('<div data-bind="template: { name: \'document-mark-suitable-for-release-ko-dialog\' }" data-dialog-width="70em"></div>');
            ko.applyBindings(vm, $editor[0]);
            Pb.Dialog.open({ content: $editor, confirmUnload: true });
        };
        return MarkSuitableForReleaseDialog;
    }());
    Pb.MarkSuitableForReleaseDialog = MarkSuitableForReleaseDialog;
    var MarkSuitableForReleaseVm = (function () {
        function MarkSuitableForReleaseVm(urls, data) {
            var _this = this;
            this.submit = function (vm, e) {
                var $button = $(e.target);
                var self = _this;
                $button.remote({
                    url: _this.urls.markSuitableForReleaseUrl,
                    method: 'post',
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        Pb.Dialog.close(function () {
                            for (var _i = 0, _a = result.updatedDocumentIds; _i < _a.length; _i++) {
                                var id = _a[_i];
                                Pb.raiseEvent('document.updated', 'Document updated.', { id: id });
                            }
                        });
                    }
                });
            };
            this.urls = urls;
            this.title = data.title;
            this.message = data.message;
            this.fileCountMessage = data.documents.length + " File" + (data.documents.length === 1 ? '' : 's') + " Selected";
            this.shouldShowRedactions = data.shouldShowRedactions;
            this.documents = data.documents.map(function (x) {
                return __assign({}, x, { viewDocumentVersionsPermissionLink: {
                        canPerformAction: x.canViewDocumentVersions,
                        onClick: function (e) {
                            Pb.openDocumentInNewWindow(x.documentVersionsUrl);
                        }
                    }, viewDocumentRedactionsPermissionLink: {
                        canPerformAction: x.canViewDocumentRedactions,
                        onClick: function (e) {
                            Pb.openDocumentInNewWindow(x.documentRedactionsUrl);
                        }
                    } });
            });
        }
        return MarkSuitableForReleaseVm;
    }());
    Pb.MarkSuitableForReleaseVm = MarkSuitableForReleaseVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var MatrixFileStoreRowVm = (function () {
        function MatrixFileStoreRowVm(data, displayVm) {
            var _this = this;
            this.open = function (contextMenuItemVm, e) {
                _this.onOpen(contextMenuItemVm, e);
            };
            this.onOpen = function (vm, e) {
                Pb.openDocumentInNewWindow(_this.actions.matrixFileStoreOpenUrl);
            };
            this.editProperties = function () {
                console.log("editProperties...");
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        Pb.raiseEvent('matrixFileStore.updated', 'Matrix File Store updated', {
                            id: _this.id
                        });
                    }
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('matrixFileStore.recycled', 'Matrix File Store recycled.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'Matrix File Store', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('matrixFileStore.restored', 'Matrix File Store restored.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    title: 'Restore Matrix File Store?',
                    message: 'Are you sure you want to restore this matrix file store?',
                    yesCaption: 'Restore',
                    noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.delete = function () {
            };
            this.discriminator = data.discriminator;
            this.key = data.key;
            this.id = data.id;
            this.documentVersionId = ko.observable(0);
            this.name = ko.observable(data.name);
            this.groupId = ko.observable(data.groupId);
            this.typeId = ko.observable(data.typeId);
            this.groupName = ko.observable(data.groupName);
            this.typeName = ko.observable(data.typeName);
            this.type = ko.observable(data.type);
            this.description = ko.observable(data.description);
            this.sources = ko.observable(data.sources);
            this.index = ko.observable(data.index);
            this.activityFrom = ko.observable(data.activityFrom);
            this.activityThru = ko.observable(data.activityThru);
            this.isOriginalStoredInFile = ko.observable(data.isOriginalStoredInFile);
            this.reviewState = ko.observable(data.reviewState);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.hasNotBeenViewedByUser = ko.computed(function () { return !_this.hasBeenViewedByUser(); });
            this.createdBy = data.createdBy;
            this.createdOn = data.createdOn;
            this.lastModifiedBy = ko.observable(data.lastModifiedBy);
            this.lastModifiedOn = ko.observable(data.lastModifiedOn);
            this.isConfidential = ko.observable(data.isConfidential);
            this.actions = data.actions;
            this.displayVm = displayVm;
            this.active = ko.observable(false);
            this.inserted = ko.observable(false);
            this.deleted = ko.observable(false);
            this.selected = ko.observable(false);
            this.hidden = ko.observable(false);
            this.isDragging = ko.observable(false);
            this.canOpenMatrixFileStore = ko.pureComputed(function () {
                return _this.actions.canOpenMatrixFileStore.hasPermission;
            });
            this.openMatrixFileStorePermissionLink = {
                canPerformAction: this.canOpenMatrixFileStore,
                onClick: function (e) {
                    _this.hasBeenViewedByUser(true);
                    _this.onOpen(_this, e);
                }
            };
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        }
        MatrixFileStoreRowVm.prototype.update = function (data) {
            this.name(data.name);
            this.groupId(data.groupId);
            this.typeId(data.typeId);
            this.groupName(data.groupName);
            this.typeName(data.typeName);
            this.type(data.type);
            this.description(data.description);
            this.sources(data.sources);
            this.index(data.index);
            this.activityFrom(data.activityFrom);
            this.activityThru(data.activityThru);
            this.isOriginalStoredInFile(data.isOriginalStoredInFile);
            this.reviewState(data.reviewState);
            this.hasBeenViewedByUser(data.hasBeenViewedByUser);
            this.lastModifiedBy(data.lastModifiedBy);
            this.lastModifiedOn(data.lastModifiedOn);
            this.isConfidential(data.isConfidential);
            this.contextMenu(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        };
        MatrixFileStoreRowVm.prototype.getCsrfToken = function () {
            var csrfField = document.querySelector('#page-anti-forgery-token > input[name="__RequestVerificationToken"]');
            return csrfField ? csrfField.value : '';
        };
        return MatrixFileStoreRowVm;
    }());
    Pb.MatrixFileStoreRowVm = MatrixFileStoreRowVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var MatrixFileStoreThumbnailVm = (function () {
        function MatrixFileStoreThumbnailVm(data, displayVm) {
            var _this = this;
            this.update = function (data) {
                _this.name(data.name);
                _this.description(data.description);
                _this.typeName(data.typeName);
                _this.groupName(data.groupName);
                _this.index(data.index);
                _this.source(data.source);
                _this.formattedDateReceived(data.formattedDateReceived);
                _this.isOriginalFileRetained(data.isOriginalFileRetained);
                _this.reviewState(data.reviewState);
                _this.formattedCreated(data.formattedCreated);
                _this.formattedModified(data.formattedModified);
                _this.hasBeenViewedByUser(data.hasBeenViewedByUser);
                _this.contextMenu(new Pb.DocumentContextMenuBuilder(_this)
                    .buildContextMenu(data.contextMenu.menuItems));
            };
            this.open = function (contextMenuItemVm, e) {
                _this.onOpen(contextMenuItemVm, e);
            };
            this.onOpen = function (vm, e) {
                Pb.openDocumentInNewWindow(_this.actions.matrixFileStoreOpenUrl);
            };
            this.editProperties = function () {
                console.log("editProperties...");
            };
            this.updateReviewState = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        Pb.raiseEvent('matrixFileStore.updated', 'Matrix File Store updated', {
                            id: _this.id
                        });
                    }
                });
            };
            this.markAsRead = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(true);
                    }
                });
            };
            this.markAsUnread = function (contextMenuItemVm, e) {
                $(e.target).remote({
                    url: contextMenuItemVm.source.linkUrl,
                    method: 'POST',
                    afterRemote: function () {
                        _this.hasBeenViewedByUser(false);
                    }
                });
            };
            this.recycle = function (contextMenuItemVm, e) {
                var onRecycle = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('matrixFileStore.recycled', 'Matrix File Store recycled.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    type: 'delete', recordName: 'Matrix File Store', verb: 'Recycle',
                    callback: onRecycle
                });
            };
            this.restore = function (contextMenuItemVm, e) {
                var onRestore = function () {
                    $(e.target).remote({
                        url: contextMenuItemVm.source.linkUrl,
                        method: 'POST',
                        afterRemote: function (result) {
                            if (!result.error) {
                                Pb.raiseEvent('matrixFileStore.restored', 'Matrix File Store restored.', {
                                    id: _this.id
                                });
                            }
                        }
                    });
                };
                Pb.Confirmation.show({
                    title: 'Restore Matrix File Store?',
                    message: 'Are you sure you want to restore this matrix file store?',
                    yesCaption: 'Restore',
                    noCaption: 'Cancel',
                    callback: onRestore
                });
            };
            this.delete = function () {
            };
            this.discriminator = 'MatrixFileStore';
            this.id = data.id;
            this.documentVersionId = ko.observable(0);
            this.key = data.key;
            this.name = ko.observable(data.name);
            this.description = ko.observable(data.description);
            this.typeName = ko.observable(data.typeName);
            this.groupName = ko.observable(data.groupName);
            this.index = ko.observable(data.index);
            this.source = ko.observable(data.source);
            this.formattedDateReceived = ko.observable(data.formattedDateReceived);
            this.isOriginalFileRetained = ko.observable(data.isOriginalFileRetained);
            this.reviewState = ko.observable(data.reviewState);
            this.formattedCreated = ko.observable(data.formattedCreated);
            this.formattedModified = ko.observable(data.formattedModified);
            this.hasBeenViewedByUser = ko.observable(data.hasBeenViewedByUser);
            this.canOpenMatrixFileStore = ko.pureComputed(function () {
                return _this.actions.canOpenMatrixFileStore.hasPermission;
            });
            this.formattedType = ko.pureComputed(function () { return _this.typeName() + " (" + _this.groupName() + ")"; });
            this.hasNotBeenViewedByUser = ko.pureComputed(function () { return !_this.hasBeenViewedByUser(); });
            this.canEditProperties = ko.pureComputed(function () {
                return _this.actions.canEditMatrixFileStore.hasPermission;
            });
            this.displayVm = displayVm;
            this.thumbnailHeight = ko.observable(data.thumbnailHeight);
            this.thumbnailWidth = ko.observable(data.thumbnailWidth);
            this.displayHeight = ko.observable(data.thumbnailHeight);
            this.displayWidth = ko.observable(data.thumbnailWidth);
            this.displayWidthPx = ko.pureComputed(function () { return _this.displayWidth() + "px"; });
            this.displayHeightPx = ko.pureComputed(function () { return _this.displayHeight() + "px"; });
            this.active = ko.observable(false);
            this.inserted = ko.observable(false);
            this.deleted = ko.observable(false);
            this.selected = ko.observable(false);
            this.hidden = ko.observable(false);
            this.isDragging = ko.observable(false);
            this.actions = data.actions;
            this.contextMenu = ko.observable(new Pb.DocumentContextMenuBuilder(this)
                .buildContextMenu(data.contextMenu.menuItems));
        }
        return MatrixFileStoreThumbnailVm;
    }());
    Pb.MatrixFileStoreThumbnailVm = MatrixFileStoreThumbnailVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var MatrixLocalFilesApplication = (function () {
        function MatrixLocalFilesApplication(cookieName, downloadUrl) {
            var _this = this;
            this.sendCommand = function (url) {
                if (url.protocol.toLowerCase() !== 'matrixlocalfiles:') {
                    throw Error("MatrixLocalFiles does not support the '" + url.protocol + "' protocol");
                }
                function sendCommand() {
                    window.location.assign(url.toString());
                }
                if (_this.isOptOutCookieSet()) {
                    sendCommand();
                }
                else {
                    _this.showDialog().then(function (setCookie) {
                        if (setCookie) {
                            _this.setOptOutCookie();
                        }
                        sendCommand();
                    });
                }
            };
            this.isOptOutCookieSet = function () {
                var optOut = document.cookie.indexOf(_this.cookieName + '=') >= 0;
                if (optOut) {
                    _this.setOptOutCookie();
                }
                return optOut;
            };
            this.setOptOutCookie = function () {
                document.cookie = _this.cookieName + "=true;path=/;max-age=31536000";
            };
            this.showDialog = function () {
                return new Promise(function (resolve) {
                    var secondaryMessage = "\n          Don't have the MatrixLocalFiles application? <a href='" + _this.downloadUrl + "'>Download it now</a>\n          <div style='position: absolute; bottom: 1.5em;'>\n            <label>\n              <input id='" + _this.cookieName + "' type='checkbox' checked='checked' />\n              Don't show this message again\n            </label>\n          </div>\n        ";
                    Pb.Confirmation.show({
                        title: null,
                        message: 'MatrixLocalFiles is required to fully use this feature',
                        secondaryMessage: secondaryMessage,
                        yesCaption: 'Continue',
                        noCaption: null,
                        stayOpen: true,
                        callback: function (e) {
                            var optOutCheckbox = document.getElementById(_this.cookieName);
                            resolve(optOutCheckbox.checked);
                            e.closePopup();
                        }
                    });
                });
            };
            this.cookieName = cookieName;
            this.downloadUrl = downloadUrl;
        }
        return MatrixLocalFilesApplication;
    }());
    Pb.MatrixLocalFilesApplication = MatrixLocalFilesApplication;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentExplorer;
    (function (DocumentExplorer) {
        var MoveToFolderDialog = (function () {
            function MoveToFolderDialog(rows, data) {
                var _this = this;
                this.open = function () {
                    var $content = $('<div data-bind="template: { name: \'document-explorer-move-to-folder-ko-dialog\' }" data-dialog-width="40em"></div>');
                    ko.applyBindings(_this, $content[0]);
                    Pb.Dialog.open({
                        content: $content,
                        confirmUnload: true
                    });
                };
                this.onMoveToFolder = function (vm, e) {
                    $(e.target).remote({
                        url: _this.updateUrl,
                        method: 'POST',
                        data: {
                            documentIds: _this.rows.map(function (row) { return row.id; }).join(','),
                            folderId: _this.folderId
                        },
                        afterRemote: function (data) {
                            if (data.hasErrors) {
                                _this.errors(ko.bindingHandlers.matrixPropertyError.map(data.errors));
                            }
                            else {
                                Pb.Dialog.close();
                                if (data.folderId !== _this.originalFolderId) {
                                    _this.rows.forEach(function (row) { return row.deleted(true); });
                                    Pb.FlashMessage.show("Document" + (_this.rows.length > 1 ? 's' : '') + " moved to " + data.folderName);
                                }
                            }
                        }
                    });
                };
                this.rows = rows;
                this.folders = data.viewModel.folders;
                this.folderId = ko.observable(data.viewModel.folderId);
                this.originalFolderId = data.viewModel.folderId;
                this.updateUrl = data.urls.updateUrl;
                this.errors = ko.observable();
            }
            return MoveToFolderDialog;
        }());
        DocumentExplorer.MoveToFolderDialog = MoveToFolderDialog;
    })(DocumentExplorer = Pb.DocumentExplorer || (Pb.DocumentExplorer = {}));
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var MultipleCreateDocumentDialog = (function () {
        function MultipleCreateDocumentDialog() {
        }
        MultipleCreateDocumentDialog.open = function (options) {
            $(options.loadingElement).remote({
                url: options.newDocumentUrl,
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-multiple-new-ko-dialog\' }" data-dialog-width="60em"></div>');
                    var vm = new MultipleDocumentCreateVm({
                        urls: data.urls,
                        files: options.files,
                        binderId: options.binderId,
                        folderId: options.folderId,
                        createVmTemplate: data.viewModel
                    });
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return MultipleCreateDocumentDialog;
    }());
    Pb.MultipleCreateDocumentDialog = MultipleCreateDocumentDialog;
    var MultipleDocumentCreateVm = (function () {
        function MultipleDocumentCreateVm(data) {
            var _this = this;
            this.skipRemainingFiles = function () {
                while (!_this.status.allUploadsStarted()) {
                    _this.skipFile();
                }
            };
            this.skipFile = function () {
                _this.currentDocumentCreateVm().wasSkipped(true);
                _this.moveNext();
            };
            this.moveNext = function () {
                var currentDocumentTypeId = _this.currentDocumentCreateVm().typeId();
                if (_this.currentFileIndex() < _this.documentCreateVms.length - 1) {
                    _this.currentFileIndex(_this.currentFileIndex() + 1);
                    _this.currentDocumentCreateVm().typeId(currentDocumentTypeId);
                }
            };
            var buildDocumentCreateVm = function (file, i, folderId) {
                var createVm = new Pb.DocumentCreateVm(data.urls, data.createVmTemplate, { folderId: data.folderId, binderId: data.binderId });
                createVm.allowSimultaneousRequests = true;
                createVm.file(file);
                createVm.submitButtonText = i == data.files.length - 1 ? 'Finish' : 'Next';
                createVm.wasSkipped = ko.observable(false);
                createVm.wasUploadAttempted = ko.observable(false);
                createVm.isUploadFinished = ko.pureComputed(function () {
                    return createVm.wasUploadAttempted() && (createVm.hasErrors() || createVm.isUploaded());
                });
                createVm.isUploading.subscribe(function (value) {
                    if (value) {
                        createVm.wasUploadAttempted(true);
                        _this.moveNext();
                    }
                });
                return createVm;
            };
            this.documentCreateVms = _.map(data.files, buildDocumentCreateVm);
            this.currentFileIndex = ko.observable(0);
            this.currentDocumentCreateVm = ko.pureComputed(function () { return _this.documentCreateVms[_this.currentFileIndex()]; });
            this.currentFileMessage = ko.pureComputed(function () { return 'Uploading ' + (_this.currentFileIndex() + 1) + ' of ' + data.files.length + '...'; });
            this.status = new MultiuploadStatusVm(this.documentCreateVms, data.files.length);
            this.status.allUploadsStarted.subscribe(function (value) {
                if (value && _this.status.totalUploadFilesAttempted() == 0)
                    Pb.Dialog.close();
            });
        }
        return MultipleDocumentCreateVm;
    }());
    Pb.MultipleDocumentCreateVm = MultipleDocumentCreateVm;
    ;
    var MultiuploadStatusVm = (function () {
        function MultiuploadStatusVm(documentCreateVms, totalFileCount) {
            var _this = this;
            this.totalUploadFilesAttempted = ko.computed(function () {
                return _.filter(documentCreateVms, function (vm) { return vm.wasUploadAttempted(); }).length;
            });
            this.totalUploadErrors = ko.pureComputed(function () {
                return _.filter(documentCreateVms, function (vm) { return vm.hasErrors(); }).length;
            });
            this.anyUploadsStarted = ko.pureComputed(function () { return _this.totalUploadFilesAttempted() > 0; });
            this.anyUploadErrors = ko.pureComputed(function () { return _this.totalUploadErrors() > 0; });
            this.allUploadsStarted = ko.pureComputed(function () {
                return _.last(documentCreateVms).wasUploadAttempted() || _.last(documentCreateVms).wasSkipped();
            });
            this.allUploadsFinished = ko.pureComputed(function () {
                return _.filter(documentCreateVms, function (vm) { return vm.isUploadFinished() || vm.wasSkipped(); }).length === totalFileCount;
            });
            this.multiUploadPercent = ko.pureComputed(function () {
                var uploadedBytes = _.reduce(documentCreateVms, function (bytes, vm) { return bytes + vm.uploadedBytes(); }, 0);
                var totalBytes = _.reduce(documentCreateVms, function (bytes, vm) { return bytes + vm.totalBytes(); }, 0);
                return totalBytes !== 0 ? Math.floor(uploadedBytes / totalBytes * 100.0) : 0;
            });
            this.multiUploadStatus = ko.pureComputed(function () {
                return !_this.allUploadsFinished() ? 'Uploading ' + _this.totalUploadFilesAttempted() + ' document' + (_this.totalUploadFilesAttempted() > 1 ? 's' : '') :
                    _this.anyUploadErrors() ? 'Failed to upload ' + _this.totalUploadErrors() + ' document' + (_this.totalUploadErrors() > 1 ? 's' : '') + '.' :
                        'Successfully uploaded ' + _this.totalUploadFilesAttempted() + ' document' + (_this.totalUploadFilesAttempted() > 1 ? 's' : '') + '.';
            });
            this.multiUploadErrors = ko.pureComputed(function () {
                var i = 0, errors = {};
                if (!_this.allUploadsFinished()) {
                    return errors;
                }
                _.chain(documentCreateVms)
                    .filter(function (vm) { return vm.hasErrors(); })
                    .map(function (vm) {
                    return {
                        fileName: Pb.FileName.truncateEllipsis(vm.fileMetadata.fileName(), 56),
                        errors: vm.errors()
                    };
                })
                    .each(function (errorData) {
                    errors[i++] = errorData.fileName + ': ' + errorData.errors[_.keys(errorData.errors)[0]];
                }).value();
                return errors;
            });
        }
        return MultiuploadStatusVm;
    }());
    Pb.MultiuploadStatusVm = MultiuploadStatusVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentBinderDialog = (function () {
        function DocumentBinderDialog() {
        }
        DocumentBinderDialog.open = function (options) {
            var createDocumentBinderUrl = options.createDocumentBinderUrl;
            var loadingElement = options.loadingElement;
            $(loadingElement).remote({
                url: createDocumentBinderUrl,
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-binder-ko-dialog\' }" data-dialog-width="40em"></div>');
                    var vm = new DocumentBinderEditVm(data);
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return DocumentBinderDialog;
    }());
    Pb.DocumentBinderDialog = DocumentBinderDialog;
    var DocumentBinderEditVm = (function () {
        function DocumentBinderEditVm(data) {
            var _this = this;
            this.createBinder = function (vm, e) {
                $(e.target).remote({
                    url: _this.createBinderUrl(),
                    method: 'post',
                    data: ko.toJSON(_this),
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                        }
                        else {
                            Pb.Dialog.close();
                            Pb.raiseEvent('document.binderCreated', 'Binder created.', result);
                        }
                    }
                });
            };
            ko.mapping.fromJS(data, {}, this);
            this.errors = ko.observable({});
        }
        DocumentBinderEditVm.prototype.close = function () {
            Pb.Dialog.close();
        };
        return DocumentBinderEditVm;
    }());
    Pb.DocumentBinderEditVm = DocumentBinderEditVm;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentNewFolderDialog = (function () {
        function DocumentNewFolderDialog() {
        }
        DocumentNewFolderDialog.open = function (options) {
            var createDocumentFolderUrl = options.createDocumentFolderUrl;
            var loadingElement = options.loadingElement;
            $(loadingElement).remote({
                url: createDocumentFolderUrl,
                data: { binderId: options.binderId, parentFolderId: options.folderId },
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-folder-create-ko-dialog\' }" data-dialog-width="40em"></div>');
                    var vm = new Pb.DocumentFolderEditVm(data);
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return DocumentNewFolderDialog;
    }());
    Pb.DocumentNewFolderDialog = DocumentNewFolderDialog;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    function openDocumentInNewWindow(docUrl) {
        var maxHeight = window.screen.availHeight - (window.outerHeight - window.innerHeight);
        var width = 1.3 * maxHeight;
        var newWin = window.open(docUrl, docUrl, "width=" + width + ",height=" + maxHeight);
        if (!!newWin && !!window.chrome) {
            newWin.moveTo(0, 0);
            newWin.focus();
        }
    }
    Pb.openDocumentInNewWindow = openDocumentInNewWindow;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var DocumentRenameFolderDialog = (function () {
        function DocumentRenameFolderDialog() {
        }
        DocumentRenameFolderDialog.open = function (options) {
            var renameDocumentFolderUrl = options.renameDocumentFolderUrl;
            var loadingElement = options.loadingElement;
            $(loadingElement).remote({
                url: renameDocumentFolderUrl,
                data: { binderId: options.binderId, folderId: options.folderId },
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'document-folder-rename-ko-dialog\' }" data-dialog-width="40em"></div>');
                    var vm = new Pb.DocumentFolderEditVm(data);
                    vm.dialogTitle = data.isRootFolder ? 'Rename Binder' : 'Rename Folder';
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({ content: $editor, confirmUnload: true });
                }
            });
        };
        return DocumentRenameFolderDialog;
    }());
    Pb.DocumentRenameFolderDialog = DocumentRenameFolderDialog;
})(Pb || (Pb = {}));
var Pb;
(function (Pb) {
    var ReorderVm = (function () {
        function ReorderVm(data, options) {
            var _this = this;
            this.moveDocument = function (documentVm, newOrder) {
                _this.documents.remove(documentVm);
                _this.documents.splice(newOrder - 1, 0, documentVm);
                _this.reorderDocuments();
                if (documentVm.previousOrder !== newOrder) {
                    $('#ordered-document-' + documentVm.id).flash();
                }
            };
            this.reorderDocuments = function () {
                _this.documents().forEach(function (documentVm, index) {
                    documentVm.order(index + 1);
                    documentVm.previousOrder = index + 1;
                });
            };
            this.onSave = function (vm, e) {
                var documents = _this.documents()
                    .map(function (d) { return ({
                    id: d.id,
                    name: d.name,
                    order: d.order()
                }); });
                $(e.target).remote({
                    url: _this.reorderUpdateUrl,
                    method: 'POST',
                    data: ko.toJSON({ documents: documents }),
                    contentType: 'application/json',
                    afterRemote: function (result) {
                        if (result.errors) {
                            _this.errors(ko.bindingHandlers.matrixPropertyError.map(result.errors));
                        }
                        else {
                            Pb.ConfirmUnload.off();
                            Pb.Dialog.close();
                            if (_this.afterSave) {
                                _this.afterSave();
                            }
                        }
                    }
                });
            };
            this.documents = ko.observableArray(data.documents
                .map(function (d) { return new ReorderDocumentVm(d, _this); }));
            this.reorderUpdateUrl = data.reorderUpdateUrl;
            this.errors = ko.observable(null);
            this.afterSave = options.afterSave;
        }
        ReorderVm.prototype.onCancel = function () {
            Pb.Dialog.close();
        };
        ;
        return ReorderVm;
    }());
    Pb.ReorderVm = ReorderVm;
    var ReorderDocumentVm = (function () {
        function ReorderDocumentVm(data, parentVm) {
            var _this = this;
            this.moveToTop = function () {
                _this.order(1);
                _this.isChangingOrder(false);
            };
            this.moveToBottom = function () {
                _this.order(_this.parentVm.documents().length);
                _this.isChangingOrder(false);
            };
            this.onChangeOrderClick = function (data, e) {
                $(e.target).parent().find('.change-order').select();
                _this.isChangingOrder(true);
                e.stopPropagation();
            };
            this.onChangeOrderKeyPress = function (party, e) {
                if (e.which == Matrix.Keys.Enter) {
                    $(e.target).change().blur();
                    return false;
                }
                else {
                    return true;
                }
            };
            this.parentVm = parentVm;
            this.id = data.id;
            this.name = data.name;
            this.order = ko.observable(data.order);
            this.previousOrder = data.order;
            this.isChangingOrder = ko.observable(false);
            this.isChangingOrder.subscribe(function (newValue) {
                if (newValue || _this.order() === _this.previousOrder) {
                    return;
                }
                if (isNaN(_this.order())) {
                    _this.order(_this.previousOrder);
                }
                else if (_this.order() < 1) {
                    _this.order(1);
                }
                else if (_this.order() > parentVm.documents().length) {
                    _this.order(_this.parentVm.documents().length);
                }
                _this.parentVm.moveDocument(_this, _this.order());
                _this.previousOrder = _this.order();
            });
        }
        return ReorderDocumentVm;
    }());
    Pb.ReorderDocumentVm = ReorderDocumentVm;
    var ReorderDialog = (function () {
        function ReorderDialog() {
        }
        ReorderDialog.prototype.open = function (options) {
            var loadingElement = options.loadingElement;
            var reorderEditUrl = options.reorderEditUrl;
            var binderId = options.binderId;
            var folderId = options.folderId;
            var afterSave = options.afterSave;
            $(loadingElement).remote({
                url: reorderEditUrl,
                data: {
                    binderId: binderId,
                    folderId: folderId
                },
                afterRemote: function (data) {
                    var $editor = $('<div data-bind="template: { name: \'reorder-ko-dialog\'}" data-dialog-width="50em"></div>');
                    var vm = new ReorderVm(data, {
                        afterSave: afterSave
                    });
                    ko.applyBindings(vm, $editor[0]);
                    Pb.Dialog.open({
                        content: $editor,
                        id: 'reorder-dialog',
                        confirmUnload: true
                    });
                    $('#document-order-list > tbody', $editor).sortable({
                        items: 'tr',
                        handle: '.reorder-handle',
                        tolerance: 'pointer',
                        placeholder: 'selected',
                        cursor: function () {
                            var dummy = $('<div class="cursor-grabbing"><div>').hide().appendTo('body');
                            var style = dummy.css('cursor');
                            dummy.remove();
                            return style;
                        }(),
                        helper: function ($event, $item) {
                            var documentVm = ko.dataFor($item[0]);
                            documentVm.isChangingOrder(false);
                            return '<table class="grid-content pure-table">'
                                + '<colgroup>'
                                + '<col style="width: 3rem;">'
                                + '<col style="width: 13rem;">'
                                + '<col style="width: 30rem;">'
                                + '</colgroup>'
                                + $item[0].outerHTML
                                + '</table>';
                        },
                        stop: function (event, ui) {
                            var documentVm = ko.dataFor(ui.item[0]);
                            var finalPos = ui.item.index();
                            ui.item.remove();
                            documentVm.order(finalPos + 1);
                            vm.moveDocument(documentVm, finalPos + 1);
                        }
                    });
                }
            });
        };
        return ReorderDialog;
    }());
    Pb.ReorderDialog = ReorderDialog;
})(Pb || (Pb = {}));
var Matrix;
(function (Matrix) {
    var SelectedDocument = (function () {
        function SelectedDocument(data, selected) {
            var _this = this;
            this.hasAttachments = ko.pureComputed(function () { return _this.attachments && _this.attachments.length > 0; });
            this.id = data.id;
            this.attachmentIdentifier = data.attachmentIdentifier;
            this.documentVersionId = data.documentVersionId;
            this.redactionId = data.redactionId;
            this.signedDocumentId = data.signedDocumentId;
            this.key = data.key;
            this.lastModifiedOn = data.lastModifiedOn;
            this.lastModifiedOnString = data.lastModifiedOnString;
            this.lastModifiedBy = data.lastModifiedBy;
            this.name = data.name;
            this.description = data.description;
            this.__type = data.__type;
            this.redactionComments = data.redactionComments;
            this.signedDocumentComments = data.signedDocumentComments;
            this.jsViewModelName = data.jsViewModelName;
            this.type = data.type;
            this.fileExtension = data.fileExtension;
            this.fileExtensionClass = data.fileExtensionClass;
            this.fileExtensionTitle = data.fileExtensionTitle;
            this.fileSize = data.fileSize;
            this.isConfidential = data.isConfidential;
            this.isFileValid = data.isFileValid;
            this.fileValidationError = data.fileValidationError;
            this.isPdfConvertable = data.isPdfConvertable;
            this.isRestricted = data.isRestricted;
            this.isUserAuthorized = data.isUserAuthorized;
            this.folder = data.folder;
            this.downloadUrl = data.downloadUrl;
            this.viewVersionUrl = data.viewVersionUrl;
            this.attachments = data.attachments;
            this.attachmentReference = data.attachmentReference;
            this.isSelected = ko.observable(selected && (selected.isSelected() || selected.includedAsAttachment()));
            this.includeAttachments = ko.observable(selected && selected.includeAttachments());
            this.references = ko.observable('');
            this.includedAsAttachmentTo = ko.observableArray(selected ? selected.includedAsAttachmentTo() : []);
            this.someVersionIncludedAsAttachmentTo = ko.observableArray(selected ? selected.someVersionIncludedAsAttachmentTo() : []);
            this.includedAsAttachment = ko.computed(function () { return _this.someVersionIncludedAsAttachmentTo().length > 0; });
        }
        SelectedDocument.FromVm = function (vm) {
            var redactionVm = vm instanceof Pbs.Documents.SpryUI.ViewModels.SelectDocuments.SelectRedactionViewModel ? vm : null;
            var signedDocumentVm = vm instanceof Pbs.Documents.SpryUI.ViewModels.SelectDocuments.SelectSignedDocumentViewModel ? vm : null;
            return new SelectedDocument({
                id: vm.id(),
                attachmentIdentifier: vm.attachmentIdentifier(),
                documentVersionId: vm.documentVersionId(),
                redactionId: redactionVm ? redactionVm.redactionId() : null,
                signedDocumentId: signedDocumentVm ? signedDocumentVm.signedDocumentId() : null,
                key: vm.key(),
                lastModifiedOn: vm.lastModifiedOn(),
                lastModifiedOnString: vm.lastModifiedOnString(),
                lastModifiedBy: vm.lastModifiedBy(),
                name: vm.name(),
                description: vm.description(),
                __type: vm.__type(),
                redactionComments: redactionVm ? redactionVm.redactionComments() : null,
                signedDocumentComments: signedDocumentVm ? signedDocumentVm.signedDocumentComments() : null,
                jsViewModelName: vm.jsViewModelName(),
                type: vm.type(),
                fileExtension: vm.fileExtension(),
                fileExtensionClass: vm.fileExtensionClass(),
                fileExtensionTitle: vm.fileExtensionTitle(),
                fileSize: vm.fileSize(),
                isConfidential: vm.isConfidential(),
                isPdfConvertable: vm.isPdfConvertable(),
                isRestricted: vm.isRestricted(),
                isUserAuthorized: vm.isUserAuthorized(),
                isFileValid: vm.isFileValid(),
                fileValidationError: vm.fileValidationError(),
                folder: vm.folder(),
                downloadUrl: vm.downloadUrl(),
                viewVersionUrl: vm.viewVersionUrl(),
                attachments: vm.attachments(),
                attachmentReference: vm.attachmentReference()
            }, null);
        };
        return SelectedDocument;
    }());
    Matrix.SelectedDocument = SelectedDocument;
    var SelectDocumentsViewModel = (function () {
        function SelectDocumentsViewModel(options) {
            var _this = this;
            this.sortHeaders = ko.pureComputed(function () {
                return {
                    currentSortState: _this.filterVm.getSortState(),
                    sort: _this.filterVm.changeSort
                };
            });
            this.filterResultsMessage = ko.observable('');
            this.errors = ko.observable({});
            this.searchText = ko.observable('');
            this.documents = ko.observableArray([]);
            this.empty = ko.pureComputed(function () { return _this.documents().length == 0; });
            this.allDocuments = ko.observableArray([]);
            this.selectedDocuments = ko.computed(function () { return _this.allDocuments().filter(function (d) { return d.isSelected(); }); });
            this.allDocumentsDictionary = ko.computed(function () {
                return _this.allDocuments().reduce(function (result, d) {
                    result[d.key] = d;
                    return result;
                }, {});
            });
            this.selectedDocumentsCount = ko.pureComputed(function () { return _this.selectedDocuments().length; });
            this.hasSelectedDocuments = ko.pureComputed(function () { return _this.selectedDocumentsCount() > 0; });
            this.disableSortAndFilter = ko.pureComputed(function () { return _this.hasSelectedDocuments(); });
            this.sortTitle = ko.pureComputed(function () { return _this.disableSortAndFilter() ? "Cannot sort with documents selected; clear selection to sort" : ""; });
            this.filterTitle = ko.pureComputed(function () { return _this.disableSortAndFilter() ? "Cannot filter with documents selected; clear selection to filter" : ""; });
            this.searching = ko.observable(true);
            this.hasFilter = ko.pureComputed(function () { return false; });
            this.emptyMessage = ko.pureComputed(function () {
                if (_this.hasFilter())
                    return "No files were returned with the current filter.";
                else
                    return "No files found.";
            });
            this.addDocumentsText = ko.pureComputed(function () {
                if (_this.hasSelectedDocuments()) {
                    var suffix = _this.selectedDocumentsCount() > 1 ? "s" : "";
                    return _this.selectedDocumentsCount() + " File" + suffix + " Selected";
                }
                else {
                    return "No files selected";
                }
            });
            this.addDocumentsTooltip = ko.pureComputed(function () {
                if (_this.hasSelectedDocuments())
                    return "";
                else
                    return "You must select at least one file to add";
            });
            this.selectAllClick = function (vm, event) {
                try {
                    if (_this.allDocumentsSelected())
                        _this.deselectAllDocuments();
                    else
                        _this.selectAllDocuments();
                }
                finally {
                    window.requestAnimationFrame(function () { return $(event.target).prop('checked', _this.selectAllChecked()); });
                }
            };
            this.addDocumentsClick = function () {
                _this.documentSelectedCallback(_this.selectedDocuments(), _this);
            };
            this.allDocumentsSelected = function () {
                var allDocumentIds = _.uniq(_this.documents().map(function (d) { return d.id(); }));
                var selectedDocumentIds = _this.selectedDocuments().map(function (d) { return d.id; });
                return _.isEqual(_.sortBy(allDocumentIds), _.sortBy(selectedDocumentIds));
            };
            this.selectAllDocuments = function () {
                var idGroups = _.groupBy(_this.allDocuments(), function (d) { return d.id; });
                for (var documentId in idGroups) {
                    var documentsById = idGroups[documentId];
                    var sortedDocuments = _.chain(documentsById)
                        .sortBy(function (d) { return -(new Date(d.lastModifiedOn.toString()).getTime()); })
                        .sortBy(function (d) { return d.redactionId ? 0 : 1; })
                        .sortBy(function (d) { return d.signedDocumentId ? 0 : 1; })
                        .value();
                    sortedDocuments[0].isSelected(false);
                    sortedDocuments[0].includeAttachments(true);
                    _this.toggleSelected(sortedDocuments[0]);
                }
                _this.documents().forEach(function (d) {
                    if (d.hasAttachments) {
                        d.includeAttachments(true);
                        _this.toggleAttachments(d);
                    }
                });
            };
            this.deselectAllDocuments = function () {
                _this.allDocuments()
                    .forEach(function (d) {
                    d.isSelected(false);
                    d.includeAttachments(false);
                    d.includedAsAttachmentTo([]);
                    d.someVersionIncludedAsAttachmentTo([]);
                });
                _this.documents()
                    .filter(function (d) { return d.selected(); })
                    .forEach(function (d) { return _this.toggleAttachments(d); });
            };
            this.setSelected = function (document, selected) {
                _this.allDocuments()
                    .filter(function (d) { return d.key == document.key; })
                    .forEach(function (d) { return d.isSelected(selected); });
                if (selected) {
                    if (_this.isSingleSelectionMode)
                        _this.deselectOtherDocuments(document);
                    else
                        _this.deselectSameDocuments(document);
                }
            };
            this.toggleSelected = function (document) {
                _this.setSelected(document, !document.isSelected());
            };
            this.toggleAttachments = function (documentVm) {
                var documentsById = {};
                var documentsByIdentifier = {};
                _this.allDocuments().forEach(function (document) {
                    if (!documentsById[document.id])
                        documentsById[document.id] = [];
                    documentsById[document.id].push(document);
                    documentsByIdentifier[document.attachmentIdentifier] = document;
                }, {});
                var allDocument = _this.findOrCreateAllDocumentEntry(documentVm);
                var includeAttachments = documentVm.includeAttachments();
                allDocument.includeAttachments(includeAttachments);
                _this.toggleAttachmentsRecursive(allDocument, includeAttachments, documentsById, documentsByIdentifier, {});
            };
            this.findAllDocumentEntry = function (key) {
                return _this.allDocumentsDictionary()[key];
            };
            this.findOrCreateAllDocumentEntry = function (documentVm) {
                if (_this.findAllDocumentEntry(documentVm.key()) == null)
                    _this.allDocuments.push(SelectedDocument.FromVm(documentVm));
                return _this.findAllDocumentEntry(documentVm.key());
            };
            this.toggleAttachmentsRecursive = function (document, includeAttachments, documentsById, documentsByIdentifier, visitedDocuments) {
                visitedDocuments[document.id] = document;
                var attachments = document.attachments;
                attachments.forEach(function (attachment) {
                    var attachedDocument = documentsByIdentifier[attachment.identifier];
                    var attachmentReference = document.attachmentReference ? document.attachmentReference : document.name;
                    var attachmentTo = attachmentReference + " ATT-" + attachment.number;
                    if (!attachedDocument || visitedDocuments[attachedDocument.id])
                        return;
                    if (includeAttachments) {
                        if (!attachedDocument.includedAsAttachmentTo().some(function (existingAttachmentTo) { return attachmentTo == existingAttachmentTo; }))
                            attachedDocument.includedAsAttachmentTo.push(attachmentTo);
                        documentsById[attachedDocument.id].forEach(function (d) { return d.someVersionIncludedAsAttachmentTo.push(attachmentTo); });
                    }
                    else {
                        attachedDocument.includedAsAttachmentTo.remove(attachmentTo);
                        documentsById[attachedDocument.id].forEach(function (d) { return d.someVersionIncludedAsAttachmentTo.remove(attachmentTo); });
                    }
                    attachedDocument.isSelected(attachedDocument.includedAsAttachment());
                    attachedDocument.includeAttachments(false);
                    _this.setSelected(attachedDocument, attachedDocument.isSelected());
                    _this.toggleAttachmentsRecursive(attachedDocument, false, documentsById, documentsByIdentifier, visitedDocuments);
                });
            };
            this.isSelected = function (key) {
                var allDoc = _this.findAllDocumentEntry(key);
                return allDoc ? (allDoc.isSelected() || allDoc.includedAsAttachment()) : false;
            };
            this.includedAsAttachmentTo = function (key) {
                var allDoc = _this.findAllDocumentEntry(key);
                return allDoc ? allDoc.includedAsAttachmentTo() : [];
            };
            this.someVersionIncludedAsAttachmentTo = function (key) {
                var allDoc = _this.findAllDocumentEntry(key);
                return allDoc ? allDoc.someVersionIncludedAsAttachmentTo() : [];
            };
            this.search = function (resetPaging) {
                if (resetPaging === void 0) { resetPaging = false; }
                _this.searching(true);
                if (resetPaging)
                    _this.filterVm.pager.reset();
                var data = ko.toJS(_this.filterVm.data);
                var customFilterProvider = _this.filterFlyoutVm.customFilterProvider;
                if (customFilterProvider)
                    customFilterProvider.addCustomFilterData(data);
                var searchRequiresPost = customFilterProvider ? customFilterProvider.searchRequiresPost : _this.searchRequiresPost;
                var searchMethod = searchRequiresPost ? 'POST' : 'GET';
                _this.transformFilterData(data, _this);
                $('<div></div>').remote({
                    url: _this.documentSearchUrl,
                    data: data,
                    method: searchMethod,
                    showSpinner: false,
                    afterRemote: function (data) {
                        _this.allDocuments(data.allDocuments.map(function (d) {
                            var selectedDoc = _this.allDocumentsDictionary()[d.key];
                            return new SelectedDocument(d, selectedDoc);
                        }));
                        _this.documents(data.documents ? data.documents.map(function (documentDto) {
                            var selectedDoc = _this.allDocumentsDictionary()[documentDto.key];
                            documentDto.selected = documentDto.selected || (selectedDoc && (selectedDoc.isSelected() || selectedDoc.includedAsAttachment()));
                            var ctor = Pb.getObjectByName(documentDto.jsViewModelName, window);
                            var vm = new ctor(documentDto, _this.isSelected, _this.includedAsAttachmentTo, _this.someVersionIncludedAsAttachmentTo);
                            vm.includeAttachments(selectedDoc && selectedDoc.includeAttachments());
                            vm.includedMessage(_this.getDocumentIncludedMessage(documentDto.id));
                            return vm;
                        }) : []);
                        _this.documents().forEach(function (document) {
                            if (!document.selected() || !document.includeAttachments() || document.includedAsAttachment())
                                return;
                            _this.toggleAttachments(document);
                        });
                        _this.searching(false);
                        if (data.filterResultsMessage)
                            _this.filterResultsMessage(new Pb.FilterResultsMessageVm(data.filterResultsMessage).text());
                        _this.filterVm.pager.update(data.pager);
                        _this.filterFlyoutVm.documentTypeOptions(data.documentTypeOptions);
                        _this.filterFlyoutVm.documentBinderOptions(data.documentBinderOptions);
                        _this.filterFlyoutVm.documentReviewStateOptions(data.documentReviewStateOptions);
                        _this.filterFlyoutVm.documentTypeLabel(data.documentTypeLabel);
                        _this.filterFlyoutVm.documentReviewStateLabel(data.documentReviewStateLabel);
                        $(window).trigger('resize');
                    }
                });
            };
            this.closeDialog = function () {
                Pb.Dialog.close();
            };
            this.documentRowClicked = function (documentVm, e) {
                if (documentVm.includedAsAttachment())
                    return;
                var selected = !documentVm.selected();
                _this.toggleSelected(_this.findOrCreateAllDocumentEntry(documentVm));
                documentVm.includeAttachments(selected);
                _this.toggleAttachments(documentVm);
                e.stopPropagation();
            };
            this.includeAttachmentsRowClicked = function (documentVm, e) {
                if (documentVm.includedAsAttachment())
                    return;
                documentVm.includeAttachments(!documentVm.includeAttachments());
                _this.toggleAttachments(documentVm);
            };
            this.documentSearchUrl = options.documentSearchUrl;
            this.getDocumentIncludedMessage = options.getDocumentIncludedMessage || (function () { return null; });
            this.transformFilterData = options.transformFilterData || (function (data) { return data; });
            this.filterTemplateName = options.filterTemplateName || 'default-filter-template';
            this.lastColumn = options.lastColumn || 'Created';
            this.title = this.makeObservable(options.title);
            this.addText = this.makeObservable(options.addText);
            this.tabName = options.tabName || 'Link Files';
            this.isSingleSelectionMode = options.isSingleSelectionMode || false;
            this.includeAttachments = options.includeAttachments || false;
            this.showReferences = options.showReferences || false;
            this.documentSelectedCallback = options.callback || (function () { });
            this.searchText.subscribe(function (value) {
                _this.filterVm.updateSearchText(value);
            });
            this.filterVm = new Matrix.SelectDocumentsFilterViewModel(this, options.selectDocumentsVm);
            this.filterFlyoutVm = new Matrix.SelectDocumentsFilterFlyoutViewModel(this.filterVm.data.typeId, this.filterVm.data.binderKey, this.filterVm.data.documentReviewStateIds, this.filterVm.documentTypes, this.filterVm.documentBinders, this.filterVm.documentReviewStateOptions, this.filterVm.customFilterProvider, this.filterVm.documentTypeLabel, this.filterVm.documentReviewStateLabel);
            this.searchRequiresPost = options.searchRequiresPost || false;
            this.sortHeaders = ko.pureComputed(function () {
                return {
                    currentSortState: _this.filterVm.getSortState(),
                    sort: function (sortByField, sortDesc) {
                        if (_this.disableSortAndFilter())
                            return false;
                        _this.filterVm.changeSort(sortByField, sortDesc);
                    }
                };
            });
            this.selectAllChecked = ko.computed(function () { return _this.allDocumentsSelected() && _this.documents().length > 0; });
            this.disableSortAndFilter.subscribe(function () {
                window.requestAnimationFrame(function () {
                    var sortState = _this.filterVm.getSortState();
                    Pb.SortHeaders.setHeaders($(document), {
                        sortByField: sortState.sortByField,
                        sortDesc: sortState.sortDesc
                    });
                });
            });
        }
        SelectDocumentsViewModel.open = function (options) {
            var vm = new Matrix.SelectDocumentsViewModel(options);
            var $editor = $('<div data-bind="template: { name: \'select-documents-ko-dialog\' }" data-dialog-width="90em"></div>');
            ko.applyBindings(vm, $editor[0]);
            Pb.Dialog.open({
                id: 'add-matter-document-dialog',
                content: $editor,
                confirmUnload: true
            });
            vm.search();
        };
        SelectDocumentsViewModel.prototype.deselectOtherDocuments = function (document) {
            var _this = this;
            this.documents()
                .filter(function (d) { return d.key() !== document.key; })
                .filter(function (d) { return d.selected(); })
                .forEach(function (d) {
                d.selected(false);
                d.includeAttachments(false);
                _this.toggleAttachments(d);
            });
            this.allDocuments()
                .filter(function (d) { return d.key !== document.key; })
                .filter(function (d) { return d.isSelected(); })
                .forEach(function (d) {
                d.isSelected(false);
                d.includeAttachments(false);
            });
        };
        SelectDocumentsViewModel.prototype.deselectSameDocuments = function (document) {
            var _this = this;
            this.documents()
                .filter(function (d) { return d.id() === document.id; })
                .filter(function (d) { return d.key() !== document.key; })
                .filter(function (d) { return d.selected(); })
                .forEach(function (d) {
                d.selected(false);
                d.includeAttachments(false);
                _this.toggleAttachments(d);
            });
            this.allDocuments()
                .filter(function (d) { return d.id == document.id; })
                .filter(function (d) { return d.key !== document.key; })
                .filter(function (d) { return d.isSelected(); })
                .forEach(function (d) {
                d.isSelected(false);
                d.includeAttachments(false);
            });
        };
        SelectDocumentsViewModel.prototype.includeAttachmentsVisibleForDocumentVm = function (documentVm) {
            return !this.isSingleSelectionMode && this.includeAttachments && documentVm.hasAttachments() && documentVm.selected() && !documentVm.includedAsAttachment();
        };
        SelectDocumentsViewModel.toDocumentIdString = function (selectedDocuments) {
            return selectedDocuments.map(function (d) { return d.id(); }).join();
        };
        SelectDocumentsViewModel.prototype.makeObservable = function (maybeObservable) {
            return ko.isObservable(maybeObservable) ? maybeObservable : ko.observable(maybeObservable);
        };
        return SelectDocumentsViewModel;
    }());
    Matrix.SelectDocumentsViewModel = SelectDocumentsViewModel;
})(Matrix || (Matrix = {}));
var Matrix;
(function (Matrix) {
    var SelectDocumentsFilterFlyoutViewModel = (function () {
        function SelectDocumentsFilterFlyoutViewModel(selectedDocumentTypeId, selectedDocumentBinderId, selectedDocumentReviewStateIds, documentTypeOptions, documentBinderOptions, documentReviewStateOptions, customFilterProvider, documentTypeLabel, documentReviewStateLabel) {
            var _this = this;
            this.clearFlyoutFilters = function () {
                _this.selectedDocumentTypeId(null);
                _this.selectedDocumentBinderKey(null);
                _this.selectedDocumentReviewStateIds([]);
                if (_this.customFilterProvider)
                    _this.customFilterProvider.clearFilters();
            };
            this.documentTypeOptions = documentTypeOptions;
            this.documentBinderOptions = documentBinderOptions;
            this.documentReviewStateOptions = documentReviewStateOptions;
            this.documentTypeLabel = documentTypeLabel;
            this.documentReviewStateLabel = documentReviewStateLabel;
            this.selectedDocumentTypeId = selectedDocumentTypeId;
            this.selectedDocumentBinderKey = selectedDocumentBinderId;
            this.selectedDocumentReviewStateIds = selectedDocumentReviewStateIds;
            this.customFilterProvider = customFilterProvider;
            this.customFilterProviderIsFilterActive = customFilterProvider ? this.customFilterProvider.isFilterActive : ko.observable(false);
            this.isFilterActive = ko.computed(function () { return !!_this.selectedDocumentTypeId() || !!_this.selectedDocumentBinderKey() || _this.selectedDocumentReviewStateIds().length > 0 || _this.customFilterProviderIsFilterActive(); });
            this.customFilterFlyoutTemplateName = ko.computed(function () { return _this.customFilterProvider ? _this.customFilterProvider.customFilterFlyoutTemplateName : null; });
            this.customFilterFlyoutViewModel = ko.computed(function () { return _this.customFilterProvider ? _this.customFilterProvider.customFilterFlyoutViewModel : null; });
            this.customFilterFlyoutRenderOnTop = ko.computed(function () { return _this.customFilterProvider ? _this.customFilterProvider.customFilterFlyoutRenderOnTop : false; });
        }
        return SelectDocumentsFilterFlyoutViewModel;
    }());
    Matrix.SelectDocumentsFilterFlyoutViewModel = SelectDocumentsFilterFlyoutViewModel;
    var SelectDocumentsFilterViewModel = (function () {
        function SelectDocumentsFilterViewModel(selectDocumentsVm, selectDocumentsData) {
            var _this = this;
            this.getSortState = ko.pureComputed(function () {
                return {
                    sortByField: _this.data.sortByField(),
                    sortDesc: _this.data.sortDesc()
                };
            });
            this.updateSearchText = function (searchText) {
                var textChanged = (searchText != _this.data.searchText());
                _this.data.searchText(searchText);
                if (textChanged)
                    _this.selectDocumentsVm.search(true);
            };
            this.changeSort = function (sortByField, sortDesc) {
                var sortChanged = (sortByField !== _this.data.sortByField() || sortDesc !== _this.data.sortDesc());
                _this.data.sortByField(sortByField);
                _this.data.sortDesc(sortDesc);
                if (sortChanged)
                    _this.selectDocumentsVm.search();
            };
            var maxPageButtons = 7;
            this.selectDocumentsVm = selectDocumentsVm;
            this.pager = new Pb.PagerViewModel(function () { _this.selectDocumentsVm.search(); }, maxPageButtons);
            this.documentTypes = ko.observableArray([]);
            this.documentBinders = ko.observableArray([]);
            this.documentReviewStateOptions = ko.observableArray([]);
            this.documentTypeLabel = ko.observable();
            this.documentReviewStateLabel = ko.observable();
            if (selectDocumentsData.customFilterProviderFactoryFunctionName)
                this.customFilterProvider = Pb.getObjectByName(selectDocumentsData.customFilterProviderFactoryFunctionName, window)();
            this.data = {
                searchText: ko.observable(selectDocumentsData.filter.searchText),
                sortByField: ko.observable(selectDocumentsData.filter.sortByField),
                sortDesc: ko.observable(selectDocumentsData.filter.sortDesc),
                page: ko.pureComputed(function () { return _this.pager.page(); }),
                documentReferences: ko.computed(function () {
                    var result = selectDocumentsVm.selectedDocuments()
                        .filter(function (d) { return !!d.references(); })
                        .reduce(function (result, d) {
                        result[d.id] = d.references();
                        return result;
                    }, {});
                    return result;
                }),
                typeId: ko.observable(),
                binderKey: ko.observable(),
                documentReviewStateIds: ko.observable([]),
                documentReviewStateIdList: null
            };
            var debouncedSearch = _.debounce(function () { return _this.selectDocumentsVm.search(true); }, 100);
            this.data.typeId.subscribe(function () {
                debouncedSearch();
            });
            this.data.binderKey.subscribe(function (binderKey) {
                if (binderKey) {
                    _this.data.sortByField('Order');
                    _this.data.sortDesc(false);
                }
                else {
                    _this.data.sortByField('LastModifiedOn');
                    _this.data.sortDesc(true);
                }
                debouncedSearch();
            });
            if (this.customFilterProvider) {
                this.customFilterProvider.onCustomFiltersChange(function (customFilterData) {
                    debouncedSearch();
                });
            }
            this.data.documentReviewStateIds.subscribe(function (newValue) {
                _this.data.documentReviewStateIdList = newValue == null || newValue.length == _this.documentReviewStateOptions().length
                    ? null
                    : newValue.map(function (x) { return !x ? ',' : x; }).join(',');
                debouncedSearch();
            }, this);
        }
        return SelectDocumentsFilterViewModel;
    }());
    Matrix.SelectDocumentsFilterViewModel = SelectDocumentsFilterViewModel;
})(Matrix || (Matrix = {}));
